export const de = {
    dashboard: 'Dashboard',
    items_selected: 'ausgewählt',
    menu: 'Menu',
    back: 'Zurück',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    create_and_view: 'Erstellen & ansehen',
    create_and_edit: 'Erstellen & bearbeiten',
    filters: 'Filter',
    clear: 'Zurücksetzen',
    update: 'Speichern',
    load_defaults: 'Standardwerte laden',
    close: 'Schließen',
    apply: 'Anwenden',
    proceed: 'Fortfahren',
    delete: 'Löschen',
    actions: 'Aktionen',
    cancel: 'Abbrechen',
    select: 'Auswählen',
    fill: 'Ausfüllen',
    description: 'Beschreibung',
    platform_name: 'Plattform Name',
    sub_platform_name: 'Sub Plattform Name',
    parent_platform_name: 'Übergeordnete Plattform',
    platform: 'Plattform',
    platforms: 'Plattformen',
    platform_uid: 'Plattform ID',
    create_platform: 'Plattform erstellen',
    url: 'URL',
    summary: 'Zusammenfassung',
    clearing_system: 'Investmentprodukt',
    clearing_systems: 'Investmentprodukte',
    clearing_system_ci: 'Crowdinvesting',
    clearing_system_cf: 'Crowdfunding',
    clearing_system_emission: 'Emission',
    clearing_system_stock_emission: 'Stock Emission',
    terms: 'Geschäftsbedingungen',
    privacy_policy: 'Datenschutzbestimmungen',
    platform_attachments: 'Plattformdokumente Vorvertragliche Informationen',
    platform_documents: 'Plattformdokumente',
    platform_document: 'Plattformdokument',
    linked_platform_documents: 'Verknüpfte Plattformdokumente',
    select_all: 'Alle auswählen',
    id: 'ID',
    name: 'Name',
    type: 'Typ',
    file: 'Datei',
    choose_file: 'Datei auswählen',
    choose_image: 'Bild auswählen',
    no_document_uploaded: 'Kein Dokument hochgeladen',
    reset: 'Zurücksetzen',
    information_letter: 'Informationsschreiben',
    platform_webhooks: 'Plattform Webhooks',
    platform_webhook: 'Platform Webhook',
    event: 'Event',
    secret: 'Secret',
    platform_policies: 'Plattform Access-Richtlinien ',
    platform_policy: 'Platform Access-Richtlinie',
    platform_cookie_consent_services: 'Cookie Consent Services',
    platform_cookie_consent_service: 'Cookie Consent Service',
    provider_key: 'Anbieter',
    enabled: 'Aktiviert',
    country: 'Land',
    countries: 'Länder',
    language: 'Sprache',
    content: 'Inhalt',
    platform_email_templates: 'Plattform E-Mail Vorlagen',
    subject: 'Betreff',
    placeholders: 'Platzhalter',
    insert: 'Einfügen:',
    platform_disclaimer: 'Plattform Risikowarnungen',
    platform_disclaimers: 'Plattform Risikowarnungen',
    countries_applied: 'Angewendet in',
    countries_not_applied: 'Nicht angewendet in',
    platform_details: 'Plattform Details',
    platform_logo: 'Logo',
    links: 'Links',
    privacy_url: 'Datenschutzerklärung',
    email_settings: 'E-Mail Einstellungen',
    admin_email: 'Admin E-Mail',
    mail_template: 'E-Mail Vorlage',
    order_status_for_total_funding_sum: 'Investitionssumme',
    pending: 'Ausstehend',
    paid: 'Bezahlt',
    paid_total_gross: 'Bezahlt - Brutto',
    paid_total_net: 'Bezahlt - Netto',
    total_tax: 'Steuer gesamt',
    church_tax: 'Kirchensteuer',
    soli: 'Soli',
    tax: 'Steuer',
    accepted: 'Akzeptiert',
    smtp_settings: 'SMTP Einstellungen',
    mail_host: 'SMTP Server',
    mail_port: 'SMTP Port',
    mail_encryption: 'Verschlüsselung',
    none: 'Keine',
    mail_from_address: 'Absender E-Mail',
    mail_form_name: 'Absender Name',
    mail_username: 'SMTP Username',
    mail_password: 'SMTP Passwort',
    assets: 'Vermögenswerte',
    asset: 'Vermögenswert',
    asset_name: 'Vermögenswert',
    currency: 'Währung',
    create_asset: 'Vermögenswert erstellen',
    asset_title: 'Titel',
    asset_details: 'Details zum Vermögenswert',
    asset_category: 'Anlagekategorie',
    asset_class: 'Anlageklasse',
    help_asset_class: 'Die Anlageklasse des Vermögenswerts.',
    asset_regulation: 'Regulierung',
    asset_jurisdiction: 'Rechtsraum',
    is_subordinated: 'Nachrangig',
    is_tied_agent: 'Gebundener Vermittler',
    return_calculator: 'Renditerechner',
    return_calculator_active: 'Renditerechner aktiv',
    transferable: 'Übertragbar',
    transfer_restriction: 'Übertragungsbeschränkung',
    pre_money_valuation: 'Pre-Money-Bewertung',
    equity_percentage: 'Eigenkapitalanteil (%)',
    dividend_preference_pct: 'Dividendenpräferenz (%)',
    cooperative_registry_number: 'Genossenschaftsregisternummer',
    cooperative_statute_url: 'Satzungs-URL',
    cooperative_notice_period: 'Kündigungsfrist',
    cooperative_additional_contribution: 'Nachschusspflicht',
    cooperative_mandatory_shares: 'Pflichtanteile',
    spv_legal_form: 'Rechtsform der SPV',
    spv_participation_quota_pct: 'Beteiligungsquote der SPV (%)',
    spv_participation_exemption: 'Beteiligungsfreistellung',
    spv_corporate_tax_rate: 'Körperschaftsteuersatz der SPV (%)',
    spv_lead_investor: 'Leitinvestor',
    asset_location: 'Standort des Vermögenswerts',
    asset_location_state: 'Bundesland',
    asset_location_country: 'Land',
    asset_funding_limits: 'Finanzierungs Limits',
    asset_funding_min: 'Finanzierungsschwelle',
    asset_funding_max: 'Finanzierungsmaximum',
    asset_investment_min: 'Minimales Investment',
    asset_investment_max: 'Maximales Investment',
    asset_step_level: 'Finanzierungsschritte',
    asset_quick_amounts: 'Schnellauswahl-Beträge',
    asset_base_funding_count: 'Basis Investitionen',
    asset_base_funding_total: 'Basis Investitionssumme',
    manual_funding_totals: 'Manuelle Investitionssummen',
    asset_manual_funding_totals: 'Manuelle Investitionssummen',
    automatic_payments: 'Automatische Zahlungsabwicklung',
    asset_deactivate_payment_account:
        'Deaktivieren der automatischen Zahlungsabwicklung',
    asset_documents: 'Dokumente des Vermögenswert',
    asset_documents_0: 'Vertragsdaten',
    asset_documents_1: 'Reporting',
    asset_documents_2: 'Verbraucherinformation',
    asset_price_per_stock: 'Preis pro Aktie',
    asset_minimum_investment: 'Mindestinvestition',
    asset_minimum_shares: 'Mindestanzahl an Aktien',
    asset_stock_increments: 'Aktienstückelung',
    asset_number_of_stocks: 'Anzahl der Aktien',
    asset_maximum_total_investment_value: 'Maximaler Gesamtanlagewert',
    asset_stock_type: 'Aktienart',
    asset_isin: 'ISIN',
    asset_nominal_value: 'Nominalwert',
    asset_agio: 'Agio',
    asset_types: 'Vermögensarten',
    help_asset_price_per_stock:
        'Preis pro Aktie. Wird auf der Kampagnenkarte bei Aktie und Genossenschaftsanteil als erste Box angezeigt.',
    help_asset_minimum_investment:
        'Mindestanlagewert. Dieser sollte eine exakte Vielfache des Aktienkurses sein.',
    help_asset_minimum_shares: 'Mindestanlagewert in Aktien.',
    help_asset_stock_increments: 'Aktienstückelung',
    help_asset_number_of_stocks: 'Anzahl der Aktien',
    help_asset_maximum_total_investment_value: 'Maximaler Gesamtanlagewert',
    help_asset_stock_type: 'Aktienart',
    help_asset_isin: 'ISIN',
    company_details: 'Firmen Daten',
    company_name: 'Firmen Name',
    company_logo: 'Logo',
    address: 'Adresse',
    city: 'Stadt',
    postal_code: 'Postleitzahl',
    state: 'Bundesland/Kanton',
    phone_number: 'Telefonnummer',
    email: 'E-Mail',
    company_website: 'Firmen Webseite',
    iban: 'IBAN',
    bic: 'BIC',
    contract: 'Vertrag',
    contracts: 'Verträge',
    contract_details: 'Vertragsdaten',
    contract_range: 'Vertragslaufzeit',
    contract_editor: 'Vertragseditor',
    interest_rate: 'Zinssatz',
    target_yield: 'Zielrendite',
    signatures: 'Zeichnungen',
    signature_documents: 'Zeichnungsdokumente',
    add_signature_document: 'Zeichnungsdokument hinzufügen',
    signature_type: 'Zeichnungsart',
    signature_types: 'Zeichnungsarten',
    signature_type_manual: 'Manual',
    signature_manual_confirmation_required:
        'Bestätigung vor Annahme erforderlich',
    signature_type_sproof: 'Sproof',
    signature_type_signteq: 'Signteq',
    asset_signature_legal_notice: 'Zeichnungshinweis',
    contract_type: 'Vertragsart',
    contract_type_cash: 'Geld',
    contract_type_voucher: 'Gutschein',
    contract_payment_start_date: 'Erste Auszahlung',
    contract_next_payment_date: 'Nächste Auszahlung',
    payment_date: 'Payment Date',
    contract_period_type_fixed: 'Fixer Vertrag',
    asset_document_type_0: 'Vertragsdaten',
    asset_document_type_1: 'Reporting',
    asset_document_type_2: 'Verbraucherinformation',
    asset_signature_document: 'Emission Zeichnungsschein',
    asset_signature_document_name: 'Emission Zeichnungsschein Name',
    help_asset_signature_document_name: 'Der Emission Zeichnungsschein Name',
    platform_signteq_signature_organization_id: 'Organisations ID',
    help_platform_signteq_signature_organization_id:
        'Organisations ID mit der Signteq-Signatur gesendet wird',
    asset_signature_signteq_subject: 'Signatur-Betreff',
    help_asset_signature_signteq_subject:
        'Betreff der Signteq-Signatur. Wenn leer, wird der Kampagnentitel verwendet.',
    asset_signature_document_description:
        'Emission Zeichnungsschein Beschreibung',
    help_asset_signature_document_description:
        'Die Emission Zeichnungsschein Beschreibung',
    modal_title_delete_signature_documents: 'Emission Zeichnungsschein löschen',
    modal_title_create_contract_template: 'Vertragsdokument erstellen',
    modal_title_edit_contract_template: 'Vertragsdokument bearbeiten',
    signature_document_deleted: 'Zeichnungsdokument gelöscht',
    signature_document_uploaded: 'Zeichnungsdokument hochgeladen',
    transfer: 'Überweisen',
    run_exclusive_acceptance: 'Exklusive Annahme durchführen',
    start_process: 'Prozess starten',
    no_payment_account_found: 'Kein Zahlungskonto gefunden.',
    wallet: 'Wallet',
    amount: 'Betrag',
    date: 'Datum',
    associate_orders: 'Bestellungen verknüpfen',
    campaign: 'Kampagne',
    campaigns: 'Kampagnen',
    order: 'Bestellung',
    orders: 'Bestellungen',
    open_baskets: 'offene Bestellungen',
    basket_stage: 'aktueller Schritt',
    view_campaigns: 'Anzeigen',
    status: 'Status',
    sub_status: 'Substatus',
    created_on: 'Erstellt am',
    campaign_title: 'Titel der Kampagne',
    campaign_subtitle: 'Untertitel der Kampagne',
    create_campaign: 'Neue Kampagne anlegen',
    campaign_details: 'Kampagnendetails',
    campaign_summary: 'Zusammenfassung',
    campaign_excerpt: 'Auszug',
    funding_period: 'Finanzierungszeitraum',
    funding_start: 'Finanzierungsbeginn',
    funding_end: 'Finanzierungsende',
    waitlist_url: 'Wartelisten-URL',
    waitlist_text: 'Wartelisten-Text',
    regulatory_requirements: 'Regulatorische Anforderungen',
    asset_regulation_override: 'Regulierungs-Override',
    is_co_placement: 'Co-Platzierung',
    agio_disagio: 'Agio/Disagio',
    agio_disagio_title: 'Agio/Disagio Titel',
    agio_disagio_rate: 'Agio/Disagio Rate',
    agio_disagio_type: 'Agio/Disagio Typ',
    agio_disagio_info_text: 'Agio/Disagio Infotext',
    agio_disagio_disclaimer: 'Agio/Disagio Bedingungen',
    agio_disagio_voucher: 'Agio/Disagio Gutschein',
    display_price_without_agio: 'Preis ohne Agio/Disagio anzeigen',
    help_display_price_without_agio:
        'Wenn aktiviert, wird der Preis ohne Agio/Disagio angezeigt.',
    savings_plan: 'Ansparplan',
    savings_plan_description: 'Ansparplan Beschreibung',
    nyala_investment_id: 'Nyala Investitions ID',
    sync_nyala_investment: 'Nyala Investition synchronisieren',
    create_nyala_investment: 'Nyala Investition erstellen',
    voucher_code: 'Gutschein Code',
    voucher_rate: 'Gutschein Rate',
    country_and_language: 'Land und Sprache',
    campaign_status: 'Status',
    funding_stats_visible: 'Finanzierungsstatus anzeigen',
    password: 'Passwort',
    broker: 'Broker',
    broker_status: 'Broker Status',
    required_field: 'Pflichtfeld',
    purpose: 'Zweck',
    broker_disclaimer: 'Broker Bedingung',
    external_project_page: 'Externe Projektseite',
    external_project_url: 'Externe Projekt URL',
    badge: 'Plakette',
    campaign_badge: 'Plakette wählen',
    checkout: 'Zahlungsabwicklung',
    show_amount_slider: 'Betragsregler anzeigen',
    media: 'Medien',
    campaign_thumb_image: 'Thumbnail',
    campaign_hero_image: 'Hauptbild',
    campaign_content: 'Inhalt',
    main: 'Main',
    user_orders_list: 'Liste der Bestellungen',
    export_asset_investment_report: 'Investment Report exportieren',
    export_signature_documents: 'Zeichnungsdokumente exportieren',
    upload_asset_investment_report: 'Investment Report hochladen',
    export_check_orders_report: 'Bestellungskontroll-Report exportieren',
    send_ad_hoc_email_reminder: 'Ad-hoc E-Mail Erinnerung senden',
    transfer_tokens: 'Token verteilen',
    push_to_zoho: 'An Zoho übertragen',
    run_inclusive_acceptance: 'Inklusive Annahme durchführen',
    content_images: 'Bilder',
    content_documents: 'Dokumente',
    loading: 'Laden ...',
    content_blocks: 'Bausteine',
    rank: 'Rang',
    title: 'Title',
    team_member: 'Teammitglied',
    team_members: 'Teammitglieder',
    job_title: 'Job Bezeichnung',
    incentives: 'Anreize',
    funding: 'Finanzierung',
    campaign_content_block_title: 'Name',
    campaign_content_block_content: 'Inhalt',
    campaign_incentive_amount: 'Anreiz Betrag',
    campaign_incentive_description: 'Anreiz Belohnung',
    campaign_incentive_title: 'Anreiz Titel',
    campaign_incentives_limit: 'Anreiz Limit',
    campaign_team_member_name: 'Name',
    campaign_team_member_title: 'Titel',
    campaign_team_member_bio: 'Beschreibung',
    campaign_team_member_image: 'Bild',
    account_title: 'Investor Name',
    wallet_status_title: 'Wallet Status',
    withdrawals: 'Abhebungen',
    withdrawal_amount: 'Summe',
    wallet_money_withdrawals: 'Abhebungen von Wallet',
    wallet_status_sc: 'SC Wallet',
    wallet_status_not_opened: 'Nicht eröffnet',
    wallet_status_incomplete: 'Unvollständig',
    wallet_status_rejected: 'Abgelehnt',
    wallet_status_kyc1: 'KYC 1',
    wallet_status_kyc2: 'KYC 2',
    wallet_status_kyc3: 'KYC 3',
    wallet_status_expired: 'Abgelaufen',
    wallet_status_blocked: 'Blockiert',
    wallet_status_closed: 'Geschlossen',
    wallet_status_kyc_updating_2_3: 'Updating von KYC 2 zu 3',
    wallet_status_ont_time_customer: 'Einmaliger Kunde',
    wallet_status_crowdlending: 'Crowdlending Wallet',
    wallet_status_technique: 'Technique Wallet',
    wallet_status_undefined: 'Konto hat keine Wallet',
    wallet_withdrawal_started_from_frontend: 'Im Frontend gestartet',
    wallet_transactions: 'Wallet Transaktionen',
    no_wallet_transactions: 'keine Wallet Transaktionen',
    transaction_sender: 'Absender',
    transaction_receiver: 'Empfänger',
    transaction_type: 'Transaktionstyp',
    transactions: 'Transaktionen',
    account: 'Investor',
    accounts: 'Investoren',
    transfer_to: 'Übertragung an',
    amount_of_shares: 'Anzahl der Anteile',
    further_transmissions: 'Weitere Übertragungen',
    natural_profile_active: 'Aktiv',
    account_first_name: 'Vorname',
    account_last_name: 'Nachname',
    account_email: 'E-Mail',
    account_date_of_birth: 'Geburtsdatum',
    account_nationality: 'Nationalität',
    account_default_language: 'Standardsprache',
    account_country_of_birth: 'Geburtsland',
    account_city_of_birth: 'Geburtsstadt',
    account_email_pending: 'E-Mail ausstehend',
    linked_natural_profiles: 'Natürliche Personen',
    natural_profiles: 'Natürliche Personen',
    male: 'männlich',
    female: 'weiblich',
    account_gender: 'Geschlecht',
    account_custom_id: 'Individuelle ID',
    account_pep: 'Politisch exponierte Person (PEP)',
    account_is_pep: 'Ja',
    account_is_not_pep: 'Nein',
    account_nl_subscribed: 'Newsletter zugestimmt bei Registrierung',
    account_nl_is_subscribed: 'Ja',
    account_nl_is_not_subscribed: 'Nein',
    account_address: 'Adresse',
    account_address_required_for_wallet: 'Adresse (Verpflichtend für Wallet)',
    account_zip: 'PLZ',
    account_zip_required_for_wallet: 'PLZ (Verpflichtend für Wallet)',
    account_country: 'Land',
    account_country_required_for_wallet: 'Land (Verpflichtend für Wallet)',
    account_city: 'Stadt',
    account_city_required_for_wallet: 'Stadt (Verpflichtend für Wallet)',
    account_state: 'Bundesland',
    account_state_required_for_wallet: 'Bundesland (Verpflichtend für Wallet)',
    account_phone: 'Telefon',
    account_mobile: 'Mobiltelefon',
    account_primary_email: 'E-Mail',
    account_pending_email: 'Unbestätigte E-Mail Adresse',
    account_address_kyc_status: 'Adressangaben - KYC-Status',
    account_address_kyc_document: 'KYC Dokumente - Adresse',
    wallet_not_yet_created: 'Keine Wallet vorhanden',
    account_kyc_not_verified: 'KYC noch nicht bestätigt',
    kyc_bank_documents: 'KYC Dokumente - Bankkonto',
    kyc_tax_documents: 'KYC Dokumente - Steuerdaten',
    social_security_number: 'Nationale Steuernummer',
    account_kyc_status: 'Identitätsangaben - KYC-Status',
    account_iban: 'IBAN',
    account_bic: 'BIC',
    account_bank_accounts: 'Bankkonten',
    account_bank_account: 'Bankkonto',
    account_bank_account_headline: 'Liste der Bankkonten',
    bank_accounts_list: 'Liste der Bankkonten',
    no_bank_accounts: 'es gibt keine Bankkonten',
    is_main_bank_account: 'Hauptkonto',
    account_bank_historical_data: 'historische Daten (ohne Lemonway)',
    account_owner: 'Inhaber',
    account_holder: 'Bankkontoinhaber',
    account_type: 'Typ',
    account_status: 'Status',
    created_at: 'Erstellt',
    cancelled_at: 'Abgebrochen',
    account_bank_kyc_status: 'Bankkonto KYC-Status',
    account_profile_overview: 'Profilübersicht',
    account_profile_details: 'Profildetails',
    account_address_contact_details: 'Adresse und Kontaktdaten',
    account_address_details: 'Addresse',
    account_identity_details: 'Identitätsdetails',
    button_delete_dsgvo: 'DSGVO Daten löschen',
    create_natural_account: 'natürliche Person erstellen',
    profile_company_name: 'Firmenname',
    profile_company_company_email: 'Firmen E-Mail',
    profile_company_description: 'Unternehmensgegenstand',
    profile_company_required_for_wallet: 'Benötigt für Wallet',
    profile_company_registration_number: 'Unternehmenregistrationsnummer',
    profile_company_website_url: 'Webseite',
    profile_company_details_kyc: 'Prüfung der Unternehmensdaten  (KYC)',
    profile_company_bank_kyc: 'Prüfung der Bankverbindung (KYC)',
    legal_account_create: 'Geschäftskonto anlegen',
    download_signteq_idv_document: 'Signteq IDV Dokument herunterladen',
    legal_account_show: 'Geschäftskonto anzeigen',
    contact_person: 'Kontaktperson',
    address_details: 'Adressdetails',
    bank_details: 'Bank Details',
    tax_details: 'Steuer Details',
    depot_data: 'Depotdaten',
    wallet_details: 'Wallet Details',
    kyc_documents: 'KYC Dokumente',
    kyc_id_documents: 'KYC Dokumente zur Prüfung der Identität',
    kyc_legal_documents: 'KYC Dokumente zur Prüfung der Unternehmensdaten',
    kyc_document_no_comment: 'Kein Dokument vorhanden',
    open_kyc_document: 'öffnen',
    kyc: 'KYC',
    kyc_external: 'Externes KYC',
    external_kyc_details: 'Externes KYC Details',
    external_kyc_process_status: 'Status externer KYC',
    kyc_external_id: 'ID',
    kyc_external_external_id: 'Externe KYC-ID',
    kyc_external_status: 'KYC Status',
    kyc_external_created_at: 'Erstellt am',
    kyc_external_updated_at: 'Zuletzt geändert am',
    kyc_external_natural_profile_overwritten_at:
        'Investorenkonto überschrieben am',
    kyc_external_result_summary_url: 'Zusammenfassung herunterladen',
    kyc_external_result_data_package_url: 'Datenpaket herunterladen',
    button_kyc_reset_external_process: 'Externe KYC zurücksetzen',
    comment: 'Kommentar',
    document_id: 'Dokument ID',
    verification_type: 'Verifikationsart',
    verification_status: 'Verifikationsstatus',
    account_id: 'Acocunt ID',
    valid_to: 'Gültig bis',
    kyc_verification_status: 'Verifizierungsstatus',
    verification_date: 'Verifizierungsdatum',
    external_kyc: 'externes KYC',
    manual_kyc: 'manuelles KYC',
    open_doc_in_new_tab: 'Dokument in neuem Tab öffnen',
    kyc_document_file: 'KYC Dokument - File',
    kyc_type_kyc_id: 'Prüfung der Identität',
    kyc_type_kyc_bank: 'Prüfung der Bankverbindung1',
    kyc_type_kyc_address: 'Prüfung der Adressangaben',
    kyc_type_kyc_tax: 'Prüfung der Steuerdetails',
    kyc_address_documents: 'KYC Dokumente - Adresse',
    tax_number: 'Steuernummer',
    account_social_security_number: 'Sozialversicherungsnummer',
    account_tax_kyc_status: 'Steuerdetails - KYC-Status',
    account_show_legal_account: 'Zeige juristische Person',
    profile: 'Profil',
    view_profile: 'Profil ansehen',
    wallet_balance: 'Saldo',
    wallet_retrievable_balance: 'verfügbarer Saldo',
    wallet_blocked_balance_from_paid_orders: 'blockiert (bezahlte Order)',
    wallet_blocked_balance_from_pending_withdrawals:
        'blockiert (ausstehende Auszahlungen)',
    wallet_status: 'Wallet Status',
    wallet_currency: 'Währung',
    wallet_deposit_information: 'Einzahlungsinformationen',
    wallet_deposit_account_holder: 'Kontoinhaber',
    wallet_deposit_iban: 'IBAN',
    wallet_deposit_bic: 'BIC',
    wallet_deposit_payment_reference: 'Zahlungsreferenz',
    money_withdrawal_value: 'Summe der Abhebung',
    yes: 'ja',
    no: 'nein',
    search_account_title: 'Investor suchen',
    nothing_found: 'Nichts gefunden',
    search_other_user: 'Anderen Investor suchen',
    order_send_mails: 'Investitionsmails senden',
    date_of_order: 'Investitionsdatum',
    order_attachment_type: 'Order attachment type',
    order_attachment_name: ' Order attachment name',
    order_attachment_description: 'Order attachment description',
    edit_order: 'Bestellung bearbeiten',
    additional_fields: 'Zusätzliche Felder',
    order_attachments: 'Anhänge',
    order_attachment_upload: 'Anhang hochladen',
    order_documents: 'Bestellungs Dokumente',
    reporting_documents: 'Reporting Dokumente',
    documents: 'Dokumente',
    view_document: 'Dokument anzeigen',
    depot: 'Depot',
    depot_owner: 'Depotinhaber',
    depot_number: 'Depotnummer',
    depot_bank: 'Name der Bank',
    deposit_account_holder: 'Einzahlungskontoinhaber',
    depot_bic: 'BIC oder BLZ',
    order_details: 'Bestelldetails',
    order_notes: 'Notiz',
    order_id: 'ID',
    order_emission_signature: 'Zeichnung',
    order_emission_signatures: 'Zeichnungen',
    document_type: 'Dokumentenart',
    signature_date: 'Signature date',
    signature_cancellation_date: 'Abbruchdatum der Zeichnung',
    confirm_manual_signature: 'Bestätigen der Manuellen Zeichnung',
    regenerate_signatures: 'Zeichnungen regenerieren',
    upload_signed_document: 'Signiertes Dokument hochladen',
    modal_title_upload_signed_document: 'Signiertes Dokument hochladen',
    signed_document: 'Signiertes Dokument',
    toast_success_signed_document_uploaded: 'Signiertes Dokument hochgeladen',
    toast_success_signature_confirmed: 'Zeichnung bestätigt',
    signature_pending_review: 'Warten auf Prüfung',
    account_name: 'Investor Name',
    change_order_status: 'Bestellstatus ändern',
    bulk_change_order_status: 'Bestellstatus mehrerer Bestellungen ändern',
    total: 'Total',
    invested_amount: 'Investierter Betrag',
    wallet_amount: 'Wallet-Betrag',
    total_amount_to_pay: 'zu bezahlender Betrag',
    incentive: 'Anreiz',
    voucher_amount: 'Voucher-Betrag',
    voucher_balance: 'Voucher-Saldo',
    vouchers: 'Gutscheine',
    reference_number: 'Referenz',
    investor_information_for_germany: 'Kundeninformationen für Deutschland',
    please_confirm_data: 'Bestätigung',
    first_name: 'Vorname',
    last_name: 'Nachname',
    place_of_birth: 'Geburtsort',
    id_card_passport_number: 'Personalausweisnummer oder Reisepass',
    issuing_authority: 'Ausstellende Behörde',
    vib_investment_information:
        'Hiermit bestätige ich, dass ich das Vermögensanlagen-Informationsblatt rechtzeitig zur Verfügung gestellt bekommen sowie heruntergeladen und gespeichert habe. Insbesondere habe ich den Warnhinweis, dass der Erwerb dieser Vermögensanlage mit erheblichen Risiken verbunden ist und bis zum vollständigen Verlust des eingesetzten Vermögens führen kann, zur Kenntnis genommen.',
    vib_investment_under_1000:
        'Hiermit bestätige ich, dass der Gesamtbetrag der von mir erworbenen Vermögensanlagen der „synthesize B2C markets (EM)“ (inklusive meines im Rahmen dieses Investmentangebots gewährten Darlehensbetrages) 1000 Euro nicht übersteigt',
    vib_investment_income:
        'Hiermit bestätige ich, dass der Gesamtbetrag der von mir erworbenen Vermögensanlagen der synthesize B2C markets (EM) (inklusive meines im Rahmen dieses Investmentangebots gewährten Darlehensbetrages) zwischen 10 000 und 25 000 Euro liegt, jedoch den zweifachen Betrag meines durchschnittlichen monatlichen Nettoeinkommens nicht übersteigt.',
    vib_investment_financial_assets_over_10000:
        'Hiermit bestätige ich, dass der Gesamtbetrag der von mir erworbenen Vermögensanlagen der „synthesize B2C markets (EM)“ (inklusive meines im Rahmen dieses Investmentangebots gewährten Darlehensbetrages) zwischen 1 000 und 10 000 Euro liegt und ich über ein frei verfügbares Vermögen in Form von Bankguthaben und Finanzinstrumenten von mindestens 100 000 Euro verfüge.',
    vib_investment_limit:
        'Hiermit bestätige ich, dass ich insgesamt nicht mehr als 25.000 € an Vermögensanlagen des Emittenten „synthesize B2C markets (EM)“ erworben habe (inklusive meines im Rahmen dieses Investmentangebots gewählten Darlehensbetrags).',
    wphg_investment_under_1000:
        'Hiermit bestätige ich, dass meine Investition 1.000 € nicht übersteigt.',
    wphg_investment_limit:
        ' Hiermit bestätige ich, dass ich insgesamt nicht mehr als 25.000 € in Wertpapiere des Emittenten synthesize B2C markets (EM) investiert habe (inklusive meines im Rahmen dieses Angebots gewählten Investments).',
    wphg_inappropriate_investment:
        'Ich bin darüber informiert, dass die Zeichnung dieses Produkts nicht meinem Anlageprofil aufgrund der von mir gemachten Angaben entspricht. Ich entscheide mich dennoch für die Zeichnung dieses Produkts.',
    order_was_created_manually: 'Wurde manuell erstellt',
    profile_information_legal: 'Investor (Unternehmensprofil)',
    profile_legal: 'Unternehmensprofil',
    profile_information_natural: 'Investor (natürliche Person)',
    linked_profile_information_natural: 'Verknüpfte natürliche Person',
    date_of_birth: 'Geburtsdatum',
    nationality: 'Nationalität',
    change_status_to: 'Status ändern zu',
    for_selected_orders: 'für die Bestellungen {selected}',
    account_name_at_order: 'Investor Name bei Bestellung',
    account_name_current: 'Aktueller Investor Name',
    set_to_canceled: 'Bestellung abbrechen',
    set_to_paid: 'Auf bezahlt setzen',
    set_to_pending: 'Auf ausstehend setzen',
    set_to_accepted: 'Auf akzeptiert setzen',
    investment: 'Investment',
    bullet: 'Bullet',
    period: 'Zeitraum',
    next_payment: 'Nächste Auszahlung',
    interest: 'Zinsen',
    gross_interest: 'Brutto Zinsen',
    payouts: 'Auszahlungen',
    contract_duration: 'Vertragslaufzeit',
    first_payout: 'Erste Auszahlung',
    last_payout: 'Letzte Auszahlung',
    total_payments_count: 'Anzahl der Auszahlungen',
    start_of_contract: 'Start der Laufzeit',
    add_date: 'Auszahlungsdatum hinzufügen',
    early_bird_promotion: 'Early Bird Promotion',
    early_bird_interest_rate: 'Early Bird Zinssatz',
    early_bird_deadline: 'Early Bird Deadline',
    interest_rate_calculation: 'Zinssatzberechnung',
    calculation_method: 'Methode zur Berechnung',
    calculation_start_date: 'Berechnungsbeginn',
    repayment: 'Zurückzahlung',
    bullet_loan: 'Bullet Loan',
    deferred_clearance: 'Tilgung aufschieben',

    // Contract class details (asset_class-driven contract fields)
    contract_class_details: 'Klassenspezifische Details',
    conversion_trigger_type: 'Wandlungsauslöser',
    conversion_price_formula: 'Wandlungspreisformel',
    conversion_price_reference_days: 'Referenztage für Wandlungspreis',
    conversion_price_floor: 'Wandlungspreis-Untergrenze',
    conversion_price_discount_pct: 'Wandlungspreis-Abschlag (%)',
    conversion_price_final: 'Finaler Wandlungspreis',
    conversion_date_annual: 'Jährliches Wandlungsdatum',
    conversion_window_open_days: 'Offene Tage im Wandlungsfenster',
    conversion_conditions: 'Wandlungsbedingungen',
    conversion_valuation: 'Wandlungsbewertung',
    disagio_pct: 'Disagio (%)',
    early_repayment_price_threshold_pct:
        'Preisschwelle für vorzeitige Rückzahlung (%)',
    early_repayment_observation_days:
        'Beobachtungstage für vorzeitige Rückzahlung',
    collateral_description: 'Besicherungsbeschreibung',
    gs_participation_rate_max: 'Max. Genussschein-Beteiligungsquote',
    share_capital_base: 'Stammkapitalbasis',
    min_interest_rate_pa: 'Mindestzinssatz p.a.',
    ebit_multiple: 'EBIT-Multiplikator',
    revenue_multiple: 'Umsatz-Multiplikator',
    settlement_costs_pct: 'Abwicklungskosten (%)',
    participation_share_per_gs: 'Beteiligungsanteil je Genussschein',
    cancellation_possible_from: 'Kündigung möglich ab',
    termination_notice_months: 'Kündigungsfrist (Monate)',
    termination_reference_date: 'Kündigungsstichtag',
    repayment_type: 'Tilgungsart',
    repayment_schedule: 'Tilgungsplan',
    help_repayment_schedule:
        'Nur relevant bei unregelmäßiger Tilgungsart. Die Beträge müssen sich zu genau 100% aufsummieren.',
    help_repayment_schedule_empty: 'Noch keine Tilgungsplan-Einträge.',
    repayment_schedule_total: 'Summe: {total}%',
    amount_pct: 'Betrag (%)',
    accrued_interest_applicable: 'Aufgelaufene Zinsen anwendbar',
    default_interest_rate: 'Verzugszinssatz',
    early_repayment_min_yield_pct:
        'Mindestrendite bei vorzeitiger Rückzahlung (%)',
    in_kind_interest_rate: 'Sachzinssatz',

    // ConversionTriggerType
    IPO: 'IPO',
    ANNUAL: 'Jährlich',
    PRICE_THRESHOLD: 'Preisschwelle',
    MATURITY: 'Fälligkeit',

    // ConversionPriceFormula
    VWAP: 'VWAP',
    // FIXED: 'Fixed', (bereits oben unter ContractPeriodType definiert, gleicher Wert)
    IPO_PRICE: 'IPO-Preis',

    // RepaymentType
    BULLET: 'Bullet',
    REGULAR: 'Regelmäßig',
    IRREGULAR: 'Unregelmäßig',
    tax_calculation: 'Steuerberechnung',
    tax_calculation_enabled: 'Steuerberechnung aktiviert',
    external_wallet: 'External Wallet',
    external_wallet_id: 'External Wallet ID',
    wallet_id: 'Wallet ID',
    voucherify_settings: 'Voucherify Einstellungen',
    voucher_wallet: 'Gutschein Wallet',
    voucher_campaign: 'Gutschein Kampagne',
    voucher_campaigns: 'Gutschein Kampagnen',
    voucher_campaign_name: 'Kampagnen Name',
    add_voucher_campaign: 'Kampagne hinzufügen',
    voucher_campaign_type: 'Campaign Typ',
    voucher_campaign_default: 'Standard',
    voucher_contract: 'Gutschein Vertrag',
    interest_payments: 'Zinszahlungen',
    paid_interest: 'Ausgezahlte Zinsen',
    paid_clearance: 'Tilgung',
    payment: 'Auszahlung',
    total_amount: 'Gesamtsumme',
    sum_paid_clearance: 'Tilgung',
    sum_paid_interest_net: 'Netto ausgezahlte Zinsen',
    bonus: 'Bonus',
    download_sepa_csv: 'SEPA CSV herunterladen',
    start_payment: 'Auszahlung starten',
    paid_at: 'Bezahlt am',
    accepted_at: 'Akzeptiert am',
    interest_payment_transactions: 'Zinszahlungen',
    loan: 'Darlehn',
    clearance: 'Tilgung',
    rest: 'Rest',
    execute_interest_payment: 'Zinszahlung ausführen',
    execute_interest_payment_including_sepa_export:
        'Zinszahlung ausführen und SEPA-CSV exportieren',
    recalculate: 'Neuberechnen',
    recalculate_and_export_excel: 'Neuberechnen und Excel exportieren',
    recalculate_and_export_sepa_csv: 'Neuberechnen und SEPA-CSV exportieren',
    please_recalculate_interest_first: 'Bitte berechnen Sie zuerst die Zinsen.',
    sum_paid_rest: 'Summe ausgezahlter Zinsen',
    pay_interest: 'Zinsen auszahlen',
    pay_clearance: 'Tilgung auszahlen',
    pay_percent_of_rest: 'Prozentanteil des Restbetrags auszahlen',
    interest_bonus: 'Bonuszinsen',
    new_calculation: 'Neue Berechnung',
    load_payout_tasks: 'Auszahlungen laden',
    start_interest_payment_payout: 'Neuen Auszahlungs-PayoutTask starten',
    started_at: 'Gestartet am',
    finished_at: 'Abgeschlossen am',
    finished_type: 'Ergebnis Typ',
    result: 'Ergebnis',
    result_details: 'Ergebnis Details',
    interest_payment_date: 'Auszahlungsdatum',
    settings: 'Einstellungen',
    sign_out: 'Abmelden',
    export_accounts_csv: 'Gefilterte Investoren-Liste exportieren',
    export_kyc_folder: 'KYC-Ordner exportieren (ECSP)',
    view: 'Ansehen',
    no_table_entries: 'Keine Einträge vorhanden.',
    check_table_filters: 'Filter anpassen.',
    export_orders_csv: 'Gefilterte Liste exportieren',
    bulk_change_order_campaign: 'Kampagne ändern',
    natural_account: 'Natürliche Person',
    legal_account: 'Juristische Person',
    active: 'Aktiv',
    no_orders: 'Keine Bestellungen vorhanden.',
    manual_investments: 'Manuelle Investmentsumme',
    duplicate: 'Duplizieren',
    change_status: 'Status ändern',
    change_order_status_date: 'Status-Datum ändern',
    emails: 'E-Mails',
    email_template: 'E-Mail Vorlage',
    recipient: 'Empfänger',
    is_test: 'Test',
    send: 'Senden',

    button_bank_kyc_document_upload: 'Bank-Nachweishochladen',
    button_address_kyc_document_upload: 'Adress-Nachweis hochladen',
    button_tax_kyc_document_upload: 'Steuerdaten-Nachweis hochladen',
    button_id_kyc_document_upload: 'ID-Nachweis hochladen',
    button_legal_kyc_document_upload: 'Unternehmensdaten-Dokument hochladen',
    button_sync_wallet: 'Wallet synchronisieren',
    button_delete_legal: 'Account löschen',
    sender: 'Absender',
    receiver: 'Empfänger',
    transaction_method: 'Transaktionsart',
    date_from: 'Datum von',
    date_to: 'Datum bis',
    view_linked_order: 'Zugehörige Bestellung anzeigen',
    view_sender_natural_profile: 'Natürliche Person (Absender) anzeigen',
    view_receiver_natural_profile: 'Natürliche Person (Empfänger) anzeigen',
    view_sender_legal_profile: 'Unternehmensprofil (Absender) anzeigen',
    view_receiver_legal_profile: 'Unternehmensprofil (Empfänger) anzeigen',
    no_signatures: 'Keine Zeichnungen',
    billing_address: 'Rechnungsadresse',
    postal_address: 'Zustelladresse',
    contact_details: 'Kontaktdetails',
    same_as_billing_address: 'Gleich wie Rechnungsadresse',

    help_platform_name: 'Der Name der Plattform.',
    help_parent_platform_name: 'Die übergeordnete Plattform.',
    help_platform_url: 'Die URL unter der die Plattform erreichbar ist.',
    help_file_name: 'Der Name der Datei.',
    help_file_type: 'Der Typ der Datei.',
    help_platform_webhook_event: 'Das Event, welches den Webhook auslöst.',
    help_platform_webhook_url:
        'Die URL, die aufgerufen wird wenn das Event den Webhook auslöst.',
    help_platform_webhook_secret:
        'Der Sicherheitsschlüssel mit dem der Webhook abgesichert ist. Der Sicherheitsschlüssel ist nur während der Erstellung einsehbar.',
    help_platform_policy_name: 'Der Name der Plattform Access-Richtlinie.',
    help_platform_policy_country:
        'Das Land in dem die Plattform Access-Richtlinie gültig ist.',
    help_platform_policy_language:
        'Die Sprache in der die Plattform Access-Richtlinie verfasst wurde.',
    help_platform_policy_content: 'Der Inhalt der Plattform Access-Richtlinie.',
    help_cookie_consent_service_category:
        'Die Consent-Kategorie, zu der dieser Dienst gehört.',
    help_cookie_consent_service_provider_key:
        'Der Anbieter, den dieser Dienst repräsentiert.',
    help_cookie_consent_service_name:
        'Der Name des Dienstes, der Besuchern im Cookie-Banner angezeigt wird.',
    help_cookie_consent_service_description:
        'Die Beschreibung des Dienstes, die Besuchern im Cookie-Banner angezeigt wird.',
    help_cookie_consent_service_enabled:
        'Ob dieser Dienst aktiv und im Cookie-Banner sichtbar ist.',
    help_platform_email_template_type: 'Der Typ der Plattform E-Mail Vorlage.',
    help_platform_email_template_language:
        'Die Sprache in der die E-Mail Vorlage verfasst wurde.',
    help_platform_email_template_number_locale:
        'Zahlenformat für diese E-Mail Vorlage überschreiben. Leer lassen, um das Format automatisch abzuleiten.',
    help_platform_email_template_subject: 'Der Betreff der E-Mail Vorlage.',
    help_platform_email_template_content:
        'Der Inhalt der E-Mail Vorlage. Um die Platzhalter neu zu laden, bitte erst den Typ zurücksetzen und dann neu auswählen.',
    help_platform_disclaimer_name: 'Der Name der Risikowarnung.',
    help_platform_disclaimer_language:
        'Die Sprache in welcher der Inhalt der Warnung verfasst wurde.',
    help_platform_disclaimers_countries_applied:
        'Die Ländern, in denen diese Warnung angewendet wird.',
    help_platform_disclaimers_countries_not_applied:
        'Die Ländern, in denen diese Warnung NICHT angewendet wird..',
    help_platform_disclaimer_content: 'Der Inhalt der Plattform Warnung.',
    help_platform_terms:
        'Öffentlich zugängliche URL zu den Geschäftsbedingungen.',
    help_platform_privacy_url:
        'Öffentlich zugängliche URL zur Datenschutzerklärung.',
    help_platform_admin_email:
        'Die E-Mail Adresse, welche zum versenden von E-Mails verwendet wird.',
    help_platform_mail_template:
        'E-Mail Vorlage, welche zum versenden von E-Mails verwendet wird.',
    help_clearing_systems: 'Wählen Sie eines oder mehrere Investitionsvehikel.',
    help_clearing_system: 'Wählen Sie ein Investitionsvehikel.',
    help_order_status_for_total_funding_sum:
        'Investitionsstatus zur Berechnung der gesamten Investitionssumme.',
    help_mail_host:
        'Der SMTP Server, welcher zum versenden von E-Mails verwendet wird.',
    help_mail_port:
        'Der Server Port, welcher verwendet wird um mit dem SMTP Server zu kommunizieren.',
    help_mail_encryption:
        'Die Verschlüsselungsmethode, welche verwendet wird um mit dem SMTP Server zu kommunizieren.',
    help_mail_from_address:
        'Die Absender E-Mail Adresse, welche beim versenden von E-Mails verwendet wird.',
    help_mail_form_name:
        'Der Absender Name, welcher beim versenden von E-Mails verwendet wird.',
    help_mail_username:
        'Der Benutzername, welcher bei der Authentifizierung gegenüber dem SMTP Server angegeben wird.',
    help_mail_password:
        'Das Passwort, welches bei der Authentifizierung gegenüber dem SMTP Server angegeben wird.',
    help_asset_title: 'Der Titel des Vermögenswerts.',
    help_currency: 'Die zu verwendende Währung.',
    help_asset_base_funding_count:
        'Erhöhen Sie die Anzahl der Investments manuell.',
    help_asset_base_funding_total:
        'Erhöhen Sie den investierten Betrag manuell.',
    help_asset_category: 'Die Kategorie des Vermögenswerts.',
    help_asset_currency: 'Die Währung des Vermögenswerts.',
    help_asset_deactivate_payment_account:
        'Sollen automatische Zahlungsabwicklungen deaktiviert sein?',
    help_asset_funding_min: 'Die Finanzierungsschwelle des Vermögenswerts.',
    help_asset_funding_max: 'Das Finanzierungsmaximum des Vermögenswerts.',
    help_asset_investment_min: 'Das minimale Investment.',
    help_asset_investment_max: 'Das maximale Investment.',
    help_asset_location_city: 'Die Stadt des Vermögenswert.',
    help_asset_location_state: 'Das Bundesland des Vermögenswerts.',
    help_asset_location_country: 'Das Land des Vermögenswerts.',
    help_asset_manual_funding_totals:
        'Sollen manuelle Investitionssummen angezeigt werden?',
    help_asset_status: 'Haptstatus.',
    help_asset_step_level: 'Die Finanzierungsschritte der Investition.',
    help_asset_quick_amounts:
        'Geben Sie 4 Werte ein, einen pro Zeile. Diese werden auf der Investitionsseite als Schnellauswahl-Beträge angezeigt.',
    help_asset_sub_status: 'Substatus.',
    help_company_name: 'Der Name der Firma.',
    help_company_logo:
        'Das Logo der Firma, welches im Frontend angezeigt wird.',
    help_company_address: 'Die Adresse von der aus die Firma operiert.',
    help_company_city:
        'Die Stadt oder Ortschaft von der aus die Firma operiert.',
    help_company_postal_code:
        'Die Postleitzahl der Ortschaft von der aus die Firma operiert.',
    help_company_state: 'Das Bundesland/Kanton von der aus die Firma operiert.',
    help_company_country: 'Das Land von dem aus die Firma operiert.',
    help_company_phone_number: 'Die Telefonnummer der Firma.',
    help_company_email: 'Firmen E-Mail Adresse.',
    help_company_website: 'Die Webseite der Firma.',
    bank_account_holder: 'Kontoinhaber',
    help_company_bank_account_holder: 'Der Kontoinhaber der Firma.',
    help_company_iban: 'Der IBAN der Firma.',
    help_company_bic: 'Der BIC der Firma.',
    help_contract_range:
        'Bspw. 3 Jahre, 6 Monate, "unbefristet", ... Wird auf der Kampagnenkarte als zweite Box (Laufzeit) angezeigt. Leer = Box wird ausgeblendet.',
    help_interest_rate: 'Der Zinssatz des Vertrags.',
    help_asset_interest_rate:
        'Zinssatz in %. Wird auf der Kampagnenkarte als erste Box angezeigt, für Anleihe, Wandelanleihe und Nachrangdarlehen. Leer oder 0 = Box wird ausgeblendet.',
    help_target_yield:
        'Zielrendite als Freitext, z. B. "6-8 % p.a.". Wird auf der Kampagnenkarte als erste Box angezeigt, für Partizipationsschein, Genussschein und Indirekte Beteiligung. Leer = Box wird ausgeblendet.',
    help_asset_signature_types:
        'Die für diesen Vermögenswert verfügbaren Zeichnungsoptionen.',
    help_signature_manual_confirmation_required:
        'Wenn aktiviert (Standard), kann eine Order für diesen Vermögenswert erst angenommen werden, wenn ihre manuelle Zeichnung als unterschrieben bestätigt wurde. Wenn deaktiviert, können Orders auch ohne unterschriebene Zeichnung angenommen werden; der Zeichnungsstatus zeigt weiterhin „nicht unterschrieben“ an.',
    help_asset_signature_legal_notice: 'Hinweis zur Zeichnung.',
    help_asset_document_type: 'Die Art des Dokuments.',
    help_asset_document_description: 'Beschreibung des Dokuments',
    help_asset_documents_table_0:
        'Diese Dokumente werden dem Investor via Mail geschickt.',
    help_asset_documents_table_1:
        'Die Reporting Dokumente werden im Frontend angezeigt.',
    help_asset_documents_table_2:
        'Diese Dokumente werden dem Investor vor Abschluss des Investments via Mail zugeschickt.',
    help_run_inclusive_acceptance_wallet:
        'Die Wallet, welche den Betrag erhält.',
    help_run_inclusive_acceptance_date:
        'Investments bis zu diesem Datum werden übertragen.',
    help_campaign_title: 'Der Titel der Kampagne',
    help_campaign_subtitle: 'Der Untertitel der Kampagne',
    help_campaign_slug:
        'Wird in der URL der Kampagne verwendet. Passt sich bei Titeländerungen automatisch an, außer Sie ändern ihn hier. Nur Kleinbuchstaben, Zahlen und Bindestriche, und er muss eindeutig sein. Links mit dem bisherigen Slug funktionieren danach nicht mehr.',
    help_country_campaign:
        'Wählen Sie das Land, in welchem die Kampagne veröffentlicht werden soll.',
    help_language_campaign: 'Wählen Sie die Sprache der Kampagne.',
    number_locale: 'Zahlenformat',
    help_number_locale_campaign:
        'Zahlenformat für E-Mails überschreiben. Leer lassen, um das Format automatisch aus der Kampagnensprache abzuleiten.',
    help_campaign_summary: 'Die Zusammenfassung der Kampagne.',
    help_platform_name_campaign:
        'Wählen Sie die Plattform, welche die Kampagne veröffentlicht.',
    help_asset_title_campaign:
        'Wählen Sie den Vermögenswert, welcher mit der Kampagne verknüpft werden soll.',
    help_campaign_excerpt: 'Der Auszug der Kampagne',
    help_funding_start: 'Start der Finanzierung der Kampagne',
    help_funding_end: 'Ende der Finanzierung der Kampagne',
    help_waitlist_url: 'URL der Wartelisten-Anmeldeseite für diese Kampagne.',
    help_waitlist_text:
        'Text, der neben dem Wartelisten-Anmeldelink für diese Kampagne angezeigt wird.',
    help_regulatory_requirements:
        'Die regulatorischen Anforderungen für diese Kampagne.',
    help_asset_regulation_override:
        'Überschreibt die Regulierung des Vermögenswerts nur für die Anzeige auf dieser Kampagne.',
    help_is_co_placement: 'Markiert diese Kampagne als Co-Platzierung.',
    help_agio_disagio: 'Agio/Disagio',
    help_agio_disagio_title: 'Der Agio/Disagio Titel.',
    help_agio_disagio_rate: 'Die Agio/Disagio Rate.',
    help_agio_disagio_type: 'Der Agio/Disagio Typ.',
    help_agio_disagio_info_text: 'Der Agio/Disagio Infotext.',
    help_agio_disagio_disclaimer: 'Die Agio/Disagio Warnung.',
    help_agio_disagio_voucher:
        'Aktivieren oder deaktivieren sie Gutscheine für Agio/Disagio.',
    help_voucher_code: 'Der Gutscheincode für den Agio/Disagio Gutschein.',
    help_voucher_rate: 'Der Rabatt, welcher durch den Gutschein gewährt wird.',
    help_status_campaign: 'Der Status der Kampagne.',
    help_funding_stats_visible:
        'Soll der Finanzierungsstatus öffentlich angezeigt werden.',
    help_password_campaign:
        'Das Passwort, welches zur Sicherung der Kampagne benötigt wird. Nur Benutzer mit Zugang können investieren.',
    error_private_placement_password_required:
        'Für eine Privatplatzierung muss ein Passwort gesetzt werden.',
    help_broker_status: 'Soll die Broker Warnung angezeigt werden?',
    help_broker_field_required:
        'Soll das Broker Feld als Pflichtfeld angezeigt werden?',
    help_broker_disclaimer: 'Die Broker Warnung, welche angezeigt wird.',
    help_external_project_url: 'Link zu einer externen Projektseite.',
    help_campaign_badge:
        'Wählen Sie das Badge, welches auf der Kampagnenseite angezeigt werden soll.',
    help_show_amount_slider:
        'Soll der Betragsregler während des Checkouts angezeigt werden.',
    help_campaign_thumb_image:
        'Das Thumbnail der Kampagne, welches im Frontend angezeigt wird.',
    help_campaign_hero_image:
        'Das Hauptbild der Kampagne, welches im Frontend angezeigt wird.',
    help_main_campaign: 'Der Hauptinhalt der Kampagne.',
    help_summary_campaign: 'Zusammenfassung der Kampagne.',
    help_associate_orders_modal_text:
        'Möchten Sie dem Vertrag {contract} alle Bestellungen, die noch keinem Vertrag zugeordnet sind zuweisen?',
    help_drag_and_drop:
        'Ziehen Sie die Elemente, um die Reihenfolge zu ändern.',
    help_campaign_content_block_title: 'Titel des Bausteins.',
    help_campaign_content_block_content: 'Inhalt des Bausteins.',
    help_campaign_incentive_amount:
        'Der Anreiz Betrag, welcher dem Investor gewährt wird.',
    help_campaign_incentive_description: 'Die Beschreibung des Anreiz.',
    help_campaign_incentive_title: 'Der Titel des Anreizes.',
    help_campaign_team_member_name: 'Name des Teammitglieds.',
    help_campaign_team_member_title: 'Titel des Teammitglieds.',
    help_campaign_team_member_bio: 'Biografie des Teammitglieds.',
    help_campaign_team_member_image: 'Bild des Teammitglieds.',
    help_order_invested_amount: 'Der investierte Betrag.',
    help_order_notes: 'Notizen zur Bestellung hinzufügen',
    help_order_send_mails: 'Investoren Emails schicken.',
    help_date_of_order: 'Das Datum der Investition.',
    help_select_campaign: 'Wählen Sie die Kampagne.',
    help_select_incentive: 'Wählen Sie einen Anreiz.',
    help_contract_type: 'Wählen Sie die Vertragsart.',
    help_search_account_title: 'Suchen Sie nach einem Investor.',
    help_search_field: 'Geben Sie mindestens 3 Zeichen ein.',
    help_email: 'Die E-Mail Adresse des Investors.',
    help_city: 'Der Wohnort des Investors.',
    help_date: 'Datum der Bestellung.',
    help_first_name: 'Der Vorname des Investors.',
    help_last_name: 'Der Nachname des Investors.',
    help_place_of_birth: 'Der Geburtsort des Investors.',
    help_date_of_birth: 'Das Geburtsdatum des Investors.',
    help_id_card_passport_number:
        'Die Personalausweisnummer oder Reisepass des Investors.',
    help_issuing_authority:
        'Die Ausstellungsbehörde des Personalausweis oder Reisepass.',
    help_address: 'Die Adresse des Investors.',
    help_postal_code: 'Die Postleitzahl.',
    help_state: 'Die Region des Investors.',
    help_tax_number: 'Die Steuernummer des Investors.',
    help_order_attachment_type: 'Geben Sie den Typ des Anhangs an.',
    help_order_attachment_name: 'Der Name des Anhangs.',
    help_order_attachment_description: 'Die Beschreibung des Anhangs.',
    help_additional_fields_enabled:
        'Aktivieren oder deaktivieren Sie die zusätzlichen Felder (Es werden immer alle Felder aktiviert oder deaktiviert). Die folgenden Schalter sind für die verpflichtende Eingabe der jeweiligen Felder.',
    help_depot_owner: 'Der Depotinhaber.',
    help_depot_number: 'Die Depotnummer.',
    help_depot_bank: 'Die Depotbank.',
    help_deposit_account_holder: 'Der Einzahlungskontoinhaber.',
    help_depot_bic: 'BIC der Depotbank.',
    help_bulk_change_order_status: 'Wählen Sie den neuen Status.',
    help_contract_duration: 'Geben Sie die Vertragsdauer an.',
    help_first_payout: 'Das erste Auszahlungsdatum.',
    help_last_payout: 'Das letzte Auszahlungsdatum.',
    help_total_payments_count:
        'Die Anzahl der Auszahlungen für diesen Vertrag.',
    help_start_of_contract: 'Das Startdatum des Vertrags.',
    help_early_bird_promotion:
        'Aktivieren oder deaktivieren Sie die Early Bird Promotion.',
    help_early_bird_interest_rate: 'Der Zinssatz für die Early Bird Promotion.',
    help_early_bird_deadline:
        'Das Datum bis zu dem die Early Bird Promotion gilt.',
    help_calculation_method:
        'Wählen Sie die Berechnungsmethode für den Zinssatz.',
    help_calculation_start_date:
        'Das Datum ab dem der Zinssatz berechnet wird.',
    help_bullet_loan:
        'Aktivieren oder deaktivieren Sie Auszahlungen am Ende der Vertragsdauer.',
    help_deferred_clearance:
        'Die Anzahl der Auszahlungen um welche die Tilgung verschoben wird.',
    help_external_wallet_id:
        'Die externe Wallet ID für die Ein- und Auszahlungen.',
    help_voucher_wallet:
        'Von diesem Lemonway Wallet werden die eingelösten Vouchers abgebucht.',
    help_voucher_campaign_name: 'Name der Voucher Kampagne.',
    help_voucher_campaign_type: 'Wählen Sie den Typ der Voucher Kampagne.',
    help_voucher_campaign_default: 'Wählen Sie die Standard Voucher Kampagne.',
    help_pay_percent_of_rest: 'Der Prozentsatz der Restsumme.',
    help_interest_bonus: 'Der Zinsbonus.',
    help_open_file_in_new_tab: 'File in neuem Tab öffnen',
    help_show_verification_comment: 'Kommentar anzeigen',
    help_account_first_name: 'Vorname',
    help_account_last_name: 'Nachname',
    help_account_email: 'E-Mail Adresse',
    help_account_nationality: 'Nationalität',
    help_account_gender: 'Geschlecht',
    help_account_country: 'Land',
    help_account_email_pending: 'E-Mail Bestätigung',
    help_account_company_description: 'Unternehmensgegenstand',
    help_account_company_registration_number: 'Unternehmenregistrationsnummer',
    help_account_company_name: 'Firmenname',
    help_account_name: 'Name des Investors',
    help_account_custom_id: 'Individuelle ID',
    help_account_address: 'Adresse',
    help_account_zip: 'PLZ',
    help_account_city: 'Stadt',
    help_account_state: 'Bundesland',
    help_account_phone: 'Telefonnummer',
    help_account_mobile: 'Mobiltelefonnummer',
    help_account_iban: 'IBAN',
    help_account_bic: 'BIC',
    help_account_tax_number: 'Steuernummer',
    help_account_social_security_number: 'Sozialversicherungsnummer',
    help_campaigns_table:
        'Die Liste der Kampagnen auf die Sie zugreifen können.',
    help_contracts_table:
        'Die Liste der Verträge auf die Sie zugreifen können.',
    help_bank_account: 'Verifiziertes Bankkonto',
    help_money_withdrawal_comment: 'Kommentar zur Abhebung',
    help_money_withdrawal_amount: 'Summe der Abhebung',
    help_kyc_document_type: 'Dokumenttyp',
    help_kyc_document_iban: 'IBAN',
    help_kyc_document_account_holder: 'Bankkontoinhaber',
    help_bank_account_holder: 'Bankkontoinhaber',
    help_bank_account_iban: 'IBAN',
    help_bank_account_bic: 'BIC',
    error_invalid_iban: 'Diese IBAN ist ungültig.',
    error_invalid_bic: 'Diese BIC ist ungültig.',
    modal_title_create_bank_account: 'Bankkonto erstellen',
    modal_title_update_bank_account: 'Bankkonto bearbeiten',
    modal_title_delete_bank_account: 'Bankkonto löschen',
    modal_confirm_delete_bank_account:
        'Möchten Sie dieses Bankkonto wirklich löschen?',
    toast_success_bank_account_created: 'Bankkonto erstellt!',
    toast_error_bank_account_create: 'Erstellen des Bankkontos fehlgeschlagen!',
    toast_success_bank_account_updated: 'Bankkonto aktualisiert!',
    toast_error_bank_account_update:
        'Aktualisieren des Bankkontos fehlgeschlagen!',
    toast_success_bank_account_deleted: 'Bankkonto gelöscht!',
    toast_error_bank_account_delete: 'Löschen des Bankkontos fehlgeschlagen!',
    set_as_primary: 'Als primär festlegen',
    help_set_as_primary: 'Als primäres Konto für die Plattform festlegen',
    primary_for_platforms: 'Primär für',
    help_view_bank_account_audits: 'Änderungsverlauf anzeigen',
    help_edit_order: 'Bestellung bearbeiten',
    help_campaign_content_images_table: 'Die Kampagnen Bilder.',
    help_campaign_content_documents_table: 'Die Kampagnen Dokumente.',
    help_campaign_content_blocks_table: 'Die Content Bausteine der Kampagne.',
    help_platform_attachments_table: 'Die Plattform Anhänge.',
    help_platform_documents_table:
        'Einmal für diese Plattform hochgeladene Dokumente (z. B. AGB, Hinweise), die mit beliebigen Assets verknüpft werden können.',
    help_linked_platform_documents:
        'Plattformdokumente, die Anlegern während des Investmentprozesses dieses Assets zusätzlich zu dessen eigenen Vertragsdaten-Dokumenten angezeigt werden.',
    help_platform_webhooks_table: 'Die Plattform Webhooks.',
    help_platform_policies_table: 'Die Platform Richtlinien.',
    help_platform_cookie_consent_services_table:
        'Die Cookie Consent Services Tabelle.',
    help_platform_email_templates_table: 'Die Platform Email Templates.',
    help_platform_disclaimers_table: 'Die Platform Warnungen.',
    help_bulk_change_order_campaign: 'Wählen Sie die Kampagne.',
    help_assets_table: 'Die Vermögenswerte.',
    help_asset_contracts_table: 'Die Verträge des Vermögenswert.',
    help_platforms_table: 'Die Plattformen.',
    help_orders_table: 'Die Bestellungen.',
    help_investor_modal: 'Der Investor in dessen Namen sie gerade agieren.',
    help_valid_to: 'Gültig-bis Datum muss mindestens übermorgen sein: ',
    help_verification_status: 'Verifikationsstatus',
    help_comment: 'Kommentar',
    help_incentives_table: 'Die Anreize.',
    help_bank_accounts_table: 'The bank accounts.',
    help_view_order: 'View order',
    help_wallet_transaction_table: 'The wallet transactions table',
    help_withdrawals_table: 'The withdrawals table',
    help_accounts_table: 'Investoren',
    help_natural_profiles: 'Verknüpfte natürliche Personen',
    help_view_natural_profile: 'Profil der natürlichen Person anzeigen',
    help_order_attachments_table: 'Anhänge',
    help_manual_investments:
        'Mit Aktivierung der Checkbox wird die Anzeige für die Anzahl wie die Gesamtsumme von Investments manuell geändert.',
    help_team_members_table: 'Liste der Team Mitglieder.',
    help_order_status:
        'Wählen Sie das Status Datum, welches sie anpassen möchten.',
    help_order_status_date:
        'Geben Sie das Datum an, auf welches das Status Datum gesetzt werden soll.',
    help_transactions_table: 'Transaktionen',
    help_emails_table: 'E-Mails',
    help_default_language: 'Standardsprache',
    help_account_country_of_birth: 'Geburtsland',
    help_account_city_of_birth: 'Geburtsstadt',
    help_savings_plan: 'Aktivierung des Ansparplan E-Mail',
    help_savings_plan_description:
        'Dieser Text wird angezeigt in der Zusammenfassung des Investmentprozesses',

    modal_title_export_result: 'Export',
    modal_title_delete_platform: 'Plattform löschen?',
    modal_title_delete_platforms: 'Plattformen löschen?',
    modal_title_update_platform_attachment: 'Plattform Anhang bearbeiten',
    modal_title_create_platform_attachment: 'Plattform Anhang erstellen',
    modal_title_delete_platform_attachment: 'Plattform Anhang löschen?',
    modal_title_delete_platform_attachments: 'Plattform Anhänge löschen?',
    modal_title_update_platform_document: 'Plattformdokument bearbeiten',
    modal_title_create_platform_document: 'Plattformdokument erstellen',
    modal_title_delete_platform_document: 'Plattformdokument löschen?',
    modal_title_delete_platform_documents: 'Plattformdokumente löschen?',
    modal_title_edit_linked_platform_documents: 'Verknüpfte Plattformdokumente',
    modal_title_update_platform_webhook: 'Plattform Webhook bearbeiten',
    modal_title_create_platform_webhook: 'Plattform Webhook erstellen',
    modal_title_delete_platform_webhook: 'Plattform Webhook löschen?',
    modal_title_delete_platform_webhooks: 'Plattform Webhooks löschen?',
    modal_title_update_platform_policy: 'Plattform Richtlinie bearbeiten',
    modal_title_create_platform_policy: 'Plattform Richtlinie erstellen',
    modal_title_delete_platform_policy: 'Plattform Richtlinie löschen?',
    modal_title_delete_platform_policies: 'Plattform Richtlinien löschen?',
    modal_title_update_platform_cookie_consent_service:
        'Cookie Consent Service bearbeiten',
    modal_title_create_platform_cookie_consent_service:
        'Cookie Consent Service erstellen',
    modal_title_delete_platform_cookie_consent_service:
        'Cookie Consent Service löschen?',
    modal_title_delete_platform_cookie_consent_services:
        'Cookie Consent Services löschen?',
    modal_title_update_platform_email_template:
        'Plattform E-Mail Vorlage bearbeiten',
    modal_title_create_platform_email_template:
        'Plattform E-Mail Vorlage erstellen',
    modal_title_view_platform_email_template:
        'Plattform E-Mail Vorlage anzeigen',
    modal_title_delete_platform_email_template:
        'Plattform E-Mail Vorlage löschen?',
    modal_title_delete_platform_email_templates:
        'Plattform E-Mail Vorlagen löschen?',
    modal_title_update_platform_disclaimer: 'Plattform Warnung bearbeiten',
    modal_title_create_platform_disclaimer: 'Plattform Warnung erstellen',
    modal_title_delete_platform_disclaimer: 'Plattform Warnung löschen?',
    modal_title_delete_platform_disclaimers: 'Plattform Warnungen löschen?',
    modal_title_delete_asset: 'Vermögenswert löschen?',
    modal_title_delete_assets: 'Vermögenswerte löschen?',
    modal_title_update_asset_document: 'Vertragsdokument bearbeiten',
    modal_title_create_asset_document: 'Vertragsdokument erstellen',
    modal_title_update_ecsp_document: 'ECSP Dokument bearbeiten',
    modal_title_view_ecsp_document: 'ECSP Dokument ansehen',
    modal_title_update_asset_document_0:
        'Vertragsdokument bearbeiten (Vertragsdaten)',
    modal_title_create_asset_document_0:
        'Vertragsdokument erstellen (Vertragsdaten)',
    modal_title_update_asset_document_1:
        'Vertragsdokument bearbeiten (Reporting)',
    modal_title_create_asset_document_1:
        'Vertragsdokument erstellen (Reporting)',
    modal_title_update_asset_document_2:
        'Vertragsdokument bearbeiten (Verbraucherinformation)',
    modal_title_create_asset_document_2:
        'Vertragsdokument erstellen (Verbraucherinformation)',
    modal_title_delete_asset_document: 'Vertragsdokument löschen?',
    modal_title_delete_asset_documents: 'Vertragsdokumente löschen?',
    modal_title_run_inclusive_acceptance: 'Inklusive Annahme durchführen',
    modal_title_run_exclusive_acceptance:
        'Exklusiven Annahmeprozess durchführen',
    modal_title_delete_campaign: 'Kampagne löschen?',
    modal_title_delete_campaigns: 'Kampagnen löschen?',
    modal_title_associate_orders: 'Bestellungen verknüpfen?',
    modal_title_delete_asset_contract: 'Vertrag löschen?',
    modal_title_delete_asset_contracts: 'Verträge löschen?',
    modal_title_delete_campaign_content_image: 'Bild löschen?',
    modal_title_delete_campaign_content_images: 'Bilder löschen?',
    modal_title_delete_campaign_content_document: 'Dokument löschen?',
    modal_title_delete_campaign_content_documents: 'Dokumente löschen?',
    modal_title_delete_campaign_content_block: 'Baustein löschen?',
    modal_title_delete_campaign_content_blocks: 'Bausteine löschen?',
    modal_title_view_campaign_content_block: 'Baustein ansehen',
    modal_title_edit_campaign_content_block: 'Baustein bearbeiten',
    modal_title_create_campaign_content_block: 'Baustein erstellen',
    modal_title_view_campaign_team_member: 'Teammitglied ansehen',
    modal_title_create_campaign_team_member: 'Teammitglied erstellen',
    modal_title_edit_campaign_team_member: 'Teammitglied bearbeiten',
    modal_title_delete_campaign_team_member: 'Teammitglied löschen?',
    modal_title_delete_campaign_team_members: 'Teammitglieder löschen?',
    modal_title_view_campaign_incentive: 'Anreiz ansehen',
    modal_title_edit_campaign_incentive: 'Anreiz bearbeiten',
    modal_title_create_campaign_incentive: 'Anreiz erstellen',
    modal_title_delete_campaign_incentive: 'Anreiz löschen?',
    modal_title_delete_campaign_incentives: 'Anreiz löschen?',
    modal_title_create_order: 'Bestellung erstellen',
    modal_title_edit_order_attachment: 'Anhang bearbeiten',
    modal_title_create_order_attachment: 'Anhang erstellen',
    modal_title_delete_order_attachment: 'Anhang löschen?',
    modal_title_delete_order_attachments: 'Anhänge löschen?',
    modal_title_confirm_signature: 'Signatur bestätigen',
    modal_title_cancel_order: 'Bestellung Abbrechen?',
    modal_title_confirm_refund_accepted_order:
        'Rückerstattung der angenommenen Bestellung bestätigen',
    modal_text_confirm_refund_accepted_order:
        'Diese Investition wurde angenommen und kann ausstehende Verpflichtungen haben. Bitte bestätigen Sie, dass Sie mit der Rückerstattung fortfahren möchten.',
    with_refund: 'Zahlung erstatten',
    help_with_refund:
        'Löst eine Zahlungsrückerstattung über Secupay aus, wenn diese Bestellung storniert wird.',
    cancel_order_within_cancel_period_warning:
        'Hinweis: Diese Investition befindet sich noch innerhalb der Widerrufsfrist des Investors (läuft ab: {deadline}). Der Investor erwartet möglicherweise noch, selbst zu widerrufen.',
    cancel_order_policy_conflict_confirm:
        'Ich bestätige, dass diese Stornierung die aktive Widerrufsfrist des Investors überschreibt, und möchte fortfahren.',
    confirm_refund_on_accepted_orders:
        'Rückerstattung für akzeptierte Bestellungen bestätigen',
    help_confirm_refund_on_accepted_orders:
        'Erstattet auch Bestellungen, die bereits akzeptiert wurden. Mit Vorsicht verwenden – akzeptierte Bestellungen können ausstehende Verpflichtungen haben.',
    modal_title_accept_order: 'Bestellung akzeptieren?',
    modal_title_set_order_status_to_pending:
        'Bestellstatus auf "Ausstehend" setzen?',
    modal_title_set_order_status_to_paid: 'Bestellstatus auf "Bezahlt" setzen?',
    modal_title_delete_contract: 'Vertrag löschen?',
    modal_title_delete_contract_template: 'Vertragsdokument löschen?',
    modal_delete_warning_contract_template:
        'Sind Sie sicher, dass Sie das Vertragsdokument löschen möchten?',
    modal_title_delete_contracts: 'Verträge löschen?',
    modal_title_delete_task: 'Aufgabe löschen?',
    modal_title_confirm_update_contract: 'Vertragsänderung bestätigen',
    modal_title_new_interest_payment_calculation: 'Neue Zinsberechnung',
    modal_title_execute_interest_payment: 'Zinszahlung ausführen',
    modal_title_payout_task: 'Auszahlung',
    modal_title_start_interest_payment_payout: 'Zinszahlung ausführen',
    modal_title_create_money_withdrawal: 'Abhebung von Wallet hinzufügen',
    modal_title_show_kyc_document_comment: 'Kommentare zum Dokument',
    modal_title_create_bank_kyc_document: 'Upload - Bankkonto KYC Dokument',
    modal_title_create_address_kyc_document: 'Upload - KYC Dokument - Adresse',
    modal_title_create_tax_kyc_document: 'Upload - KYC Dokument - Steuerdaten',
    modal_title_bulk_change_order_status: 'Bestellstatus ändern',
    modal_title_bulk_change_order_campaign: 'Kampagne ändern',
    modal_title_delete_natural_profile: 'DSGVO Daten löschen?',
    modal_title_delete_legal_profile: 'Account löschen?',
    modal_title_update_kyc_document: 'KYC Dokument bearbeiten',
    modal_title_create_id_kyc_document: 'Upload - KYC Dokument - Identität',
    modal_title_create_legal_kyc_document:
        'Upload - KYC Dokument - Prüfung der Unternehmensdaten',
    modal_title_create_nautral_account: 'Natürliche Person erstellen',
    modal_title_change_campaign_status: 'Kampagnenstatus ändern',
    modal_title_change_order_status_date: 'Status Datum ändern',

    modal_text_confirm_signature:
        'Sind Sie sicher, dass sie die Signatur manuell bestätigen wollen? Dies sollte nur nach Erhalt und Überprüfung eines rechtlich bindenden Dokuments erfolgen.',
    modal_text_regenerate_signature:
        'Sind Sie sicher, dass Sie die Signaturen neu generieren möchten? Alle derzeit aktiven Signaturen werden zurückgesetzt.',
    modal_text_order_status_set_order_status_paid:
        'Ja, setze den Bestellstatus auf "Bezahlt".',
    modal_text_order_status_accept:
        'Ja, setze den bestellstatus auf "Akzeptiert".',
    modal_text_order_status_set_order_status_pending:
        'Ja, setze den Bestellstatus auf "Ausstehend".',
    modal_text_order_status_set_order_status_canceled:
        'Ja, setze den Bestellstatus auf "Abgebrochen".',
    modal_text_confirm_update_contract:
        'The contract with id {contract} has orders. Do you want to updated this contract?',
    modal_text_execute_interest_payment:
        'Wollen Sie diese Aktion wirklich ausführen? Diese Aktion kann nicht rückgängig gemacht werden.',
    modal_text_start_interest_payment_payout:
        'Sind Sie sich sicher, dass die Zinsauszahlungan auf die Wallets ausgeführt werden sollen?',
    modal_text_delete_natural_profile:
        'Sind Sie sich sicher, dass Sie alle Daten dieses Accounts löschen wollen? Dies ist eine DSGVO-Lösung (keine normale Löschung/Deaktivierung). Bei dieser Löschung werden alle Daten wie KYC-Dokumente, Audits, etc. mitgelöscht. Alte Versionen des Accounts werden ebenfalls gelöscht. Als alte Accounts zählen deaktivierte Accounts mit der selber E-Mailadresse in der selben Plattform.',
    modal_text_delete_legal_profile:
        'Bitte bestätigen Sie das Löschen des Accounts.',
    modal_text_delete_task:
        'Sind Sie sich sicher, dass Sie die Aufgabe "{type}", die am {created} erstellt wurde löschen möchten?',

    toast_error_cannot_delete_platform: 'Plattform kann nicht entfernt werden!',
    toast_error_access_denied:
        'Sie sind nicht berechtigt diese Seite zu sehen: {path}.',
    toast_success_platform_deleted: 'Plattform "{platform}" wurde entfernt.',
    toast_success_platforms_deleted:
        'Plattformen "{platforms}" wurden entfernt.',
    toast_success_applying_filters: 'Wende filter an: {filters}',
    toast_success_clear_filters: 'Filter werden zurückgesetzt ...',
    toast_success_platform_created: 'Plattform wurde erstellt!',
    toast_success_platform_saved: 'Plattform "{platform}" gespeichert!',
    toast_success_platform_attachment_created:
        'Plattform Anhang "{attachment}" erstellt!',
    toast_success_platform_attachment_updated:
        'Plattform Anhang "{attachment}" aktualisiert!',
    toast_success_platform_attachment_deleted:
        'Plattform Anhang "{attachment}" entfernt!',
    toast_success_platform_attachments_deleted:
        'Plattform Anhänge "{attachments}" entfernt!',
    platform_terms_documents: 'AGB-Dokumente',
    platform_terms_document: 'AGB-Dokument',
    platform_terms_document_group: 'Gruppe',
    platform_terms_document_languages: 'PDF-Sprachen',
    help_platform_terms_document_group:
        'Abschnitt der AGB-Seite, unter dem das Dokument angezeigt wird. Neue Gruppen legen Sie in der Tabelle AGB-Gruppen an.',
    modal_title_create_platform_terms_document_group: 'AGB-Gruppe hinzufügen',
    modal_title_delete_platform_terms_document_group: 'AGB-Gruppe löschen',
    toast_success_platform_terms_document_group_created:
        'AGB-Gruppe {group} wurde erstellt.',
    toast_success_platform_terms_document_group_deleted:
        'AGB-Gruppe {group} wurde gelöscht.',
    platform_terms_document_group_page: 'Seite',
    platform_terms_document_group_page_terms: 'AGB',
    platform_terms_document_group_page_data_privacy: 'Datenschutz',
    platform_terms_document_groups: 'AGB-Gruppen',
    platform_terms_document_group_title_de: 'Überschrift DE',
    platform_terms_document_group_title_en: 'Überschrift EN',
    platform_terms_document_group_title_it: 'Überschrift IT',
    help_platform_terms_document_group_titles:
        'Überschrift der Gruppe auf der AGB-Seite je Sprache. Die deutsche Überschrift ist Pflicht, leere Sprachen zeigen die deutsche.',
    modal_title_update_platform_terms_document_group: 'AGB-Gruppe bearbeiten',
    toast_success_platform_terms_document_group_updated:
        'AGB-Gruppe {group} wurde gespeichert.',
    platform_terms_documents_count: 'Dokumente',
    help_platform_terms_documents_table:
        'Dokumente der AGB-Seite. Per Drag & Drop legen Sie die Reihenfolge innerhalb einer Gruppe fest; die Gruppe wählen Sie im Dokument aus.',
    help_platform_terms_document_groups_table:
        'Abschnitte der AGB-Seite, in der angezeigten Reihenfolge. Per Drag & Drop sortieren. Eine Gruppe kann erst gelöscht werden, wenn sie keine Dokumente mehr enthält. Die Gruppe Datenschutz ist fest vorgegeben und erscheint auf der Datenschutzseite statt auf der AGB-Seite.',
    help_platform_terms_document_name:
        'Titel, unter dem das Dokument in der gewählten Sprache auf der AGB-Seite angezeigt wird.',
    help_platform_terms_document_language:
        'Sprache des PDFs, das Sie hochladen oder bearbeiten. Laden Sie die Sprachen nacheinander hoch; ✓ markiert Sprachen mit PDF. Auf der AGB-Seite erscheint das Dokument nur in den Sprachen, für die es ein PDF hat.',
    modal_title_create_platform_terms_document: 'AGB-Dokument hinzufügen',
    modal_title_update_platform_terms_document: 'AGB-Dokument bearbeiten',
    modal_title_delete_platform_terms_documents: 'AGB-Dokumente löschen',
    toast_success_platform_terms_document_created:
        'AGB-Dokument {document} wurde erstellt.',
    toast_success_platform_terms_document_updated:
        'AGB-Dokument {document} wurde aktualisiert.',
    toast_success_platform_terms_documents_deleted:
        'AGB-Dokumente {documents} wurden gelöscht.',
    toast_success_platform_document_created:
        'Plattformdokument "{document}" erstellt!',
    toast_success_platform_document_updated:
        'Plattformdokument "{document}" aktualisiert!',
    toast_success_platform_document_deleted:
        'Plattformdokument "{document}" entfernt!',
    toast_success_platform_documents_deleted:
        'Plattformdokumente "{documents}" entfernt!',
    toast_success_asset_linked_platform_documents_updated:
        'Verknüpfte Plattformdokumente aktualisiert!',
    toast_success_platform_webhook_created:
        'Plattform Webhook "{action}" erstellt!',
    toast_success_platform_webhook_updated:
        'Plattform Webhook "{action}" aktualisiert!',
    toast_success_platform_webhook_deleted:
        'Plattform Webhook "{action}" entfernt!',
    toast_success_platform_webhooks_deleted:
        'Plattform Webhook "{actions}" entfernt!',
    toast_success_platform_policy_created:
        'Plattform Richtlinie "{policy}" erstellt!',
    toast_success_platform_policy_updated:
        'Plattform Richtlinie "{policy}" aktualisiert!',
    toast_success_platform_policy_deleted:
        'Plattform Richtlinie "{policy}" entfernt!',
    toast_success_platform_policies_deleted:
        'Plattform Richtlinien "{policies}" entfernt!',
    toast_success_cookie_consent_service_created:
        'Cookie Consent Service "{service}" erstellt!',
    toast_success_cookie_consent_service_updated:
        'Cookie Consent Service "{service}" aktualisiert!',
    toast_success_cookie_consent_service_deleted:
        'Cookie Consent Service "{service}" entfernt!',
    toast_success_cookie_consent_services_deleted:
        'Cookie Consent Services "{services}" entfernt!',
    toast_success_cookie_consent_services_seeded:
        'Standard Cookie Consent Services geladen!',
    toast_success_platform_email_template_updated:
        'Plattform E-Mail Vorlage "{template}" bearbeitet!',
    toast_success_platform_email_template_created:
        'Plattform E-Mail Vorlage "{template}" erstellt!',
    toast_success_platform_email_template_deleted:
        'Plattform E-Mail Vorlage "{template}" entfernt!',
    toast_success_platform_email_templates_deleted:
        'Plattform E-Mail Vorlagen "{templates}" entfernt!',
    toast_success_platform_email_template_sent:
        'Plattform E-Mail Vorlage "{template}" gesendet!',
    toast_success_platform_disclaimer_updated:
        'Plattform Warnung "{disclaimer}" bearbeitet!',
    toast_success_platform_disclaimer_created:
        'Plattform Warnung "{disclaimer}" erstellt!',
    toast_success_platform_disclaimer_deleted:
        'Plattform Warnung "{disclaimer}" entfernt!',
    toast_success_platform_disclaimers_deleted:
        'Plattform Warnungen "{disclaimers}" entfernt!',
    toast_success_transmit_asset: 'Vermögenswerte erfolgreich übertragen!',
    toast_success_asset_created: 'Vermögenswert wurde erstellt!',
    toast_error_cannot_delete_asset:
        'Vermögenswert kann nicht entfernt werden!',
    toast_success_asset_deleted: 'Vermögenswert wurde erfolgreich entfernt!',
    toast_success_assets_deleted: 'Vermögenswerte wurden erfolgreich gelöscht.',
    toast_success_campaign_created: 'Kampagne erstellt!',
    toast_success_campaign_duplicated: 'Kampagne dupliziert!',
    toast_success_asset_saved: 'Vermögenswert wurde erfolgreich gespeichert!',
    toast_success_campaign_saved: 'Kampagne wurde erfolgreich gespeichert!',
    toast_success_asset_document_updated:
        'Vertragsdokument "{document}" aktualisiert!',
    toast_success_asset_document_created:
        'Vertragsdokument "{document}" erstellt!',
    toast_success_asset_document_deleted:
        'Vertragsdokument "{document}" gelöscht!',
    toast_success_asset_documents_deleted:
        'VertragsdokumentE "{documents}" gelöscht!',
    toast_success_ad_hoc_email_sent:
        'Ad-hoc E-Mail wurde erfolgreich gesendet!',
    toast_success_run_inclusive_acceptance: 'Annahme gestartet: {log}',
    toast_success_run_exclusive_acceptance:
        'Exklusives Annahmeprocess wurde gestartet: {log}',
    toast_success_transfer_tokens_success:
        'Starte Nyala-Token übertragung: {log}',
    toast_success_associate_orders:
        '{orders} Bestellungen wurden mit dem Vertrag {contract} verknüpft.',
    toast_success_campaign_content_image_deleted:
        'Beitragsbild {contentImage} gelöscht!',
    toast_success_campaign_content_images_deleted:
        'Beitragsbilder {contentImages} gelöscht!',
    toast_success_campaign_content_image_created:
        'Beitragsbild {contentImage} erstellt!',
    toast_success_campaign_content_document_deleted:
        'Beitragsdokument {contentDocument} gelöscht!',
    toast_success_campaign_content_documents_deleted:
        'Beitragsdokumente {contentDocuments} gelöscht!',
    toast_success_campaign_content_document_created:
        'Beitragsdokument {contentDocument} erstellt!',
    toast_success_campaign_content_block_updated:
        'Baustein {contentBlock} aktualisiert!',
    toast_success_campaign_content_block_created:
        'Baustein {contentBlock} erstellt!',
    toast_success_campaign_content_block_deleted:
        'Baustein {contentBlock} gelöscht!',
    toast_success_campaign_content_blocks_deleted:
        'Bausteine {contentBlocks} gelöscht!',
    toast_success_campaign_team_member_created:
        'Teammitglied {teamMember} erstellt!',
    toast_success_campaign_team_member_updated:
        'Teammitglied {teamMember} aktualisiert!',
    toast_success_campaign_team_member_deleted:
        'Teammitglied {teamMember} gelöscht!',
    toast_success_campaign_team_members_deleted:
        'Teammitglieder {teamMembers} gelöscht!',
    toast_success_order_attachment_deleted: 'Anhang {attachment} gelöscht!',
    toast_success_order_attachments_deleted: 'Anhänge {attachments} gelöscht!',
    toast_success_order_attachment_updated: 'Anhang {attachment} aktualisiert',
    toast_success_order_attachment_created: 'Anhang {attachment} erstellt',
    toast_success_order_status_changed:
        'Bestellstatus von Bestellung {order} geändert!',
    toast_success_order_updated: 'Bestellung {order} aktualisiert!',
    toast_success_order_created: 'Bestellung erstellt!',
    toast_success_orders_status_changed:
        'Status der Bestellungen {orders} erfolgreich geändert!',
    toast_success_campaign_deleted: 'Kampagne erfolgreich entfernt!',
    toast_success_campaigns_deleted: 'Kampagnen erfolgreich entfernt!',
    toast_success_contract_saved: 'Vertrag {contract} erfolgreich geändert!',
    toast_success_contract_deleted: 'Vertrag {contract} erfolgreich entfernt!',
    toast_success_contracts_deleted:
        'Verträge {contracts} erfolgreich entfernt!',
    toast_success_interest_payment_execute: 'Zinszahlung wurde erstellt!',
    toast_success_interest_payment_payout_started: 'Zinszahlung gestartet!',
    toast_success_orders_campaign_changed:
        'Kampagne der Bestellungen {orders} geändert!',

    toast_success_withdrawal_created: 'Abhebung erfolgreich hinzugefügt!',
    toast_success_campaign_status_changed:
        'Kampagnen Status erfolgreich geändert!',

    toast_error_withdrawal_creation_failed:
        'Abhebung konnte nicht erstellt werden!',

    toast_success_natural_profile_updated: 'Speichern der Daten erfolgreich!',
    toast_error_natural_profile_update_failed:
        'Speichern der Daten fehlgeschlagen!',

    toast_success_kyc_document_created:
        'Dokument wurde erfolgreich hochgeladen!',
    toast_error_kyc_document_create:
        'Dokument konnte nicht hochgeladen werden!',

    toast_success_legal_profile_updated: 'Speichern der Daten erfolgreich!',
    toast_error_legal_profile_update_failed:
        'Speichern der Daten fehlgeschlagen!',
    toast_error_wallet_sync_failed: 'Wallet Synchronisation fehlgeschlagen!',
    toast_success_wallet_synced: 'Wallet Synchronisation erfolgreich!',
    toast_success_natural_profile_deleted: 'DSGVO deleted!',
    toast_success_legal_profile_deleted: 'Account deleted!',
    toast_success_legal_account_created: 'Geschäftskonto erfolgreich angelegt!',
    toast_success_account_created:
        'Account für natürliche Person erfolgreich erstellt',
    toast_success_kyc_document_updated: 'KYC document erfolgreich gepeichert!',
    toast_error_kyc_document_updated:
        'Speichern des KYC Dokuments fehlgeschlagen!',
    toast_success_campaign_incentive_created: 'Incentive erfolgreich erstellt!',
    toast_success_campaign_incentive_updated:
        'Incentive erfolgreich aktualisiert!',
    toast_success_idv_document_download:
        'Signteq IDV Dokument wurde erfolgreich heruntergeladet.',
    toast_error_idv_document_download:
        'Fehler: Signteq IDV Dokument konnte nicht heruntergeladet werden.',

    toast_success_asset_push_to_zoho: 'Asset an Zoho übertragen!',
    toast_success_assets_push_to_zoho: 'Assets an Zoho übertragen!',
    toast_success_investor_push_to_zoho: 'Investor an Zoho übertragen!',
    toast_success_investors_push_to_zoho: 'Investoren an Zoho übertragen!',
    toast_success_investment_push_to_zoho: 'Investition an Zoho übertragen!',
    toast_success_investments_push_to_zoho: 'Investitionen an Zoho übertragen!',
    warning_failed_transactions_count:
        'Warnung: Fehlgeschlagene Transaktionen: {count}.',
    warning_missing_iban:
        'Warnung: Bei {count} Bestellung(en) wurde kein IBAN angegeben.',
    warning_missing_bic:
        'Hinweis: Bei {count} Bestellung(en) wurde kein BIC angegeben.',
    warning_order_failed_transactions_count:
        'Anzahl fehlgeschlagener Transaktionen: {count}',
    warning_order_missing_iban: 'Kein IBAN',
    warning_order_missing_bic: 'Kein BIC',

    // Enums //

    // CampaignStatus //
    DRAFT: 'Entwurf',
    ANNOUNCEMENT: 'Ankündigung',
    PRE_FUNDING: 'Pre-Funding',
    FUNDING: 'Finanzierung',
    FUNDING_SUCCESSFUL: 'Erfolgreich',
    FUNDING_UNSUCCESSFUL: 'Nicht erfolgreich',
    PRIVATE_PLACEMENT: 'Private Platzierung',

    // RegulatoryRequirements //
    DEFAULT: 'Default',
    ALTFG: 'AltFG',
    VERMANLG: 'VermAnlG',
    WPHG: 'WpHG-Aktien',
    ECSP: 'ECSP',

    // AgioDisagio //
    DEACTIVATED: 'Deaktiviert',
    AGIO_ACTIVATED: 'Agio',
    DISAGIO_ACTIVATED: 'Disagio',

    // Contract type
    CASH: 'Geld',
    VOUCHER: 'Gutschein',

    // Campaign Badge
    NEW: 'Neu',
    WE_LOVE_THIS: 'We love this',
    FAVORITE: 'Favorite',
    STARTING_SOON: 'Startet bald',
    IMPACT_INVESTMENT: 'Impact Investment',
    FUNDING_THRESHOLD_REACHED: 'Fundingschwelle erreicht',

    // Order Attachment Type
    INVESTMENT_DOCUMENT: 'Investitionsdokument',
    OTHER: 'Anderes',

    // SignatureDocumentType
    EMISSION: 'Emission',
    ESAC_FORM_A: 'Anlegerprofil (FORM A)',
    ESAC_FORM_B: 'Erklärung des wirtschaftlich Berechtigten (FORM B)',
    ESAC_FORM_C: 'FATCA-Erklärung (Form C)',
    ESAC_FORM_D: 'FATCA-Erklärung (Form D)',

    // SignatureType
    MANUAL: 'Manual',
    SPROOF: 'Sproof',

    // OrderStatus
    CANCELED: 'Abgebrochen',
    PENDING: 'Ausstehend',
    PAID: 'Bezahlt',
    ACCEPTED: 'Akzeptiert',

    // ContractPeriodType
    FIXED: 'Fixed',
    CONTINUOUS: 'Continuous',

    // ContractPeriodStart
    CURRENT: 'current',
    NEXT: 'next',

    // InterestRateCalculationMethod
    IR_ACT_360: 'ACT/360',
    IR_ACT_365: 'ACT/365',
    IR_30_360: '30/360',

    // CalculationStartDate
    ACCEPTANCE_DATE: 'Akzeptiert am',
    PAID_DATE: 'Bezahlt am',

    // PayoutTaskFinishedType
    SUCCESS: 'Erfolg',
    WARNING: 'Warnung',
    HAS_ERRORS: 'Hat Fehler',
    ERROR: 'Fehler',
    ERROR_WHILE_GENERATING: 'Fehler beim Generieren',

    // PrimaryUserRoles
    DEVELOPER: 'Developer',
    SUPERADMIN: 'Superadmin',
    PLATFORM_ADMIN: 'Platform Admin',
    FRONTOFFICE_MANAGER: 'Frontoffice Manager',
    BACKOFFICE_MANAGER_CONDA: 'Backoffice Manager Conda',
    BACKOFFICE_MANAGER_WL: 'Backoffice Manager WL',
    READ_ONLY: 'Read Only',
    // Accounts
    MALE: 'männlich',
    FEMALE: 'weiblich',
    NON_BINARY: 'nicht binär',

    // ECSP Status
    EXPERT: 'Kundig',
    NON_EXPERT: 'Nicht Kundig (Abgelehnt)',
    EXPERT_PENDING: 'Nicht Kundig (zu prüfen)',
    NOTHING_TO_CHECK: 'Nicht zu Prüfen',

    // KYC Dokumenttyp
    PASSPORT: 'Reisepass',
    INVOICE: 'Rechnung',
    ID_CARD: 'Personalausweis',
    RESIDENCE_CONFIRMATION: 'Wohnsitzbestätigung',
    BANK_STATEMENT: 'Kontoauszug',
    SDD_MANDATE: 'SEPA-Lastschriftmandat',
    COMPANY_REGISTRATION: 'Firmenregistrierung',
    ARTICLES_OF_ASSOCIATION: 'Gesellschaftsvertrag',
    ASSOCIATION_REGISTER_EXTRACT: 'Vereinsregisterauszug',
    LIST_OF_SHAREHOLDERS: 'Gesellschafterliste',
    ID_OF_BENEFICIAL_OWNERS: 'Pass des wirtschaftlichen Eigentümers (>25 %)',
    ID_OF_MANAGING_DIRECTOR: 'Pass des Geschäftsführers',
    PROOF_OF_AUTHORITY_TO_REPRESENT: 'Nachweis der Vertretungsbefugnis',
    KYC_OTHER: 'andere',

    // KYC Document Status
    KYC_DOC_STATUS_IN_PROGRESS: 'in Bearbeitung',
    KYC_DOC_STATUS_ON_HOLD: 'on hold',
    KYC_DOC_STATUS_ACCEPTED: 'akzeptiert',
    KYC_DOC_STATUS_NOT_ACCEPTED: 'abgelehnt',
    KYC_DOC_STATUS_UNREADABLE: 'unleserlich',
    KYC_DOC_STATUS_EXPIRED: 'abgelaufen',
    KYC_DOC_STATUS_WRONG_TYPE: 'falscher Typ',
    KYC_DOC_STATUS_WRONG_NAME: 'falscher Name',
    KYC_DOC_STATUS_DUPLICATE_DOCUMENT: 'doppeltes Dokument',

    // KYC FIELD RESTRICTION MODE
    SIMPLE_FIELD_RESTRICTION:
        'Einfache Feldbeschränkung (Name, Geburtsdatum, Staatsangehörigkeit, Geschlecht)',

    // Bank Account Status
    VERIFICATION_PENDING: 'in Bearbeitung',
    VERIFIED: 'verifiziert',
    REJECTED: 'abgelehnt',

    // MONEY WITHDRAWAL STATUS
    WITHDRAWAL_PENDING: 'Ausstehend',
    WITHDRAWAL_DONE: 'Abgeschlossen',
    WITHDRAWAL_REJECTED: 'Abgelehnt',

    WALLET_STATUS_SC: 'SC Wallet',
    WALLET_STATUS_NOT_OPENED: 'Nicht geöffnet',
    WALLET_STATUS_INCOMPLETE: 'Unvollständig',
    WALLET_STATUS_REJECTED: 'Abgelehnt',
    WALLET_STATUS_KYC1: 'KYC 1',
    WALLET_STATUS_KYC2: 'KYC 2',
    WALLET_STATUS_KYC3: 'KYC 3',
    WALLET_STATUS_EXPIRED: 'Abgelaufen',
    WALLET_STATUS_BLOCKED: 'Geblocked',
    WALLET_STATUS_CLOSED: 'Geschlossen',
    WALLET_STATUS_KYC_UPDATING_2_3: 'Updating von KYC 2 zu 3',
    WALLET_STATUS_ONE_TIME_CUSTOMER: 'Einmaliger Kunde',
    WALLET_STATUS_CROWDLENDING: 'Crowdlending Wallet',
    WALLET_STATUS_TECHNIQUE: 'Technique Wallet',
    WALLET_STATUS_UNDEFINED: 'Konto hat keine Wallet',

    // ACCOUNT TYPE
    LEGAL: 'legal',
    NATURAL: 'natural',

    // EXTERNAL KYC STATUS
    EXTERNAL_KYC_CREATED: 'Erstellt',
    EXTERNAL_KYC_PENDING: 'Ausstehend',
    EXTERNAL_KYC_IN_REVIEW: 'In Review',
    EXTERNAL_KYC_SUCCESS: 'Erfolgreich',
    EXTERNAL_KYC_DONE: 'Erledigt',
    EXTERNAL_KYC_FAILED_CANCELED: 'Fehlgeschlagen - Abgebrochen',
    EXTERNAL_KYC_FAILED_FRAUDULENT: 'Fehlgeschlagen - Betrugsverdacht',

    // ZAHLUNGSMETHODEN
    BANK_CARD: 'Bankkarte',
    INCOMING_WIRE_TRANSFER: 'Eingehende Überweisung',
    OUTGOING_WIRE_TRANSFER: 'Ausgehende Überweisung',
    P2P: 'P2P',
    IDEAL: 'iDEAL',
    SEPA_DIRECT: 'SEPA Lastschrift',
    CHEQUE: 'Scheck',
    NEOSURF: 'Neosurf',
    SOFORT: 'SOFORT',
    PFS_PHYSICAL_CARD: 'PFS physische Karte',
    MULTIBANCO: 'Multibanco',
    PAYSHOP: 'Payshop',
    MB_WAY: 'MB WAY',
    POLISH_INSTANT_TRANSFER: 'Polnische Sofortüberweisung',
    PAGARE: 'Pagare',
    MOBILE_PAY: 'Mobile Pay',
    PAY_TRAIL: 'PayTrail',
    WE_CHAT: 'WeChat (über PayTend)',
    P24: 'P24',
    MONEY_IN_BY_TPE: 'Geld per TPE einziehen',
    TRUSTLY: 'Trustly',

    // OPEN BASKET STEPS
    STEP_1_INSTALMENT: 'Schritt 1 (CF - Raten)',
    STEP_1: 'Schritt 1',
    STEP_2: 'Schritt 2',
    STEP_3: 'Schritt 3',
    STEP_4: 'Schritt 4',

    // TRANSAKTIONSTYPEN
    MONEY_IN: 'Geldeingang',
    MONEY_OUT: 'Geldausgang',

    // INTERNE TRANSAKTIONSSTATUS
    SUCCESS_MONEY_IN_OUT_OR_PENDING_P2P: 'Erfolgreich',
    SUCCESS_P2P_OR_MONEY_IN_OUT_ERROR: 'Erfolgreich',
    TRANSACTION_ERROR: 'Fehlerhaft',
    CANCELLED: 'Abgebrochen',
    WAIT_FOR_VALIDATION_FINALIZATION: 'Ausstehend',
    // E-Mails
    EMAIL_TEMPLATE_WELCOME: 'Willkommen',
    EMAIL_TEMPLATE_KYC_ACCEPTED: 'KYC - Accepted',
    EMAIL_TEMPLATE_CHECK_REQUESTED_MEMBERSHIP_DOCUMENTS:
        'Angeforderte Mitgliedsdokumente',
    EMAIL_TEMPLATE_MEMBERSHIP_DOCUMENT_ACCEPTED:
        'Mitgliedsdokument wurde akzeptiert',
    EMAIL_TEMPLATE_MEMBERSHIP_DOCUMENT_REMINDER: 'Mitgliedsdokument-Erinnerung',
    EMAIL_TEMPLATE_NEWSLETTER_CONSENT: 'E-Mail-Abonnementbestätigung',
    EMAIL_TEMPLATE_CONSUMER_INFORMATION: 'Kunden Information',
    EMAIL_TEMPLATE_GIFT_CONSUMER_INFORMATION: 'Geschenk Kunden Information',
    EMAIL_TEMPLATE_ACCEPTANCE_NOTICE: 'Annahmeerklärung',
    EMAIL_TEMPLATE_PAYMENT_CONFIRMATION: 'Bezahlungsbestätigung',
    EMAIL_TEMPLATE_PAYMENT_DETAILS: 'Bezahlungsdetails',
    EMAIL_TEMPLATE_PAYMENT_REMINDER: 'Bezahlungserinnerung',
    EMAIL_TEMPLATE_SAVINGS_PLAN_PAYMENT_REMINDER:
        'Ansparplan bezahlungserinnerung',
    EMAIL_TEMPLATE_KYC_REMINDER: 'KYC-Erinnerung',
    EMAIL_TEMPLATE_KYC_STATUS: 'KYC-Statusbenachrichtigung',
    EMAIL_TEMPLATE_KYC_EXPIRE_REMINDER: 'KYC Ablauf Erinnerung',
    EMAIL_TEMPLATE_BASKET_REMINDER_ONE: 'Offene Bestellung-Erinnerung 1',
    EMAIL_TEMPLATE_BASKET_REMINDER_TWO: 'Offene Bestellung-Erinnerung 2',
    EMAIL_TEMPLATE_AUTH_EMAIL_ADDRESS_CHANGED:
        'E-Mail-Änderung Benachrichtigung',
    EMAIL_TEMPLATE_AUTH_EMAIL_VERIFICATION: 'E-Mail-Änderung Verifikation',
    EMAIL_TEMPLATE_BANK_ACCOUNT_INFORMATION_REMINDER: 'IBAN-Reminder',
    EMAIL_TEMPLATE_PRE_CONSUMER_INFORMATION: 'Pre-Kundeninformation',
    EMAIL_TEMPLATE_SIGNATURE_REMINDER: 'Signatur-Erinnerung',
    EMAIL_TEMPLATE_SIGNATURES_REGENERATED: 'Signatur regeneriert',
    EMAIL_TEMPLATE_SIGNATURE_SUCCESSFUL: 'Signatur erfolgreich',
    EMAIL_TEMPLATE_EXTERNAL_KYC_STATUS_PENDING:
        'Externe KYC-Statusbenachrichtigung - Ausstehend',
    EMAIL_TEMPLATE_EXTERNAL_KYC_STATUS_SUCCESS:
        'Externe KYC-Statusbenachrichtigung - Erfolg',
    EMAIL_TEMPLATE_EXTERNAL_KYC_PROCESS_ABORTED:
        'Externer KYC-Prozess abgebrochen',
    EMAIL_TEMPLATE_MONEY_WITHDRAWAL_VERIFICATION: 'Auszahlung - Bestätigung',
    EMAIL_TEMPLATE_INTEREST_PAYMENT_ANNOUNCEMENT: 'Zinszahlung - Ankündigung',
    EMAIL_TEMPLATE_INTEREST_PAYMENT_PAYOUT_RECEIVED:
        'Zinszahlung - Auszahlung erhalten',
    EMAIL_TEMPLATE_EMPTY_OPTION: 'Keine E-Mail Vorlage',
    EMAIL_TEMPLATE_VOUCHER_RECEIVED: 'Voucher Erhalten',
    EMAIL_TEMPLATE_NO_IBAN_REMINDER: 'Ad-hoc IBAN-Reminder',
    EMAIL_TEMPLATE_FEEDBACK_REVIEW: 'Feedback / Bewertung',
    EMAIL_TEMPLATE_VOUCHER_BALANCE: 'Voucher Guthaben Benachrichtigung',
    EMAIL_TEMPLATE_WALLET_BALANCE: 'Wallet Guthaben Benachrichtigung',
    EMAIL_TEMPLATE_ORDER_CANCELLED:
        'Investition storniert (Benachrichtigung an Empfänger)',
    EMAIL_TEMPLATE_ORDER_CANCELLED_INVESTOR_CONFIRMATION:
        'Investition storniert (Bestätigung an Investor)',
    EMAIL_TEMPLATE_CORPORATE_ACCOUNT_CREATED: 'Unternehmenskonto erstellt',
    EMAIL_TEMPLATE_CORPORATE_DOCUMENTS_SUBMITTED:
        'Unternehmensdokumente eingereicht',

    EMAIL_TEMPLATE_SM_BUYER_PAYMENT_PAID:
        'Zahlung des Käufers eingegangen (SM)',
    EMAIL_TEMPLATE_SM_BUY_REQUEST_EXPIRED: 'Kaufanfrage abgelaufen (SM)',
    EMAIL_TEMPLATE_SM_BUY_REQUEST_RECEIVED: 'Neue Kaufanfrage erhalten (SM)',
    EMAIL_TEMPLATE_SM_CHAT_MESSAGE: 'Neue Chat-Nachricht (SM)',
    EMAIL_TEMPLATE_SM_LISTING_CANCELLED: 'Verkaufsangebot abgebrochen (SM)',
    EMAIL_TEMPLATE_SM_LISTING_EXPIRED: 'Verkaufsangebot abgelaufen (SM)',
    EMAIL_TEMPLATE_SM_OFFER_ACCEPTED: 'Kaufangebot angenommen (SM)',
    EMAIL_TEMPLATE_SM_OFFER_RECEIVED: 'Neues Kaufangebot erhalten (SM)',
    EMAIL_TEMPLATE_SM_OFFER_REJECTED: 'Kaufangebot abgelehnt (SM)',
    EMAIL_TEMPLATE_SM_OFFER_EXPIRED: 'Kaufangebot abgelaufen (SM)',
    EMAIL_TEMPLATE_SM_SIGN_PROCESS_COMPLETED:
        'Signaturprozess abgeschlossen (SM)',
    EMAIL_TEMPLATE_SM_TRANSACTION_COMPLETED:
        'Transaktion erfolgreich abgeschlossen (SM)',
    EMAIL_TEMPLATE_SM_TRANSACTION_FAILED: 'Transaktion fehlgeschlagen (SM)',
    EMAIL_TEMPLATE_SM_TRANSACTION_WAITING_FOR_APPROVAL:
        'Wartet auf Freigabe (SM)',

    EPC: 'EPC',
    SWISS: 'Swiss',

    // Platform Policies
    TERMS_OF_SERVICE: 'Nutzungsbedingungen',
    COOKIE_POLICY: 'Cookie-Richtlinie',

    // Cookie Consent Service Categories
    ESSENTIAL: 'Essenziell',
    FUNCTIONAL: 'Funktional',
    MARKETING: 'Marketing',
    EXTERNAL_MEDIA: 'Externe Medien',

    // Cookie Consent Service Provider Keys
    CONDA: 'CONDA',
    ZOHO: 'Zoho',
    ZOHO_BOOKINGS: 'Zoho Bookings',
    ZOHO_SURVEY: 'Zoho Survey',
    ZOHO_PAGESENSE: 'Zoho PageSense',
    ZOHO_FORMS: 'Zoho Forms',
    JENTIS: 'Jentis',
    HOTJAR: 'Hotjar',
    GOOGLE_ANALYTICS: 'Google Analytics',
    GOOGLE_ADS_CONVERSIONS: 'Google Ads Conversions',
    GOOGLE_ANALYTICS_AUDIENCES: 'Google Analytics Audiences',
    GOOGLE_ADS_REMARKETING: 'Google Ads Remarketing',
    META_PIXEL: 'Meta Pixel',
    TWITTER_TAG: 'Twitter/X Tag',
    LINKEDIN_INSIGHT: 'LinkedIn Insight',
    FACEBOOK: 'Facebook',
    INSTAGRAM: 'Instagram',
    GOOGLE_MAPS: 'Google Maps',
    OPEN_STREET_MAP: 'OpenStreetMap',
    VIMEO: 'Vimeo',
    X_EMBED: 'X Embed',
    YOUTUBE: 'YouTube',
    TRUST_INDEX: 'Trust Index',

    // Asset Categories
    STARTUP: 'Startup',
    SME: 'SME',
    REAL_ESTATE: 'Real Estate',
    SPECIAL: 'Special',
    STOCK_EMISSION: 'Stock Emission',

    // AssetClass
    PARTICIPATION_CERT: 'Partizipationsschein',
    COOPERATIVE_SHARE: 'Genossenschaftsanteil',
    PROFIT_PARTICIPATION: 'Genussschein',
    PROFIT_PARTICIPATION_SPV: 'Indirekte Beteiligung',
    BOND: 'Anleihe',
    CONVERTIBLE_BOND: 'Wandelanleihe',
    SUBORDINATED_LOAN: 'Nachrangdarlehen',

    // AssetRegulation
    FINMA: 'FINMA',
    STANDORTFOEG: 'StaFöG',

    // TransferRestriction
    NONE: 'Keine',
    VINCULATION: 'Vinkulierung',
    LOCKUP: 'Lock-up',

    // SpvLegalForm
    GMBH: 'GmbH',
    AG: 'AG',
    TRUST: 'Trust',

    // IssuerIndustry
    AGRICULTURE: 'Landwirtschaft',
    ENERGY_AND_UTILITIES: 'Energie und Versorgungsunternehmen',
    MINING: 'Bergbau',
    CONSTRUCTION: 'Baugewerbe',
    INDUSTRY: 'Industrie',
    TRADE_AND_RETAIL: 'Handel und Einzelhandel',
    HOSPITALITY_AND_TOURISM: 'Gastgewerbe und Tourismus',
    TRANSPORTATION_AND_LOGISTICS: 'Transport und Logistik',
    FINANCE_AND_INSURANCE: 'Finanzen und Versicherungen',
    INFORMATION_TECHNOLOGY: 'Informationstechnologie',
    HEALTHCARE: 'Gesundheitswesen',
    EDUCATION_AND_RESEARCH: 'Bildung und Forschung',

    // IssuerStatus
    ACTIVE: 'Aktiv',
    INACTIVE: 'Inaktiv',
    IN_LIQUIDATION: 'In Liquidation',
    INSOLVENT: 'Insolvent',
    BUSINESS_LICENSES_DELETED: 'Gewerbeberechtigungen gelöscht',

    // IssuerStatusInternal
    //ACTIVE: 'Aktiv',
    //INACTIVE: 'Inaktiv',
    SETTLED: 'Beendet',
    UNDER_OBSERVATION: 'Unter Beobachtung',

    //AssetSubStatus
    REPORTING_DELAY: 'Verzug im Reporting',
    PAYMENT_OUTSTANDING: 'Zahlung Ausständig',
    REPAID: 'Zurückbezahlt',
    EARLY_REPAYMENT: 'Vorzeitig Zurückbezahlt',

    //MinimumInvestmentType
    SHARES: 'Aktien',
    AMOUNT: 'Betrag',

    //StockType
    REGISTERED_SHARES: 'Namensaktien',
    BEARER_SHARES: 'Inhaberaktien',
    COMMON_SHARES: 'Stammaktien',
    PREFERRED_SHARES: 'Vorzugsaktien',

    // AgioDisagioType
    PERCENT: 'Percent',
    FIXED_VALUE: 'Fixed value',
    FIXED_VALUE_PER_SHARE: 'Fixed value per share',

    // CampaignUseOfFundsBadge
    EXCLUDED: 'Ausgeschlossen',
    REDUCED: 'Reduziert',
    INCREASED: 'Erhöht',

    // NaturalProfileActive
    NATURAL_PROFILE_ACTIVE: 'Natürliche Person aktiv',
    NATURAL_PROFILE_DEACTIVATED: 'Natürliche Person deaktiviert',

    // VoucherType
    GIFT_VOUCHER: 'Voucher',
    LOYALTY_CARD: 'Kundenkarte',
    DISCOUNT_VOUCHER: 'Gutschein',

    // MembershipDocumentStatusType
    REQUESTED: 'Angefordert',
    SENT: 'Gesendet',

    // End of Enums //

    // Languages
    de: 'Deutsch',
    en: 'Englisch',
    fr: 'Französisch',
    it: 'Italienisch',
    pl: 'Polnisch',
    sl: 'Slowenisch',
    sk: 'Slowakisch',
    sr: 'Serbisch',

    // New translations
    help_platform_logo: 'Das Plattform Logo',
    active_emails: 'Aktive Emails',
    mail_active_acceptance_notice: 'Annahmeerklärung',
    help_mail_active_acceptance_notice:
        'Ausgehende E-Mail bezüglich der Annahmeerklärung.',
    mail_active_bank_account_information_reminder: 'IBAN Erinnerung',
    help_mail_active_bank_account_information_reminder:
        'Ausgehende E-Mail bezüglich eines fehlenden IBAN.',
    mail_active_basket_reminder: 'Offene Bestellung - Erinnerung',
    help_mail_active_basket_reminder:
        'Ausgehende E-Mail bezüglich einer offenen Bestellung.',
    mail_active_consumer_information: 'Kundeninformation',
    help_mail_active_consumer_information:
        'Ausgehende E-Mail mit Kundeninformationen.',
    mail_active_gift_consumer_information: 'Geschenk Kundeninformation',
    help_mail_active_gift_consumer_information:
        'Ausgehende E-Mail mit Geschenk Kundeninformationen.',
    mail_active_external_kyc_status_pending:
        'Externe KYC-Statusbenachrichtigung - Ausstehend',
    help_mail_active_external_kyc_status_pending:
        'Ausgehende E-Mail bezüglich eines ausstehenden externen KYC-Status.',
    mail_active_external_kyc_status_success:
        'Externe KYC-Statusbenachrichtigung - Erfolg',
    help_mail_active_external_kyc_status_success:
        'Ausgehende E-Mail bezüglich eines erfolgreichen externen KYC-Status.',
    mail_active_external_kyc_process_aborted:
        'Externer KYC-Prozess abgebrochen',
    help_mail_active_external_kyc_process_aborted:
        'Ausgehende E-Mail bezüglich eines abgebrochenen externen KYC-Prozesses.',
    mail_active_kyc_expire_reminder: 'KYC Ablauf Erinnerung',
    help_mail_active_kyc_expire_reminder:
        'Ausgehende E-Mail zur Erinnerung an ein bald ablaufendes KYC Dokument.',
    mail_active_interest_payment_announcement: 'Zinszahlung - Ankündigung',
    help_mail_active_interest_payment_announcement:
        'Ausgehende E-Mail bezüglich einer Zinszahlung.',
    mail_active_interest_payment_payout_received:
        'Zinszahlung - Auszahlung erhalten',
    help_mail_active_interest_payment_payout_received:
        'Ausgehende E-Mail bezüglich einer Zinszahlung.',
    mail_active_kyc_reminder: 'KYC-Erinnerung',
    help_mail_active_kyc_reminder:
        'Ausgehende E-Mail bezüglich eines ausstehenden KYC Prozess.',
    mail_active_kyc_status: 'KYC-Statusbenachrichtigung',
    help_mail_active_kyc_status:
        'Ausgehende E-Mail bezüglich einer KYC-Statusbenachrichtigung.',
    mail_active_no_iban_reminder: 'Ad-hoc IBAN-Reminder',
    help_mail_active_no_iban_reminder:
        'Ausgehende E-Mail bezüglich eines fehlenden IBAN.',
    mail_active_payment_confirmation: 'Zahlungsbestätigung',
    help_mail_active_payment_confirmation:
        'Ausgehende E-Mail bezüglich einer Bezahlungsbestätigung.',
    mail_active_payment_details: 'Bezahlungsdetails',
    help_mail_active_payment_details:
        'Ausgehende E-Mail bezüglich der Bezahlungsdetails.',
    mail_active_payment_reminder: 'Bezahlungserinnerung',
    help_mail_active_payment_reminder:
        'Ausgehende E-Mail bezüglich einer Bezahlungserinnerung.',
    mail_active_pre_consumer_information: 'Pre-Kundeninformation',
    help_mail_active_pre_consumer_information:
        'Ausgehende E-Mail mit Pre-Kundeninformationen.',
    mail_active_signature_reminder: 'Signatur-Erinnerung',
    help_mail_active_signature_reminder:
        'Ausgehende E-Mail bezüglich einer Signatur-Erinnerung.',
    mail_active_signature_successful: 'Signatur erfolgreich',
    help_mail_active_signature_successful:
        'Ausgehende E-Mail bezüglich einer erfolgreichen Signatur.',
    mail_active_signatures_regenerated: 'Signatur regeneriert',
    help_mail_active_signatures_regenerated:
        'Ausgehende E-Mail bezüglich einer regenerierten Signatur.',
    mail_active_voucher_received: 'Voucher erhalten',
    help_mail_active_voucher_received:
        'Ausgehende E-Mail bezüglich eines erhaltenen Vouchers.',
    mail_active_welcome: 'Willkommen',
    help_mail_active_welcome:
        'Ausgehende E-Mail bezüglich einer Willkommensmail.',
    mail_active_feedback_review: 'Feedback / Bewertung',
    help_mail_active_feedback_review: 'Anfrage um Feedbck nach Investition.',
    mail_active_voucher_balance: 'Voucher Guthaben Benachrichtigung',
    help_mail_active_voucher_balance:
        'Info über frei verfügbares Voucher Guthaben.',
    mail_active_wallet_balance: 'Wallet Guthaben Benachrichtigung',
    help_mail_active_wallet_balance:
        'Info über frei verfügbares Wallet Guthaben.',

    digital_signature_types: 'Digitale Signaturmethode',
    help_digital_signature_types:
        'Signaturmethode, mit der Investor:innen unterschreiben müssen. Leer lassen, um jede Methode zuzulassen.',
    require_qualified_signature: 'Qualifizierte elektronische Signatur (QES)',
    require_advanced_qualified_signature:
        'Fortgeschrittene elektronische Signatur (AES)',

    qr_code_type: 'QR-Code Typ',
    payment_qr_code_type: 'Zahlungs QR-Code Typ',
    help_payment_qr_code_type: 'Der QR-Code Typ',

    payment_methods: 'Zahlungsmethoden',
    credit_card: 'Kreditkarte',
    wire_transfer: 'Banküberweisung',

    confirm_kyc_company_details: 'Bestätige KYC Firmendetails',
    reject_kyc_company_details: 'Ablehnen KYC Firmendetails',
    toast_success_update_legal_profile_kyc_legal_confirmed: 'KYC bestätigt',
    toast_success_update_legal_profile_kyc_legal_rejected: 'KYC abgelehnt',
    toast_error_update_legal_profile_kyc_legal:
        'KYC status Aktualisierung fehlgeschlagen',

    help_order_documents_table: 'Der Bestellung anhängende Dokumente.',
    help_order_reporting_documents_table:
        'Reporting Dokumente die Bestellung betreffend.',
    help_kyc_id_documents: 'Die KYC ID Dokumente.',
    help_kyc_address_documents: 'Die KYC Melde Dokumente.',
    help_kyc_bank_documents: 'Die KYC Bank Dokumente.',
    help_kyc_tax_documents: 'Die KYC Steuer Dokumente.',
    help_kyc_legal_documents:
        'KYC Dokumente zur Prüfung der Unternehmensdaten.',
    esac_kyc: 'ESAC KYC',
    esac_kyc_active: 'Esac KYC aktiv',
    help_esac_kyc_active: 'Aktivieren KYC mit ESAC',
    esac_form_natural_person: 'ESAC Formular für natürliche Personen',
    esac_form_legal_entity: 'ESAC Formular für juristische Personen',
    esac_form_legal_ubo: 'ESAC Formular für UBO',
    modal_title_delete_file: 'Dateien löschen?',
    modal_text_delete_file:
        'Sind Sie sicher, dass Sie die Datei {file} löschen möchten?',

    mail_type_standard: 'Standard',
    mail_template_color: 'Email Farbe',
    help_mail_template: 'Das zu verwendende E-Mail Template.',
    help_mail_template_color: 'Generelle Farbe der Plattform Emails.',
    primary_color: 'Primärfarbe',
    help_primary_color: 'Die Hauptfarbe des Plattform-Themes.',
    badge_colors: 'Badge-Farben',
    help_badge_colors:
        'Farben für die Regulierungs- und "Gebundener Vermittler"-Badges/Rahmen auf den Kampagnen-Karten.',
    badge_color_ecsp: 'ECSP',
    help_badge_color_ecsp: 'Badge-/Rahmenfarbe für die Regulierung ECSP.',
    badge_color_vermanlg: 'AltFG & VermAnlG',
    help_badge_color_vermanlg:
        'Badge-/Rahmenfarbe für die Regulierung AltFG & VermAnlG.',
    badge_color_finma: 'FINMA',
    help_badge_color_finma: 'Badge-/Rahmenfarbe für die Regulierung FINMA.',
    badge_color_standortfoeg: 'StaFöG',
    help_badge_color_standortfoeg:
        'Badge-/Rahmenfarbe für die Regulierung StaFöG.',
    badge_color_tied_agent: 'Gebundener Vermittler',
    help_badge_color_tied_agent:
        'Badge-/Rahmenfarbe für das Merkmal "Gebundener Vermittler".',
    mail_template_action_button_color: 'Email Action Button Farbe',
    help_mail_template_action_button_color:
        'Die Action Button Farbe für Plattform Emails.',
    mail_template_action_button_text_color: 'Email Action Button Text Farbe',
    help_mail_template_action_button_text_color:
        'Die Action Button Text Farbe für Plattform Emails.',

    is_realm: 'Realm',
    is_platform: 'Plattform',

    platform_assets: 'Plattform Vermögenswerte',
    help_platform_assets: 'Die Vermögenswerte der Plattform',
    toast_success_delete_asset: 'Vermögenswert erfolgreich gelöscht',
    platform_campaigns: 'Plattform Kampagnen',
    help_platform_campaigns: 'Die Kampagnen der Plattform',
    toast_success_delete_campaign: 'Kampagne erfolgreich gelöscht',
    platform_orders: 'Plattform Bestellungen',

    asset_video: 'Video URL',
    help_asset_video: 'Die Video URL der Kampagne.',
    help_campaign_og_title:
        'Überschreibt den Titel für Social-Media-Vorschauen. Wird bei leerem Feld vom Titel übernommen.',
    help_campaign_og_description:
        'Überschreibt die Beschreibung für Social-Media-Vorschauen. Wird bei leerem Feld vom Kurztext übernommen.',

    toast_success_delete_task: 'Aufgabe erfolgreich gelöscht',

    toast_success_delete_asset_contract: 'Vertrag erfolgreich gelöscht',

    acceptance_document: 'Akzeptanz Dokument',
    acceptance_document_active: 'Aktivieren Sie das Akzeptanz Dokument',
    acceptance_round: 'Annahmerunde',
    acceptance_round_label:
        'Annahme – {date} ({count} Bestellung(en), {amount})',
    help_no_open_acceptance_round:
        'Noch keine offene Annahmerunde für dieses Asset — zuerst Annahme durchführen.',
    mark_acceptance_round_done: 'Diese Runde ist abgeschlossen',
    help_acceptance_document:
        'Das Akzeptanz Dokument wird bei der Annahme von Investments automatisch an die Investor*innen versendet.',
    help_acceptance_document_active:
        'Wenn diese Funktion aktiviert ist, kann ein Annahmedokument hochgeladen und bearbeitet werden.',
    help_platform_orders: 'Die Bestellungen der Plattform.',
    no_signature_link_available: 'Kein Signatur Link verfügbar',
    country_of_residence: 'Wohnort',
    natural_profile_uid: 'Natural Profile UID',
    legal_profile_uid: 'Legal Profile UID',

    upload: 'Hochladen',

    account_pep_past: 'PEP Vergangenheit',
    account_pep_position: 'PEP Position',
    help_account_pep_position:
        'Die Position, welche die politisch exponiert Person innehat.',
    account_pep_past_position: 'PEP Vergangene Position',
    help_account_pep_past_position:
        'Die Position, welche die politisch exponierte Person innehatte.',

    modal_title_duplicate_campaign: 'Duplicate campaign',

    expand: 'Vergrößern',
    collapse: 'Verkleinern',

    tasks: 'Tasks',
    help_tasks_table: 'Die Tasks Tabelle',
    taskable: 'Entität',
    result_data: 'Ergebnis',
    result_text: 'Ergebnis Text',
    expires_at: 'Läuft ab',
    download: 'Download',

    // Task Type
    GENERIC: 'Generic',
    INTEREST_PAYMENT_CALCULATION: 'Interest payment calculation',
    INTEREST_PAYMENT_PAYOUT: 'Interest payment payout',
    PAYMENT_ACCEPTANCE: 'Payment acceptance',
    NYALA_RETRIEVE_REGISTRY_EXTRACT: 'Nyala-Registerauszug herunterladen',
    NYALA_CREATE_REGISTRY_EXTRACT: 'Nyala-Registerauszug erstellen',
    NYALA_TRANSFER_TOKEN: 'Nyala-Token übertragen',
    EXPORT_CSV: 'Export CSV',
    EXPORT_XLSX: 'Export XLSX',
    UPLOAD_ASSET_INVESTMENT_REPORT: 'Vermögenswert investment report upload',
    UPLOAD_ASSET_SECONDARY_MARKET_IMPORT: 'Secondary Market Asset import',
    EXCLUSIVE_ACCEPTANCE: 'Exklusive Annahme',
    EXPORT_SIGNED_DOCUMENTS: 'Unterschriftendokumente exportieren',
    EXPORT_INVESTOR_KYC_FOLDER: 'KYC-Ordner exportieren',
    SYNC_NYALA_INVESTMENT: 'Sync Nyala-Investition',
    EXPORT_INTEREST_PAYMENT_SEPA_CSV: 'Export Interest payment SEPA CSV',
    EXPORT_INTEREST_PAYMENT_EXCEL: 'Export Interest payment Excel',
    ASSET_ORDERS_SET_PAID: 'Bulk Bestellstatus auf Bezahlt setzen',
    ASSET_ORDERS_SET_PENDING: 'Bulk Bestellstatus auf Ausstehend setzen',
    RELEASE_FUNDS: 'Release Funds',
    SEND_OPT_INS: 'Send Opt-Ins',
    UPDATE_STAKEHOLDER_AMOUNT: 'Stakeholder-Betrag aktualisieren',

    // TaskStatus
    REGISTERED: 'Registriert',
    STARTED: 'Begonnen',
    FINISHED: 'Beendet',
    issuer: 'Emittent',
    issuers: 'Emittenten',
    issuer_name: 'Name',
    issuer_logo: 'Logo',
    issuer_website: 'Webseite',
    internal_status: 'Interner Status',
    issuer_details: 'Emittenten-Daten',
    toast_error_cannot_delete_issuer: 'Emittent kann nicht entfernt werden!',
    toast_success_issuer_deleted: 'Emittent "{issuer}" wurde entfernt.',
    toast_success_issuers_deleted: 'Emittenten "{issuers}" wurden entfernt.',
    toast_success_issuer_created: 'Emittent wurde erstellt!',
    help_issuers_table:
        'Die Liste der Emittenten auf die Sie zugreifen können.',
    modal_title_delete_issuer: 'Emittent löschen?',
    create_issuer: 'Emittenten erstellen',
    help_issuer: 'Emittent des Vermögenswerts',
    help_issuer_name: 'Der Name des Emittenten.',
    help_issuer_logo: 'Das Unternehmens-Logo des Emittenten.',
    issuer_status: 'Status',
    help_issuer_status: 'Der Status des Emittenten.',
    issuer_internal_status: 'Interner Status',
    help_issuer_internal_status: 'Der interne Status des Emittenten.',
    issuer_industry: 'Industrie',
    help_issuer_industry: 'Die Industrie des Emittenten.',
    toast_success_issuer_saved:
        'Emittenten {issuer} wurde erfolgreich gespeichert!',

    toast_success_export_csv:
        'Der CSV Export wird im Hintergrund erstellt. Sie werden das Ergebnis in der "Tasks" Sektion sehen, sobald dieser fertig ist.',
    toast_success_kyc_folder_export:
        'KYC-Ordner-Export gestartet. Sie werden das Ergebnis in der "Tasks" Sektion sehen, sobald dieser fertig ist.',
    toast_success_upload_csv:
        'Der CSV Upload wird im Hintergrund erstellt. Sie werden das Ergebnis in der "Tasks" Sektion sehen, sobald dieser fertig ist.',
    platform_investor_qualification: 'Anlegerqualifikation',
    end_contract: 'Beenden',
    modal_title_end_contract: 'Vertrag beenden?',
    modal_text_end_contract:
        'Sind Sie sicher, dass Sie diesen Vertrag vorzeitig beenden möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    contract_end_cause: 'Begründung',
    help_contract_end_cause: 'Begründung der vorzeitige Beendigung',
    toast_success_end_contract: 'Vertrag wurde erfolgreich vorzeitig beendet.',

    help_signatures_table: 'Die Signaturen.',

    beneficial_owners: 'Wirtschaftliche Eigentümer',
    help_beneficial_owners: 'Die Wirtschaftliche Eigentümer',
    show_signatures: 'Signaturen anzeigen',
    toast_success_cancel_order: 'Bestellung {order} erfolgreich abgebrochen!',

    help_open_basket_table:
        'Hier werden nicht abgeschlossene Bestellungen angezeigt',
    export_transactions: 'Transaktionen exportieren',
    toast_success_export_transactions:
        'Transaktionen wurden erfolgreich exportiert!',
    export_kista_request: 'KISTA Anfrage exportieren',
    export_membership_documents: 'Mitgliedsdokumente exportieren',
    export_order_transfer_history: 'Übertragungsverlauf exportieren',
    toast_success_export_kista_request: 'KISTA Anfrage erfolgreich exportiert',
    toast_success_kista_response_import:
        'KISTA Antwort erfolgreich importiert. Erzeugte Steuermerkmale: {newTaxFeaturesCount}',
    upload_kista_response: 'KISTA Antwort-CSV hochladen',

    modal_title_task_details: 'Task details',

    total_count: 'Total count',
    error_count: 'Error count',
    modal_title_duplicate_cash_contract: 'Vertrag kopieren',
    modal_text_duplicate_cash_contract: 'Vertrag kopieren?',

    has_orders: 'Has orders',

    copy_value: 'Wert kopieren',
    toast_success_copy_to_clipboard: 'Wert wurde in die Ablage kopiert!',
    toast_clipboard_manual_copy:
        'Zwischenablage nicht verfügbar. Bitte den Link manuell kopieren: {url}',
    toast_error_copy_to_clipboard:
        'Kopieren fehlgeschlagen. Bitte versuchen sie es erneut.',
    order_paid_date: 'Bezahlt am',
    order_acceptance_date: 'Akzeptiert am',
    order_cancellation_date: 'Abgebrochen am',

    need_help: 'Brauchen Sie Hilfe?',
    documentation: 'Dokumentation',
    report_a_bug: 'Bugreport senden',
    give_feedback: 'Feedback geben',

    resend_mail: 'E-Mail erneut senden',
    modal_title_resend_mail: 'E-Mail erneut senden?',
    help_resend_mail: 'Wählen Sie die E-Mail die sie erneut senden möchten.',

    is_main: 'Is main',

    modal_title_view_kyc_document: 'View KYC document.',
    modal_title_view_kyc_bank_document: 'View KYC Bank document.',

    created_by: 'Created by',
    payment_account_id: 'Payment account id',
    funding_total_status: 'Bestellstatus für Investitionssumme',
    webhooks_activated: 'Webhooks aktiviert',
    has_credential_simply_tokenized: 'Simply Tokenized Zugangsdaten',
    has_credential_sproof: 'Sproof Zugangsdaten',
    has_credential_voucherify: 'Voucherify Zugangsdaten',
    compliance_profile: 'Compliance Profile',
    expert_investor_treatment:
        'Als kundiger / professioneller Anleger behandelt werden?',

    updated_at: 'Bearbeitet am',
    investor_consent: 'Investor consent',
    contract_period: 'Contract period',
    asset_funding_count: 'Investitionen',
    asset_funding_total: 'Investitionssumme',
    asset_installment_investment: 'Teilzahlung',
    help_asset_installment_investment:
        'Wenn diese Funktion aktiviert ist, können die Optionen für Investitionen in die Anlage eingestellt werden',
    asset_initial_payment: 'Anfangszahlung',
    asset_installment_payout: 'Ratenzahlung',
    asset_minimum_initial_payment: 'Minimum Anfangszahlung',
    help_asset_minimum_initial_payment: 'Minimum Anfangszahlung',
    asset_maximum_initial_payment: 'Maximum Anfangszahlung',
    help_asset_maximum_initial_payment: 'Maximum Anfangszahlung',
    asset_initial_payment_step: 'Finanzierungsschritt',
    help_asset_initial_payment_step: 'Finanzierungsschritt',
    asset_installments: 'Teilzahlung',
    asset_minimum_installment: 'Minimum Teilzahlung',
    help_asset_minimum_installment: 'Minimum Teilzahlung',
    asset_maximum_installment: 'Maximum Teilzahlung',
    help_asset_maximum_installment: 'Maximum Teilzahlung',
    asset_installment_step: 'Finanzierungsschritt',
    help_asset_installment_step: 'Finanzierungsschritt',
    asset_minimum_monthly_rates: 'Min. Anzahl an Monatszahlungen',
    help_asset_minimum_monthly_rates: 'Min. Anzahl an Monatszahlungen',
    asset_maximum_monthly_rates: 'Max. Anzahl an Monatszahlungen',
    help_asset_maximum_monthly_rates: 'Max. Anzahl an Monatszahlungen',
    asset_minimum_yearly_rates: 'Min. Anzahl an Jahreszahlungen',
    help_asset_minimum_yearly_rates: 'Min. Anzahl an Jahreszahlungen',
    asset_maximum_yearly_rates: 'Max. Anzahl an Jahreszahlungen',
    help_asset_maximum_yearly_rates: 'Max. Anzahl an Jahreszahlungen',
    asset_monthly_payments: 'Monatszahlung',

    campaign_asset_needs_contract_selection: 'Asset needs contract selection',

    ended_at: 'Beendet am',
    payment_dates: 'Auszahlungstermine',
    confirmed: 'Bestätigt',

    last_login_date: 'Last login date',
    blocked_balance_from_orders: 'Blocked balance from orders',
    sso_user_uid: 'SSO User UID',
    custom_id: 'Custom id',
    sub_platform: 'Sub platform',
    email_pending: 'Email pending',
    mobile_number: 'Mobile number',
    newsletter_consent: 'Newsletter consent',
    help_contract_payment_dates_title: 'Bitte Auszahlungsdatum hinzufügen',
    help_contract_payment_dates_text:
        'Bitte geben Sie die Auszahlungsdaten an. Bitte beachten Sie, dass diese nach der ersten Auszahlung liegen müssen, und vor der letzten Auszahlung bei "Fixed" Verträgen.',

    installments: 'Installments',
    disabled_on: 'Deaktiviert am',
    current_loan_amount: 'Aktuelles Darlehen',
    paid_total: 'Gesamtsumme',
    paid_rest: 'Restbetrag',
    paid_bonus: 'Bonuszahlung',
    cumulative_rest: 'summierter Rest',
    current_rest: 'aktueller Rest',
    new_basis: 'Neue Basis',
    search: 'Search',
    global_search_placeholder: 'Global search...',
    more_search_results: 'View more results...',
    no_languages_available_for_this_email_template:
        'Keine Sprachen für diese E-Mail Vorlage verfügbar.',

    subtasks: 'Subtasks',

    ecsp_status: 'ECSP Status',
    uploaded_document: 'Hochgeladenes Dokument',
    ecsp_document: 'ECSP Dokument',
    ecsp_documents: 'ECSP Dokumente',
    ecsp_id_document: 'Hochgeladenes ECSP Dokument',
    verification_comment: 'Verifizierungskommentar',
    toast_error_ecsp_document_create:
        'ECSP document konnte nicht gespeichert werden!',
    toast_success_ecsp_document_updated:
        'ECSP document erfolgreich gespeichert!',
    button_id_ecsp_document_upload: 'ECSP Dokument hochladen',
    modal_title_create_id_ecsp_document:
        'ECSP Dokument zur Verifizierung hochladen.',
    help_ecsp_id_document:
        'In dieser Tabelle können Sie die mit dem Compliance Profile ECSP verknüpften ECSP Dokumente verwalten.',
    help_ecsp_status: 'Status der ECSP Verifizierung.',

    kyc_provider: 'KYC-Anbieter',
    kyc_settings: 'KYC Einstellungen',
    the_field_contains_unallowed_characters:
        'Das Feld enthält nicht zulässige Zeichen.',

    //St. Pauli
    membership_management: 'Mitgliederverwaltung',
    membership_management_active: 'Mitgliederverwaltung aktivieren',
    help_membership_management_active:
        'Wenn diese Option aktiviert ist, wird die Möglichkeit von Mitgliedschaften freigeschaltet.',
    help_membership_management:
        'Hier können die Einstellungen für Mitgliedschaften vorgenommen werden. Diese ermöglichen es Anlegern, Mitglied zu werden, indem sie eine Investition tätigen.',
    gift_membership: 'Mitgliedschaft schenkung',
    help_gift_membership:
        'Aktivieren Sie die Mitgliedschaft-schenkung funktionalität bei Bestellungen',
    gift_membership_faq: 'Mitgliedschaft schenkung FAQ',
    help_gift_membership_faq:
        'Hier können Sie den FAQ Text angeben, der im Investmentprozess beim Mitgliedschaft schenkung angezeigt werden soll.',
    gift_membership_faq_url: 'Mitgliedschaft schenkung FAQ URL',
    help_gift_membership_faq_url:
        'Diese URL wird unter Mitgliedschaft schenkung FAQ angezeigt.',
    membership_type_manual: 'Manuell',
    membership_type_sproof: 'Sproof',
    qualified_signature: 'Qualifizierte Signatur',
    help_qualified_signature: 'Qualifizierte Signatur aktivieren',
    use_rule: 'Regelwerk Annahme',
    help_use_rule:
        'Wenn dieser Schalter aktiviert ist, können nur Bestellungen von Investoren akzeptiert werden, die ein akzeptiertes Mitgliedsdokument haben.',
    order_certificate_active: 'Bestell Urkunde aktivieren',
    help_order_certificate_active: 'Aktivieren Sie die Bestell Urkunde',
    certificates_deleted: 'Zertifikate gelöscht',
    certificate_uploaded: 'Zertifikat hochgeladen',
    membership_number_active: 'Mitgliedsnummer aktivieren',
    help_membership_number_active:
        'Aktivieren Sie die Mitgliedsnummer bei Mitgliederverwaltung',
    membership_number_prefix_natural:
        'Mitgliedsnummer-Prefix für Natürliche Personen',
    help_membership_number_prefix_natural:
        'Sie können angeben, welcher Buchstabe mit der Mitgliedsnummer für Natürliche Personen beginnen soll',
    membership_number_prefix_legal:
        'Mitgliedsnummer-Prefix für Unternehmensprofile',
    help_membership_number_prefix_legal:
        'Sie können angeben, welcher Buchstabe mit der Mitgliedsnummer für Unternehmensprofile beginnen soll',
    help_membership_number: 'Mitgliedsnummer',
    membership_barcode_active: 'Barcode aktivieren',
    help_membership_barcode_active: 'Aktivieren Sie das Barcode funktionalität',
    upload_document: 'Dokument hochladen',
    membership_number: 'Mitgliedsnummer',
    membership_id_document: 'Hochgeladene Mitgliedsdokumente',
    help_membership_id_document:
        'Hier haben Sie die Möglichkeit, ein Mitgliedsdokument hochzuladen',
    modal_title_create_id_membership_document:
        'Neues Mitgliedsdokument hochladen',
    membership_document_description: 'Mitgliedsdokument Beschreibung',
    button_id_membership_document_upload: 'Dokument auswählen',
    modal_title_update_membership_document: 'Mitgliedsdokuement bearbeiten',
    membership_document_status: 'Status des Mitgliedsdokuments',
    membership_documents_admin_email: 'Mitgliedsdokuement Admin E-mail',
    help_membership_document_status:
        'Der Status des Mitgliedsdokuments kann 3 Werte haben: ausstehend, akzeptiert und abgelehnt',
    help_membership_document_description:
        'Hier können Sie eine Beschreibung für das Mitgliedsdokument eingeben. Wird für die Kunden in bereich Mitgliedsdokuement angezeigt. Dies soll den Kunden helfen, zu wissen, was mit dem Dokument zu tun ist.',
    help_membership_document:
        'Nach dem Hochladen erhält der Anleger ein Mitgliedschaftsdokument, wenn die Investitionen akzeptiert und bezahlt werden.',
    has_membership: 'Mitglied',
    hasnt_membership: 'Nicht mitglied',
    modal_title_view_membership_document: 'Mitgliedsdokument',
    toast_success_membership_document_updated:
        'Mitgliedsdokument wurde erfolgreich gespeichert!',
    toast_error_membership_document_updated:
        'Mitgliedsdokument konnte nicht gespeichert werden!',
    toast_error_platform_saving_membership_document_missing:
        'Plattform mit aktiver Mitgliederverwaltung ohne Mitgliedsdokument kann nicht gespeichert werden!',
    toast_success_membership_document_create:
        'Mitgliedsdokument wurde erfolgreich gespeichert!',
    toast_error_membership_document_create:
        'Mitgliedsdokument konnte nicht gespeichert werden!',
    toast_success_membership_document_approved:
        'Mitgliedsdokument wurde erfolgreich akzeptiert!',
    toast_error_membership_document_approved:
        'Mitgliedsdokument konnte nicht akzeptiert werden!',

    // Certificate
    order_certificate: 'Bestell Urkunde',

    retrieve_nyala_registry_extract: 'Registerauszüge herunterladen',
    modal_title_retrieve_nyala_registry_extract:
        'Registerauszüge herunterladen',
    create_nyala_registry_extract: 'Registerauszüge erstellen',
    modal_title_create_nyala_registry_extract: 'Registerauszüge erstellen',
    toast_success_create_nyala_registry_extract:
        'Erstellung des Registerauszugs bei Nyala gestartet. {log}',
    retrieve: 'Retrieve',
    toast_success_upload_asset_investment_report:
        'Investment report wurde erfolgreich hochgeladet.',
    send_nyala_registry_document_email: 'Send Nyala Registry Document email',
    modal_title_send_nyala_registry_document_email:
        'Send Nyala Registry Document email',
    toast_success_send_nyala_registry_document_email:
        'The Nyala Registry Document email was successfully sent.',
    update_stakeholder_amount: 'Stakeholder-Betrag aktualisieren',
    modal_title_update_stakeholder_amount: 'Stakeholder-Betrag aktualisieren',
    toast_error_closing_acceptance_rounds:
        'Runde(n) {rounds} konnte(n) nicht als abgeschlossen markiert werden. Sie können es erneut über die Liste der Annahmerunden versuchen.',
    send_opt_ins: 'Send Opt-Ins',
    modal_title_send_opt_ins: 'Send Opt-Ins',
    release_funds: 'Release Funds',
    modal_title_release_funds: 'Release Funds',
    modal_title_transfer_tokens: 'Token verteilen',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    days: 'Tage',
    hours: 'Stunden',
    minutes: 'Minuten',
    toast_success_kyc_processes_reset: 'KYC Prozesse wurden zurückgesetzt!',
    toast_success_fetch_identity_token:
        'Identity token wurde erfolgreich abgerufen.',
    toast_error_fetch_identity_token:
        'Identity token konnte nicht abgerufen werden!',
    toast_success_retrieve_nyala_registry_extract:
        'Nyala Registry Extract wurde erfolgreich heruntergeladet! {log}',
    toast_error_kyc_processes_reset:
        'KYC Prozesse konnten nicht zurückgesetzt werden!',
    EMAIL_TEMPLATE_NYALA_REGISTRY_FILE: 'Send Nyala Registry Documents',
    nyala_registry_documents: 'Nyala Registry Documents',
    nyala_registry_documents_help: 'The Nyala Registry Documents',
    nyala_registry_document: 'Nyala Registry Document',
    post_status: 'Lieferstatus',
    issuer_id: 'Emittent ID',
    asset_uid: 'Vermögenswert ID',
    campaign_id: 'Kampagnen ID',
    contract_uid: 'Vertrags ID',
    help_kyc_provider: 'Der KYC-Anbieter',
    external_kyc_active: 'Externes KYC aktiv',
    help_external_kyc_active: 'Der externe KYC aktiv',
    kyc_field_restriction_mode: 'KYC-Feld Sperrungsmodus',
    kyc_field_restriction_mode_no_restriction: 'Keine Einschränkung',
    help_kyc_field_restriction_mode:
        'Beschränkung die Bearbeitung identitätsbezogener Felder für Benutzer mit KYC-Verifizierung',
    api_host: 'API-Host',
    help_api_host: 'Der API-Host',
    redirect_host: 'Umleitungs-Host',
    help_redirect_host: 'Der Umleitungs-Host',
    customer: 'Kunde',
    help_customer: 'Der Kunde',
    api_key: 'API-Schlüssel',
    help_api_key: 'Der API-Schlüssel',
    signature_api_key: 'Zeichnung API-Schlüssel',
    help_signature_api_key: 'Der API-Schlüssel für Zeichnung',

    transfer_investment: 'Übertragung von Investitionen',
    help_transfer_investment:
        'Wenn diese Funktion aktiviert ist, können Nutzer akzeptierte Investitionen zwischen Investoren übertragen.',
    legal_profile: 'Legal profile',
    natural_profile: 'Natural profile',
    keep_original_order: 'Ursprüngliche Investition behalten.',
    is_gift: 'Geschenk',
    edit_file: 'Datei bearbeiten',
    success_edited_file_uploaded: 'Bearbeitete Datei erfolgreich hochgeladen',
    error_edited_file_uploaded:
        'Die bearbeitete Datei konnte nicht hochgeladen werden',
    no_placeholders_available: 'Keine Platzhalter vorhanden',
    show_placeholders_panel: 'Platzhalter anzeigen',
    apply_placeholders: 'Platzhalter anwenden',
    apply_placeholders_info:
        'Dies schließt den Editor und übernimmt Ihre Änderungen. \nSie können das Dokument jederzeit erneut bearbeiten.',
    membership_document: 'Mitgliedsdokument',
    certificate_document: 'Zertifikatdokument',
    transaction_message: 'Transaktionsnachricht',
    help_keep_original_order:
        'Ist diese Aktion ausgewählt, wir die ursprüngliche Investition abgebrochen und eine neue Investition erstellt. Das Zahlungsdatum und das Investitionsannahmedatum werden auf die aktuelle Zeit gesetzt. Die ursprüngliche Investition kann nur beibehalten werden, wenn die ursprüngliche Bestellung akzeptiert wurde.',
    help_transaction_message:
        'Ist die Plattform mit einem Payment Account verbunden und ist die Investition bezahlt, wird diese Nachricht an den Payment Provider gesendet, um die Investition zu übertragen. Diese Nachricht ist auch erforderlich, wenn die Investition ein Geschenk ist.',
    help_transfer_investment_account_title:
        'Bitte wählen Sie den Empfänger aus, dem das Investment übertragen werden soll.',
    transfer_order_success: 'Investition erfolgreich übertragen',
    profile_title: 'Profil-UID',
    help_transfer_investment_profile_title:
        'Bitte geben Sie die natürliche oder juristische Profil-UID ein, auf die die Investition übertragen werden soll.',
    bottom_help_funding_start:
        'Hinweis: Alle Zeiten müssen in UTC eingegeben werden. Das System berücksichtigt derzeit keine lokalen Zeitzonen. Bitte konvertieren Sie Ihre lokale Zeit vor der Eingabe in UTC. Ihre Zeit ist {utcOffset} von der UTC Zeit.',
    bottom_help_funding_end:
        'Hinweis: Alle Zeiten müssen in UTC eingegeben werden. Das System berücksichtigt derzeit keine lokalen Zeitzonen. Bitte konvertieren Sie Ihre lokale Zeit vor der Eingabe in UTC. Ihre Zeit ist {utcOffset} von der UTC Zeit.',
    bottom_help_funding_ahead: 'vorraus',
    bottom_help_funding_behind: 'zurück',
    nyala_project_tokenized_asset_id: 'Nyala Projekt Tokenized asset ID',
    help_nyala_project_tokenized_asset_id: 'Nyala Projekt Tokenized asset ID',
    nyala_project: 'Nyala Projekt',
    manage_nyala_project: 'Nyala Projekt verwalten',
    edit_nyala_project: 'Edit Nyala Projekt',
    nyala_project_external_tokenized_asset_id: 'Tokenized Vermögenswert ID',
    help_nyala_project_external_tokenized_asset_id:
        'Nyala Projekt Tokenized Vermögenswert ID',
    nyala_project_external_project_id: 'Externes Projekt ID',
    help_nyala_project_external_project_id: 'Nyala Projekt Externes Projekt ID',
    toast_success_nyala_project_connected_to_asset:
        'Nyala-Projekt erfolgreich mit Vermögenswerte verbunden!',
    toast_success_nyala_project_connected_to_contract:
        'Nyala-Projekt erfolgreich mit Vertrag verbunden!',
    all_contracts_connected_to_nyala_project:
        'Alle Verträge sind mit einem Nyala-Projekt verknüpft',
    contract_asset_connected_to_nyala_project:
        'Vermögenswerte mit Nyala-Projekt verbunden',
    detach_nyala_project: 'Nyala Projekt trennen',
    toast_success_nyala_project_detached_from_contract:
        'Nyala-Projekt erfolgreich von Vertrag getrennt!',
    unit_name: 'Einheit Name',
    help_unit_name: 'Der Name der Einheit',
    issuer_wallet_seed_id: 'Emittent Wallet Seed ID',
    help_issuer_wallet_seed_id: 'Die Emittent Wallet Seed ID',
    issuer_wallet_id: 'Emittent Wallet ID',
    help_issuer_wallet_id: 'Die Emittent Wallet ID',
    integration_passphrase: 'Integrationspasswort',
    help_integration_passphrase: 'Das Integrationspasswort',
    nyala_customer: 'Nyala Kunde',
    kyc_data_transfered: 'KYC Daten übertragen',
    external_customer_id: 'Externe Kunden ID',
    public_address: 'Öffentliche Adresse',
    retail_wallet_id: 'Retail Wallet ID',
    retail_wallet_status: 'Retail Wallet Status',
    nyala_project_custody_provider: 'Custody provider',
    help_nyala_project_custody_provider: 'Custody provider für nyala Projekt',
    save: 'Speichern',
    stock_details: 'Aktien Details',
    voting_rights_per_share: 'Stimmrechte pro Aktie',
    stock_emission_contract: 'Aktienemissionsvertrag',
    fetch_signteq_identity_token: 'Identity token abrufen',
    transmit_asset: 'Anteile Übertragen',
    modal_title_transmit_asset: 'Anteile Übertragen',
    transmit: 'Übertragen',

    // Taxes
    taxes: 'Steuern',
    create_tax: 'Steuer erstellen',
    tax_name: 'Steuerbezeichnung',
    tax_rate: 'Steuersatz',
    target: 'Ziel',
    base_value: 'Basiswert',
    tax_document: 'Steuer Dokument',
    delete_tax_question: 'Soll diese Steuer wirklich gelöscht werden?',
    toast_success_tax_created: 'Steuer erfolgreich erstellt!',
    toast_success_tax_updated: 'Steuer erfolgreich aktualisiert!',
    detach: 'Trennen',
    detach_nyala_project_modal_info:
        'Sind Sie sicher, dass Sie dieses Nyala-Projekt trennen möchten?',
    zoho_integration: 'Zoho Integration',
    workdrive_integration: 'WorkDrive Integration',
    workdrive_client_id: 'WorkDrive Client ID',
    workdrive_client_secret: 'WorkDrive Client Secret',
    workdrive_refresh_token: 'WorkDrive Refresh Token',
    workdrive_api_domain: 'WorkDrive API Domain',
    workdrive_team_folder_id: 'WorkDrive Team-Ordner ID',
    help_zoho_sync_enabled:
        'Wenn sie aktiviert ist, kann die Plattform mit Zoho synchronisiert werden.',
    zoho_sync_enabled: 'Zoho Integration aktiviert',
    inherited_from_parent: 'Von Elternelement geerbt',
    zoho_override_prompt: 'Möchten Sie überschreiben?',
    modal_title_send_email_template: 'Test Email senden',
    flatten_signature_placeholder_button: 'Signatur-Platzhalter fixieren',
    flatten_signature_placeholder_button_info:
        'Dies fixiert den Signatur-Platzhalter.\nEinmal fixiert, kann der Platzhalter nicht mehr verschoben oder gelöscht werden.',
    signature_placeholder_info:
        'Dies fügt dem Dokument einen Signatur-Platzhalter hinzu.\nNach dem Fixieren wird der Platzhalter durch ein Signteq-Signaturfeld ersetzt. \n\nPro Dokument ist nur ein Signatur-Platzhalter erlaubt.\n\nFixieren Sie den Signatur-Platzhalter, bevor Sie Ihre Änderungen speichern!\nNach dem Fixieren kann der Platzhalter nicht mehr verschoben oder gelöscht werden.',
    qr_code_placeholder_info:
        'Dies fügt dem Dokument einen QR-Code-Platzhalter hinzu. \nDas Platzhalterfeld wird durch einen QR-Code ersetzt. \nPro Dokument ist nur ein QR-Code-Platzhalter erlaubt.',
    standard_placeholder_info:
        'Dies fügt dem Dokument einen Platzhalter hinzu. \nDer Platzhalter wird durch den Wert des Feldes ersetzt.',

    // investment desk settings
    investment_desk_settings: 'Investment desk Einstellungen',
    use_new_theme: 'Neues Design verwenden',
    single_campaign_style: 'Einzelne Kampagnen-Stil',
    lock_details_tab: 'Details-Tab sperren',
    lock_documents_tab: 'Dokumente-Tab sperren',
    lock_investors_room_tab: 'Investoren-Raum-Tab sperren',
    show_tos_for_unauthenticated_users:
        'TOS für nicht authentifizierte Nutzer anzeigen',
    show_minimum_investment_instead_of_minimum_funding:
        'Mindestinvestition anstatt Mindestfinanzierung anzeigen',
    hide_percentage_on_knob: 'Prozentwert auf Knopf ausblenden',
    hide_funding_indicator_on_knob: 'Finanzierungsschalter anzeigen',
    hide_funding_max_on_knob: 'Max. Finanzierung auf Knopf ausblenden',
    show_dropdown_on_hover: 'Dropdown beim Hover anzeigen',
    hide_company_account: 'Unternehmenskonto ausblenden',
    hide_create_company_account: 'Unternehmenskonto erstellen ausblenden',
    hide_latest_investments: 'Letzte Investitionen ausblenden',
    show_language_select_menu_in_header: 'Sprachauswahl im Header anzeigen',
    onboarding_flow: 'Onboarding-Flow',
    use_v2_frontend: 'V2 Frontend verwenden',
    use_v2_frontend_investment_process:
        'V2 Frontend für Investitionsprozess verwenden',
    use_v2_frontend_portfolio_dashboard:
        'V2 Frontend für Portfolio-Dashboard verwenden',
    use_v2_frontend_portfolio_investments:
        'V2 Frontend für Portfolio-Investitionen verwenden',
    use_voucherify_coupon_code: 'Voucherify Coupon Code verwenden',
    emission_use_asset_title_in_preview_calculation:
        'Vermögenswert-Titel im Vorschau-Berechnung verwenden',
    emission_hide_investment_amount_row:
        'Investitionsbetrag in Vorschau ausblenden',
    show_contract_interest_rate_investment_process:
        'Zinssatz für Investitionsprozess anzeigen',
    restrict_campaign_access_to_kyc_identity_verified_users:
        'Kampagnenzugriff auf KYC-identifizierte Nutzer beschränken',
    redirect_url_after_login: 'Umleitungs-URL nach Login',
    login_only_via_external_identity_provider:
        'Nur über externe Identitätsanbieter anmelden',
    hide_cent_values: 'Centwerte ausblenden',
    use_swiss_currency_format: 'Schweizer Währungsformat verwenden',
    queue_it: 'Queue it',
    queue_it_customer_id: 'Queue it Kunde ID',
    right_of_withdrawal: 'Recht auf Rückgabe',
    consequences_of_revocation: 'Folgen der Rücknahme',
    cancel_investment_policy: 'Stornierungsrichtlinie',
    cancel_order_button_enabled: 'Storno-Button aktivieren',
    help_cancel_order_button_enabled:
        'Wenn aktiviert, können Investoren ihre Investition innerhalb der konfigurierten Stornofrist widerrufen.',
    cancel_counter_start: 'Startdatum des Zählers',
    help_cancel_counter_start:
        'Das Datum, ab dem die Stornofrist zu laufen beginnt.',
    cancel_counter_start_created_at: 'Erstellt am (Bestelldatum)',
    cancel_counter_start_paid_at: 'Datum der Zahlung',
    cancel_counter_start_accepted_at: 'Datum der Annahme',
    cancel_period_days: 'Stornofrist (Tage)',
    cancel_contact_email: 'Widerrufs-E-Mail-Adresse',
    help_cancel_contact_email:
        'E-Mail-Adresse, an die Investoren ihren Widerruf senden können. Wird in der Bedenkzeit-Information im Investmentprozess angezeigt.',
    help_cancel_period_days:
        'Gesamtanzahl der Tage, in denen der Investor seine Investition stornieren kann.',
    cancel_notification_recipients: 'Benachrichtigungsempfänger',
    acceptance_after_cancel_period: 'Annahme nach Stornofrist',
    help_acceptance_after_cancel_period:
        'Wenn aktiviert, können Bestellungen erst nach Ablauf der individuellen Stornofrist angenommen werden.',
    payout_through_acceptance: 'Auszahlung durch Annahme',
    help_payout_through_acceptance:
        'Wenn aktiviert, wird der Emittent unabhängig von der Stornofrist bei der Annahme ausgezahlt. Überschreibt "Annahme nach Stornofrist".',
    warning_acceptance_after_cancel_period_accepted_at_invalid:
        'Warnung: "Annahme nach Stornofrist" kann nicht mit "Startdatum = Akzeptiert am" verwendet werden. Das Akzeptierungsdatum ist zum Zeitpunkt der Akzeptierung nicht bekannt. Bitte wählen Sie stattdessen "Erstellt am" oder "Bezahlt am".',
    cancel_auto_refund_enabled: 'Automatische Rückerstattung bei Stornierung',
    sm_marketplace: 'Secondary Marketplace',
    help_sm_marketplace:
        'Hier können Sie die Secondary Marktplatz einstellung aktivieren',
    sm_frontend_url: 'Secundary Market Frontend-URL',
    help_sm_frontend_url: 'URL des Secundary Market Frontends',
    show_wallet_menu_item: 'Mein Wallet Menüpunkt anzeigen',
    help_show_wallet_menu_item:
        'Blendet den Menüpunkt "Mein Wallet" im Anleger-Dashboard ein oder aus.',
    show_news_menu_item: 'Nachrichten Menüpunkt anzeigen',
    help_show_news_menu_item:
        'Blendet den Menüpunkt "Nachrichten" im Anleger-Dashboard ein oder aus. Der Aktivitäten-Feed auf dem Dashboard selbst bleibt davon unberührt.',
    sm_trading_enabled: 'Handel aktiv',
    help_sm_trading_enabled:
        'Wenn deaktiviert, können keine neuen Angebote/Nachfragen erstellt und keine bestehenden Angebote/Nachfragen mehr angenommen werden. Bereits laufende Transaktionen sind nicht betroffen.',
    help_sm_trading_enabled_asset:
        'Wenn deaktiviert, können für diesen Vermögenswert keine neuen Angebote/Nachfragen erstellt und keine bestehenden Angebote/Nachfragen mehr angenommen werden. Bereits laufende Transaktionen sind nicht betroffen.',
    sm_dashboard_marketplace_button_enabled:
        'Dashboard-Button „Zum Bezugsrechtehandel“',
    help_sm_dashboard_marketplace_button_enabled:
        'Steuert die Sichtbarkeit des Marktplatz-Buttons auf dem Dashboard des Sekundärmarkt-Frontends (nicht die Navigation).',
    sm_dashboard_back_to_platform_button_enabled:
        'Dashboard-Button „Zurück zur Plattform“',
    help_sm_dashboard_back_to_platform_button_enabled:
        'Steuert die Sichtbarkeit des „Zurück zur Plattform“-Buttons auf dem Dashboard des Sekundärmarkt-Frontends (nicht der Navigations-Link in der Sidebar).',
    sm_marketplace_listings_visible: 'Angebote/Nachfragen sichtbar',
    help_sm_marketplace_listings_visible:
        'Wenn deaktiviert, werden bestehende Angebote und Nachfragen im Sekundärmarkt-Frontend nicht mehr angezeigt (Kaufen-/Verkaufen-Tabs verschwinden). Die Buttons zum Erstellen neuer Angebote/Nachfragen werden weiterhin separat über „Handel aktiv“ gesteuert.',
    user_feedback: 'User Feedback',
    user_feedback_provider: 'Feedback-Widget',
    help_user_feedback_provider:
        'Legt fest, welches User-Feedback-Widget im Frontend angezeigt wird, sofern überhaupt eines.',
    user_feedback_provider_none: 'Keins',
    PUSHFEEDBACK: 'PushFeedback',
    USERSNAP: 'Usersnap',
    user_feedback_pushfeedback_project: 'PushFeedback Projekt',
    help_user_feedback_pushfeedback_project: 'Die PushFeedback-Projekt-ID.',
    user_feedback_pushfeedback_api_key: 'PushFeedback API-Schlüssel',
    help_user_feedback_pushfeedback_api_key:
        'Der PushFeedback API-Schlüssel. Optional, abhängig von der Projektkonfiguration.',
    user_feedback_usersnap_project_code: 'Usersnap Projekt-Code',
    help_user_feedback_usersnap_project_code:
        'Der globale Usersnap-Projekt-API-Schlüssel zum Laden des Widgets.',
    help_cancel_auto_refund_enabled:
        'Wenn aktiviert, löst die Stornierung einer Investition automatisch eine Rückerstattung über Secupay aus (Standard-Lastschrift-Setup). Deaktivieren Sie dies für Plattformen, bei denen das Secupay-Auszahlungs-Setup keine automatischen Rückerstattungen unterstützt.',
    utm_parameter: 'UTM Parameter',
    child_platform: 'Unter-Plattform',
    campaign_additional_info: 'Kampagnen Zusätzliche Informationen',
    help_campaign_additional_info:
        'Hier können Sie zusätzliche Informationen für die Kampagne eingeben. Dies wird für Kunden auf der einzelnen Kampagnenseite angezeigt.',
    platform_settings: 'Platform settings',
    help_platform_settings:
        'Here you can manage all possible settings, and decide which ones to activate for your platform.',
    asset_settings: 'Asset Einstellungen',
    help_asset_settings:
        'Hier können Sie alle möglichen Einstellungen verwalten und entscheiden, welche Sie für Ihren Vermögenswert aktivieren möchten',
    voucherify_enabled: 'Voucherify aktiviert',
    help_voucherify_enabled:
        'Wenn aktiviert, kann die Plattform Voucherify verwenden',
    appearance_and_content: 'Erscheinungsbild und Inhalt',
    help_appearance_and_content:
        'Hier können Sie das Erscheinungsbild der Kampagne sowie den Inhalt verwalten',
    appearance: 'Erscheinungsbild',
    campaign_settings: 'Kampagne Einstellungen',
    help_campaign_settings:
        'Hier können Sie alle möglichen Einstellungen verwalten und entscheiden, welche Sie für Ihre Kampagne aktivieren möchten',
    marketing_content: 'Marketing-Inhalte',
    campaign_marketing_asset_information: 'Asset-Informationen',
    campaign_marketing_overview: 'Übersicht',
    campaign_marketing_media: 'Medien',
    campaign_marketing_company_presentation: 'Unternehmensvorstellung',
    campaign_marketing_key_facts: 'Wichtige Fakten für Investoren',
    campaign_marketing_milestones: 'Erfolge & Milestones',
    campaign_marketing_team: 'Management Team',
    campaign_marketing_podcast: 'Podcast',
    campaign_marketing_community: 'Community',
    campaign_marketing_incentives: 'Prämien',
    campaign_marketing_details: 'Details',
    campaign_marketing_business_model: 'Business Model',
    campaign_marketing_business_model_section:
        'Geschäftsmodell & Direktvertrieb',
    campaign_marketing_offerings: 'Produktportfolio & Zielgruppen',
    campaign_marketing_revenue_structure: 'Umsatzstruktur',
    campaign_marketing_competitive_advantages: 'Wettbewerbsvorteile',
    campaign_marketing_market_potential: 'Markt & Marktpotenzial',
    campaign_marketing_market_segment: 'Marktsegment',
    campaign_marketing_trends: 'Trends & Wachstumschancen',
    campaign_marketing_competition: 'Wettbewerb',
    campaign_marketing_swot_analysis: 'SWOT-Analyse',
    help_campaign_marketing_company_presentation:
        'Geben Sie die Unternehmensvorstellung ein.',
    help_campaign_marketing_team: 'Geben Sie die Vorstellung des Teams ein.',
    help_campaign_marketing_podcast:
        'Wählen Sie den Podcast für die Kampagne aus.',
    help_campaign_marketing_community:
        'Geben Sie die URL zum Community-Bereich der Kampagne ein.',
    campaign_marketing_news: 'News',
    help_campaign_marketing_news:
        'Wählen Sie einen oder mehrere News-Beiträge aus, die mit dieser Kampagne verknüpft werden sollen.',
    help_campaign_marketing_business_model_section:
        'Geben Sie das Geschäftsmodell des Unternehmens ein.',
    help_campaign_marketing_market_segment:
        'Geben Sie das Marktsegment des Unternehmens ein.',
    help_campaign_marketing_competition:
        'Geben Sie die Wettbewerbsübersicht des Unternehmens ein.',
    campaign_marketing_asset_information_label: 'Bezeichnung',
    help_campaign_marketing_asset_information_label:
        'Geben Sie die Bezeichnung für diese Asset-Information ein (z. B. "Anlageprodukt").',
    campaign_marketing_asset_information_value: 'Wert',
    help_campaign_marketing_asset_information_value:
        'Geben Sie den Wert für diese Asset-Information ein (z. B. "Nachrangige Anleihe").',
    campaign_marketing_key_fact_label: 'Bezeichnung des wichtigen Fakts',
    help_campaign_marketing_key_fact_label:
        'Geben Sie die Bezeichnung des wichtigen Fakts ein.',
    campaign_marketing_key_fact_value: 'Wert des wichtigen Fakts',
    help_campaign_marketing_key_fact_value:
        'Geben Sie den Wert des wichtigen Fakts ein.',
    campaign_marketing_key_facts_note: 'Notiz zu den wichtigen Fakten',
    help_campaign_marketing_key_facts_note:
        'Geben Sie eine zusätzliche Notiz ein, die zusammen mit den wichtigen Fakten angezeigt wird.',
    campaign_marketing_risk_disclaimer: 'Risikohinweis',
    help_campaign_marketing_risk_disclaimer:
        'Geben Sie den Risikohinweis für diese Kampagne ein.',
    campaign_marketing_white_label_box: 'White-Label-Box',
    campaign_marketing_white_label_box_title: 'Titel der White-Label-Box',
    help_campaign_marketing_white_label_box_title:
        'Geben Sie den Titel der White-Label-Box ein.',
    campaign_marketing_white_label_box_icon: 'Icon der White-Label-Box',
    help_campaign_marketing_white_label_box_icon:
        'Geben Sie den Namen des Lucide-Icons ein, das gerendert werden soll (z. B. "shield-check").',
    campaign_marketing_white_label_box_description:
        'Beschreibung der White-Label-Box',
    help_campaign_marketing_white_label_box_description:
        'Geben Sie die Beschreibung der White-Label-Box ein.',
    campaign_marketing_milestone_label: 'Bezeichnung des Meilensteins',
    help_campaign_marketing_milestone_label:
        'Geben Sie die Bezeichnung des Meilensteins ein.',
    campaign_marketing_milestone_value: 'Wert des Meilensteins',
    help_campaign_marketing_milestone_value:
        'Geben Sie den Wert des Meilensteins ein.',
    campaign_marketing_offering_title: 'Titel des Angebots',
    help_campaign_marketing_offering_title:
        'Geben Sie den Titel des Angebots ein.',
    campaign_marketing_offering_description: 'Beschreibung des Angebots',
    help_campaign_marketing_offering_description:
        'Geben Sie die Beschreibung des Angebots ein.',
    campaign_marketing_revenue_structure_title:
        'Titel des Umsatzstrukturpunkts',
    help_campaign_marketing_revenue_structure_title:
        'Geben Sie den Titel des Umsatzstrukturpunkts ein.',
    campaign_marketing_revenue_structure_description:
        'Beschreibung des Umsatzstrukturpunkts',
    help_campaign_marketing_revenue_structure_description:
        'Geben Sie die Beschreibung des Umsatzstrukturpunkts ein.',
    campaign_marketing_revenue_structure_percentage: 'Prozentsatz',
    help_campaign_marketing_revenue_structure_percentage:
        'Geben Sie den prozentualen Anteil dieses Umsatzstrukturpunkts ein.',
    campaign_marketing_competitive_advantage_title:
        'Titel des Wettbewerbsvorteils',
    help_campaign_marketing_competitive_advantage_title:
        'Geben Sie den Titel des Wettbewerbsvorteils ein.',
    campaign_marketing_competitive_advantage_description:
        'Beschreibung des Wettbewerbsvorteils',
    help_campaign_marketing_competitive_advantage_description:
        'Geben Sie die Beschreibung des Wettbewerbsvorteils ein.',
    campaign_marketing_trend_title: 'Titel des Trends',
    help_campaign_marketing_trend_title: 'Geben Sie den Titel des Trends ein.',
    campaign_marketing_trend_description: 'Beschreibung des Trends',
    help_campaign_marketing_trend_description:
        'Geben Sie die Beschreibung des Trends ein.',
    campaign_marketing_swot_title: 'Titel des SWOT-Punkts',
    help_campaign_marketing_swot_title:
        'Geben Sie den Titel des SWOT-Punkts ein.',
    campaign_marketing_swot_description: 'Beschreibung des SWOT-Punkts',
    help_campaign_marketing_swot_description:
        'Geben Sie die Beschreibung des SWOT-Punkts ein.',
    campaign_marketing_swot_type: 'SWOT-Typ',
    help_campaign_marketing_swot_type:
        'Wählen Sie aus, ob dies ein positiver (Stärke/Chance) oder negativer (Schwäche/Risiko) Punkt ist.',
    campaign_marketing_swot_type_success: 'Positiv (Stärke/Chance)',
    campaign_marketing_swot_type_error: 'Negativ (Schwäche/Risiko)',
    campaign_marketing_financials_projections: 'Finanz- & Planzahlen',
    campaign_marketing_past_financial_figures: 'Vergangene Finanzzahlen',
    campaign_marketing_financial_introduction: 'Einleitung',
    help_campaign_marketing_financial_introduction:
        'Geben Sie den einleitenden Text ein, der über den Finanztabellen angezeigt wird.',
    campaign_marketing_financial_table_number: 'Tabelle {number}',
    campaign_marketing_financial_table_title: 'Tabellentitel',
    help_campaign_marketing_financial_table_title:
        'Geben Sie den Titel dieser Finanztabelle ein.',
    campaign_marketing_financial_table_note: 'Anmerkung',
    help_campaign_marketing_financial_table_note:
        'Geben Sie eine optionale Anmerkung ein, die unterhalb dieser Tabelle angezeigt wird (z. B. "Stand: Januar 2026").',
    campaign_marketing_financial_item: 'Position',
    campaign_marketing_financial_add_period: 'Zeitraum hinzufügen',
    campaign_marketing_financial_add_row: 'Zeile hinzufügen',
    campaign_marketing_financial_add_table: 'Tabelle hinzufügen',
    campaign_marketing_current_status: 'Aktueller Stand',
    help_campaign_marketing_current_status:
        'Geben Sie eine kurze Zusammenfassung des aktuellen Stands der Kampagne ein.',
    campaign_marketing_current_status_box_label: 'Bezeichnung',
    help_campaign_marketing_current_status_box_label:
        'Geben Sie die Bezeichnung ein, die über dem Wert angezeigt wird (z. B. "Verbindlichkeiten gesamt").',
    campaign_marketing_current_status_box_value: 'Wert',
    help_campaign_marketing_current_status_box_value:
        'Geben Sie den Wert ein, der in dieser Box angezeigt wird (z. B. "2.180.000 €").',
    campaign_marketing_current_status_box_sublabel: 'Zusatztext',
    help_campaign_marketing_current_status_box_sublabel:
        'Geben Sie den Zusatztext ein, der unterhalb des Werts angezeigt wird (z. B. "Stand 28.02.2026").',
    campaign_marketing_projections_strategy: 'Planzahlen & Strategie',
    campaign_marketing_use_of_funds: 'Mittelverwendung',
    campaign_marketing_use_of_funds_description: 'Beschreibung',
    help_campaign_marketing_use_of_funds_description:
        'Geben Sie eine kurze Beschreibung ein, wie die eingesammelten Mittel verwendet werden.',
    campaign_marketing_use_of_funds_total: 'Gesamter Kapitalbedarf',
    help_campaign_marketing_use_of_funds_total:
        'Geben Sie den gesamten Kapitalbedarf für dieses Projekt ein.',
    campaign_marketing_use_of_funds_threshold: 'Minimum (Fundingschwelle)',
    help_campaign_marketing_use_of_funds_threshold:
        'Geben Sie die Mindest-Fundingschwelle für dieses Projekt ein.',
    campaign_marketing_use_of_funds_fully_funded: 'Vollfinanziert (Ziel / Cap)',
    help_campaign_marketing_use_of_funds_fully_funded:
        'Geben Sie den Ziel-/Cap-Betrag bei Vollfinanzierung für dieses Projekt ein.',
    campaign_marketing_use_of_funds_item_label: 'Bezeichnung',
    help_campaign_marketing_use_of_funds_item_label:
        'Geben Sie die Bezeichnung für diese Mittelverwendungsposition ein (z. B. "Investition in neue Produktionsstätte").',
    campaign_marketing_use_of_funds_item_minimum_percentage:
        'Minimum-Szenario %',
    help_campaign_marketing_use_of_funds_item_minimum_percentage:
        'Geben Sie den Prozentsatz ein, der dieser Position im Minimum-Szenario zugeordnet ist.',
    campaign_marketing_use_of_funds_item_full_percentage: 'Vollfinanziert %',
    help_campaign_marketing_use_of_funds_item_full_percentage:
        'Geben Sie den Prozentsatz ein, der dieser Position im vollfinanzierten Szenario zugeordnet ist.',
    campaign_marketing_use_of_funds_item_minimum_badge:
        'Badge Minimum-Szenario',
    help_campaign_marketing_use_of_funds_item_minimum_badge:
        'Kennzeichnen Sie optional, wie sich diese Position im Minimum-Szenario verändert.',
    campaign_marketing_use_of_funds_item_full_badge: 'Badge Vollfinanzierung',
    help_campaign_marketing_use_of_funds_item_full_badge:
        'Kennzeichnen Sie optional, wie sich diese Position im vollfinanzierten Szenario verändert.',
    campaign_marketing_use_of_funds_add_item: 'Position hinzufügen',
    campaign_marketing_sustainability: 'Nachhaltigkeit',
    campaign_marketing_esg_score: 'ESG-Score',
    help_campaign_marketing_esg_score:
        'Geben Sie den ESG-Score in Prozent ein (Dezimalstellen möglich, z. B. 82,6).',
    campaign_marketing_esg_description: 'Beschreibung',
    help_campaign_marketing_esg_description:
        'Geben Sie eine kurze Beschreibung ein, die unterhalb der ESG-Score-Fortschrittsleiste angezeigt wird.',
    campaign_marketing_esg_card_title: 'Titel',
    help_campaign_marketing_esg_card_title:
        'Geben Sie den Titel für diese ESG-Karte ein (z. B. "Environment", "Social", "Governance").',
    campaign_marketing_esg_card_description: 'Beschreibung',
    help_campaign_marketing_esg_card_description:
        'Geben Sie die Beschreibung für diese ESG-Karte ein.',
    sdg_goal_1: 'Keine Armut',
    sdg_goal_2: 'Kein Hunger',
    sdg_goal_3: 'Gesundheit und Wohlergehen',
    sdg_goal_4: 'Hochwertige Bildung',
    sdg_goal_5: 'Geschlechtergleichheit',
    sdg_goal_6: 'Sauberes Wasser und Sanitäreinrichtungen',
    sdg_goal_7: 'Bezahlbare und saubere Energie',
    sdg_goal_8: 'Menschenwürdige Arbeit und Wirtschaftswachstum',
    sdg_goal_9: 'Industrie, Innovation und Infrastruktur',
    sdg_goal_10: 'Weniger Ungleichheiten',
    sdg_goal_11: 'Nachhaltige Städte und Gemeinden',
    sdg_goal_12: 'Nachhaltige/r Konsum und Produktion',
    sdg_goal_13: 'Maßnahmen zum Klimaschutz',
    sdg_goal_14: 'Leben unter Wasser',
    sdg_goal_15: 'Leben an Land',
    sdg_goal_16: 'Frieden, Gerechtigkeit und starke Institutionen',
    sdg_goal_17: 'Partnerschaften zur Erreichung der Ziele',
    campaign_marketing_esg_sdgs: 'SDGs',
    campaign_marketing_esg_sdg_number: 'SDG',
    help_campaign_marketing_esg_sdg_number:
        'Wählen Sie das UN-Nachhaltigkeitsziel aus, das diese Karte repräsentiert.',
    campaign_marketing_esg_sdg_description: 'Beschreibung',
    help_campaign_marketing_esg_sdg_description:
        'Geben Sie eine kurze Beschreibung ein, wie dieses Projekt dieses SDG unterstützt.',
    campaign_marketing_esg_document: 'ESG-Dokument',
    campaign_marketing_esg_document_file: 'Dokument',
    help_campaign_marketing_esg_document_file:
        'Laden Sie den ESG-Bericht als PDF-Datei hoch.',
    toast_error_document_upload_failed:
        'Die Datei "{file}" konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
    toast_error_document_upload_invalid_type:
        'Dieser Dateityp wird nicht unterstützt. Erlaubte Dateitypen: {accepted}',
    signature_feature_active: 'Signaturfunktion aktiviert',
    help_signature_feature_active:
        'Wenn aktiviert, kann der Vermögenswert die Signaturfunktion verwenden',
    agio_disagio_feature_active: 'Agio/Disagio Funktion aktiviert',
    help_agio_disagio_feature_active:
        'Wenn aktiviert, kann die Plattform die Agio/Disagio Funktion verwenden',
    add_order_certificate: 'Bestell Urkunde hinzufügen',
    modal_title_delete_certificates: 'Zertifikate löschen',
    send_notification_mail: 'Benachrichtigungsmail senden',
    help_investment_desk_settings:
        'Hier können Sie alle Einstellungen für den Investment-Desk ändern.',
    sign_all_documents: 'Alle Dokumente auf einmal signieren',
    help_sign_all_documents:
        'Wenn aktiviert, werden alle Dokumente auf einmal in Signteq Iframes signiert. Dies ist nützlich für Vermögenswerte, die viele Dokumente zum Signieren haben.',
    webhook_calls: 'Webhook calls',
    help_webhook_calls_table:
        'Hier können Sie alle Webhook Aufrufe anzeigen und nach Plattform und Status filtern.',
    last_attempted_at: 'Letzter Versuch am',
    payload: 'Payload',
    attempt_number: 'Versuchszahl',
    modal_title_view_webhook_call: 'Webhook Aufruf anzeigen',
    attempt: 'Versuch',
    help_webhooks_activated:
        'Wenn aktiviert, können Sie Webhooks für die Plattform konfigurieren.',
    audits: 'Audits',
    help_audits: 'Hier können Sie die Audits der Model ansehen.',
    auditable_type: 'Auditable type',
    auditable_id: 'Auditable ID',
    old_values: 'Alte Werte',
    new_values: 'Neue Werte',
    view_audit: 'Audit ansehen',
    user_id: 'Nutzer ID',
    user_agent: 'Nutzer Agent',
    ip_address: 'IP Adresse',
    user_tracking_history: 'User tracking Geschichte',
    user_tracking: 'User tracking',
    help_user_tracking_table:
        'Die User tracking Tabelle, wo Sie die Benutzeraktionen Geschichte sehen können',
    issuer_country: 'Emittent Land',
    investor_country: 'Investor Land',
    create_formula_amount: 'Steuerbetrag Formel erstellen',
    create_formula_rate: 'Steuersatz Formel erstellen',
    edit_tax: 'Steuer bearbeiten',
    rate: 'Satz',
    formula: 'Formel',
    create_formula: 'Formel erstellen',
    tax_detail_name_required: 'Steuerdetailname ist erforderlich',
    platform_tax_documents: 'Plattform Steuerdokumente',
    toast_success_platform_tax_document_deleted:
        'Plattform-Steuerdokument "{platformTaxDocument}" gelöscht!',
    help_platform_tax_documents_table:
        'Hier können Sie mehrsprachige Plattform-Steuerdokumente verwalten',
    modal_title_update_platform_tax_document:
        'Plattform-Steuerdokument aktualisieren',
    modal_title_create_platform_tax_document:
        'Plattform-Steuerdokument erstellen',
    modal_title_delete_platform_tax_document:
        'Plattform-Steuerdokument löschen',
    modal_title_delete_platform_tax_documents:
        'Plattform-Steuerdokumente löschen',
    platform_membership_documents: 'Plattform Mitgliedsdokumente',
    help_platform_membership_documents_table:
        'Hier können Sie mehrsprachige Plattform-Mitgliedsdokumente verwalten',
    modal_title_update_platform_membership_document:
        'Plattform-Mitgliedsdokument aktualisieren',
    modal_title_create_platform_membership_document:
        'Plattform-Mitgliedsdokument erstellen',
    modal_title_delete_platform_membership_document:
        'Plattform-Mitgliedsdokument löschen',
    modal_title_delete_platform_membership_documents:
        'Plattform-Mitgliedsdokumente löschen',
    toast_success_platform_membership_document_updated:
        'Plattform-Mitgliedsdokument "{platformMembershipDocument}" aktualisiert!',
    toast_success_platform_membership_document_created:
        'Plattform-Mitgliedsdokument "{platformMembershipDocument}" erstellt!',
    toast_success_platform_membership_document_deleted:
        'Plattform-Mitgliedsdokument "{platformMembershipDocument}" gelöscht!',
    toast_success_platform_membership_documents_deleted:
        'Plattform-Mitgliedsdokumente "{platformMembershipDocuments}" gelöscht!',
    toast_success_platform_tax_document_updated:
        'Plattform-Steuerdokument "{platformTaxDocument}" aktualisiert!',
    toast_success_platform_tax_document_created:
        'Plattform-Steuerdokument "{platformTaxDocument}" erstellt!',
    toast_success_platform_tax_documents_deleted:
        'Plattform-Steuerdokumente "{platformTaxDocuments}" gelöscht!',

    platform_acceptance_documents: 'Plattform Akzeptanz Dokumente',
    help_platform_acceptance_documents_table:
        'Hier können Sie mehrsprachige Plattform-Akzeptanzdokumente verwalten',
    modal_title_update_platform_acceptance_document:
        'Plattform-Akzeptanzdokument aktualisieren',
    modal_title_create_platform_acceptance_document:
        'Plattform-Akzeptanzdokument erstellen',
    toast_success_platform_acceptance_document_updated:
        'Plattform-Akzeptanzdokument "{platformAcceptanceDocument}" aktualisiert!',
    toast_success_platform_acceptance_document_created:
        'Plattform-Akzeptanzdokument "{platformAcceptanceDocument}" erstellt!',
    modal_title_delete_platform_acceptance_document:
        'Plattform-Akzeptanzdokument löschen',
    toast_success_platform_acceptance_document_deleted:
        'Plattform-Akzeptanzdokument "{platformAcceptanceDocument}" gelöscht!',
    toast_success_platform_acceptance_documents_deleted:
        'Plattform-Akzeptanzdokumente "{platformAcceptanceDocuments}" gelöscht!',
    modal_title_delete_platform_acceptance_documents:
        'Plattform-Akzeptanzdokumente löschen',

    platform_self_disclosure_forms: 'Plattform Selbstverständnis Formulare',
    help_platform_self_disclosure_forms_table:
        'Hier können Sie mehrsprachige Plattform-Selbstverständnis-Formulare verwalten',
    modal_title_update_platform_self_disclosure_form:
        'Plattform-Selbstverständnis-Formular aktualisieren',
    modal_title_create_platform_self_disclosure_form:
        'Plattform-Selbstverständnis-Formular erstellen',
    toast_success_platform_self_disclosure_form_updated:
        'Plattform-Selbstverständnis-Formular "{platformSelfDisclosureForm}" aktualisiert!',
    toast_success_platform_self_disclosure_form_created:
        'Plattform-Selbstverständnis-Formular "{platformSelfDisclosureForm}" erstellt!',
    modal_title_delete_platform_self_disclosure_form:
        'Plattform-Selbstverständnis-Formular löschen',
    toast_success_platform_self_disclosure_form_deleted:
        'Plattform-Selbstverständnis-Formular "{platformSelfDisclosureForm}" gelöscht!',
    modal_title_delete_platform_self_disclosure_forms:
        'Plattform-Selbstverständnis-Formulare löschen',
    toast_success_platform_self_disclosure_forms_deleted:
        'Plattform-Selbstverständnis-Formulare "{platformSelfDisclosureForms}" gelöscht!',
    toast_signature_document_updated: 'Unterschriftendokument aktualisiert!',
    payment_account: 'Zahlungskonto',
    payment_accounts: 'Zahlungskonten',
    sync_enabled: 'Synchronisierung aktiviert',
    help_sync_enabled:
        'Umschalten, um die Synchronisierung des Zahlungskontos zu aktivieren.',
    uses_proxy: 'Verwendet Proxy',
    help_uses_proxy:
        'Umschalten, um die Nutzung des Zahlungskonto-Proxys zu aktivieren.',
    toast_success_payment_account_saved:
        'Zahlungskonto erfolgreich gespeichert!',
    webhook_api_key: 'Webhook-API-Schlüssel',
    help_webhook_api_key:
        'API-Schlüssel, der für die Authentifizierung von Webhooks verwendet wird.',
    payment_reference_prefix: 'Zahlungsreferenz-Präfix',
    help_payment_reference_prefix:
        'Präfix, das zu Zahlungsreferenzen hinzugefügt wird.',
    payment_endpoint: 'Zahlungsendpunkt',
    help_payment_endpoint: 'Endpunkt-URL für die Zahlungsabwicklung.',
    auth_endpoint: 'Authentifizierungsendpunkt',
    api_endpoint: 'API-Endpunkt',
    help_api_endpoint: 'Endpunkt-URL für den API-Zugriff.',
    help_auth_endpoint: 'Endpunkt-URL für die Authentifizierung.',
    api_token: 'API-Token',
    help_api_token: 'Token, das für die API-Authentifizierung verwendet wird.',
    client_id: 'Client-ID',
    help_client_id: 'Die Client-ID für die API-Authentifizierung.',
    client_secret: 'Client-Geheimnis',
    help_client_secret: 'Das Client-Geheimnis für die API-Authentifizierung.',
    master_contract_id: 'Hauptvertrags-ID',
    help_master_contract_id:
        'ID des Hauptvertrags, der mit diesem Zahlungskonto verknüpft ist.',
    checkout_template_id: 'Checkout-Vorlagen-ID',
    help_checkout_template_id:
        'ID der Checkout-Vorlage, die für Zahlungen verwendet wird.',
    deposit_iban: 'Einzahlungs-IBAN',
    help_deposit_iban: 'IBAN, die für Einzahlungen verwendet wird.',
    toast_success_payment_account_deleted:
        'Zahlungskonto erfolgreich gelöscht!',
    deposit_bic: 'Einzahlungs-BIC',
    help_deposit_bic: 'BIC, der für Einzahlungen verwendet wird.',
    limit_credit_card: 'Kreditkartenlimit',
    help_limit_credit_card: 'Limit für Kreditkartentransaktionen.',
    limit_bank_transfer: 'Überweisungslimit',
    help_limit_bank_transfer: 'Limit für Banküberweisungen.',
    deposit_account_holder_address: 'Adresse des Einzahlerkontoinhabers',
    help_deposit_account_holder_address:
        'Adresse des Inhabers des Einzahlerkontos.',
    deposit_account_holder_country: 'Land des Einzahlerkontoinhabers',
    help_deposit_account_holder_country:
        'Land des Inhabers des Einzahlerkontos.',
    healthcheck_wallet: 'Healthcheck-Wallet',
    help_healthcheck_wallet:
        'Das Wallet, das zum Überprüfen der API verwendet wird.',
    help_type: 'Der Typ der Entität.',
    payment_account_details: 'Zahlungskontodetails',
    toast_error_payment_account_not_saved:
        'Zahlungskonto konnte nicht gespeichert werden!',
    payment_account_platforms: 'Zahlungskonto Plattformen',
    help_name: 'Der Name der Entität.',
    help_description: 'Die Beschreibung der Entität.',
    payment_account_summary: 'Zahlungskontoübersicht',
    payment_account_assets: 'Zahlungskonto-Vermögenswerte',
    help_payment_account:
        'Das Plattform-Zahlungskonto kann überschrieben werden, indem ein Zahlungskonto im Vermögenswert festgelegt wird.',
    toast_error_payment_methods_required:
        'Mindestens eine Zahlungsmethode ist erforderlich',
    toast_investment_max_is_greater_than_the_biggest_limit:
        'Investitionsmax ist größer als das Limit der verfügbaren Zahlungsmethoden',
    limit: 'Limit',
    external_contract_id: 'Externe Vertrags-ID',
    help_external_contract_id: 'Die externe Vertrags-ID vom Zahlungsanbieter.',
    external_contract: 'Externe Vertrag',
    can_deposit: 'Kann einzahlen',
    help_can_deposit:
        'Umschalten, um die Einzahlungsfunktionalität für das Zahlungskonto zu aktivieren.',
    can_withdraw: 'Kann abheben',
    help_can_withdraw:
        'Umschalten, um die Abhebungsfunktionalität für das Zahlungskonto zu aktivieren.',
    logo_url: 'Logo URL',
    help_logo_url: 'Die URL des Logos des Zahlungskontos.',
    require_kyc_id_for_investments: 'KYC für Investitionen erforderlich',
    help_require_kyc_id_for_investments:
        'Bei Aktivierung ist KYC ID für Investoren erforderlich, um Investitionen zu tätigen',
    require_bank_account_for_investments:
        'Bankkonto für Investitionen erforderlich',
    help_require_bank_account_for_investments:
        'Bei Aktivierung müssen Investoren ein Bankkonto hinterlegt haben, bevor sie investieren können',
    require_kyc_address_for_investments:
        'KYC Adresse für Investitionen erforderlich',
    help_require_kyc_address_for_investments:
        'Bei Aktivierung ist KYC Adresse für Investitionen erforderlich',
    require_kyc_tax_for_investments:
        'KYC Steuer für Investitionen erforderlich',
    help_require_kyc_tax_for_investments:
        'Bei Aktivierung ist KYC Steuer für Investitionen erforderlich',
    wallets: 'Wallets',
    full_name: 'Vollständiger Name',
    external_id: 'Externe ID',
    external_internal_id: 'Externe interne ID',
    balance: 'Balance',
    are_you_sure_you_want_to_run_exclusive_acceptance:
        'Sind Sie sicher, dass Sie eine exklusive Annahme wünschen?',
    signteq_kyc_qes: 'Signteq QES (qualifizierte elektronische Signatur)',
    help_signteq_kyc_qes:
        'Umschalten, um die Signteq QES (qualifizierte elektronische Signatur) zu aktivieren.',
    payout_contract_id: 'Payout Vertrags-ID',
    help_payout_contract_id: 'Die Payout Vertrags-ID vom Zahlungsanbieter.',
    iban_verifications: 'IBAN Verifizierungen',
    iban_verification_view: 'IBAN Verifizierung anzeigen',
    data: 'Daten',
    response_data: 'Antwortdaten',
    wallet_type: 'Wallet Typ',
    redirect_to_another_platform: 'Auf eine andere Plattform umleiten',
    help_redirect_to_another_platform:
        'Wenn aktiviert, werden Benutzer, die versuchen, sich auf dieser Plattform anzumelden oder zu registrieren, auf eine andere Plattform umgeleitet.',
    redirection_url: 'Umleitungs-URL',
    help_redirection_url:
        'Die URL, auf die Benutzer umgeleitet werden, wenn sie versuchen, sich anzumelden oder zu registrieren.',
    redirection_settings: 'Umleitungseinstellungen',
    recalculate_kyc_flags: 'KYC-Flags neu berechnen',
    toggle_manual_kyc: 'Manuelle KYC aktivieren/deaktivieren',
    toast_success_kyc_flags_recalculated:
        'KYC-Flags erfolgreich neu berechnet!',
    toast_error_kyc_flags_recalculation:
        'Fehler: Konnte KYC-Flags nicht neu berechnen',
    toast_success_manual_kyc_toggled:
        'Manuelle KYC erfolgreich aktiviert/deaktiviert!',
    toast_error_manual_kyc_toggled:
        'Fehler: Konnte Manuelle KYC nicht aktivieren/deaktivieren',
    redirect_on_login: 'Bei Login weiterleiten',
    help_redirect_on_login:
        'Benutzer werden beim Klicken auf die Login-Schaltfläche auf die andere Plattform weitergeleitet',
    redirect_on_register: 'Bei Registrierung weiterleiten',
    help_redirect_on_register:
        'Benutzer werden beim Klicken auf die Registrieren-Schaltfläche auf die andere Plattform weitergeleitet',
    limit_credit_card_order: 'Kreditkartenlimit für Bestellung',
    help_limit_credit_card_order:
        'Limit für die Kreditkarten-Transaktionen während der Investition.',
    limit_credit_card_deposit: 'Kreditkartenlimit für Einzahlung',
    help_limit_credit_card_deposit:
        'Limit für die Kreditkarten-Transaktionen während der Einzahlung.',
    limit_bank_transfer_order: 'Überweisungslimit für Bestellung',
    help_limit_bank_transfer_order:
        'Limit für die Überweisungs-Transaktionen während der Investition.',
    limit_bank_transfer_deposit: 'Überweisungslimit für Einzahlung',
    help_limit_bank_transfer_deposit:
        'Limit für die Überweisungs-Transaktionen während der Einzahlung.',
    limit_bank_transfer_withdrawal: 'Überweisungslimit für Abhebung',
    help_limit_bank_transfer_withdrawal:
        'Limit für die Überweisungs-Transaktionen während der Abhebung.',
    asset_hide_payment_info: 'Zahlungsinformationen ausblenden',
    help_asset_hide_payment_info:
        'Wenn aktiviert, werden die Zahlungsinformationen für den Vermögenswert auf den Investitions- und Bestellseiten ausgeblendet.',
    asset_revoke_accrual: 'Accrual-Flag widerrufen (Secupay)',
    help_asset_revoke_accrual:
        'Wenn aktiviert, wird das Accrual-Flag bei der Zahlungsannahme für diesen Vermögenswert entfernt.',
    label_invoice_fee_to_distribute: 'Stakeholder-Gebühr zur Verteilung',
    help_invoice_fee_to_distribute:
        'Absoluter Rechnungsbetrag von der Buchhaltung. Überschreibt den Vertrags-/Zahlungskonto-Standard für diese Akzeptanz. Die Eingabe von 0 entfernt diese Gebühr für diese Akzeptanz — das ist nur bei der Akzeptanz möglich, nicht bei der Erstellung der Transaktion.',
    label_configured_stakeholder_fee: 'Konfigurierte Stakeholder-Gebühr',
    label_total_acceptance_amount: 'Gesamtbetrag zur Akzeptanz',
    label_orders: 'Aufträge',
    label_derived_fee_percentage: 'Abgeleiteter Gebührenprozentsatz',
    label_stakeholder_fee_will_be_removed:
        'Die Stakeholder-Gebühr wird für diese Akzeptanz entfernt.',
    label_fee_input_mode_amount: 'Betrag eingeben',
    label_fee_input_mode_percentage: 'Prozentsatz direkt eingeben',
    label_fee_percentage_direct: 'Gebührenprozentsatz',
    help_fee_percentage_direct:
        'Gebührenprozentsatz direkt eingeben (0–100). Überschreibt den Vertrags-/Zahlungskonto-Standard für diese Akzeptanz. Die Eingabe von 0 entfernt diese Gebühr für diese Akzeptanz — das ist nur bei der Akzeptanz möglich, nicht bei der Erstellung der Transaktion.',
    label_revoke_accrual_acceptance: 'Accrual-Flag widerrufen',
    help_revoke_accrual_acceptance:
        'Das Accrual-Flag wird widerrufen, wenn diese Option aktiviert ist oder wenn "Accrual widerrufen" bereits auf Vermögenswert-Ebene aktiviert ist. Um sicherzustellen, dass Accrual nicht widerrufen wird, muss es an beiden Stellen deaktiviert sein.',
    disable_campaigns_button:
        'Kampagnen deaktivierenKampagnen-Investition und Detail-Button deaktivieren',
    help_disable_campaigns_button:
        'Aktivieren, um Details und den Investieren-Button auszublenden.',
    modal_title_create_withdrawal: 'Geldabhebung erstellen',
    withdraw_money: 'Geld abheben',
    error_withdrawal_amount_must_be_greater_than_0:
        'Abhebungsbetrag muss größer als 0 sein',
    error_withdrawal_not_allowed: 'Abhebung nicht erlaubt durch Zahlungskonto',
    error_bank_account_required: 'Bank account is required for withdrawal',
    error_withdrawal_amount_is_greater_than_balance:
        'Abhebungsbetrag ist größer als der Kontostand',
    error_withdrawal_amount_is_greater_than_limit:
        'Abhebungsbetrag ist größer als das Abhebungslimit des Zahlungskontos',
    toast_success_money_withdrawal_created:
        'Geldabhebung erfolgreich erstellt!',
    new_login_modal_translations: 'Neue Login Modal Texte verwenden',
    stakeholder_payment: 'Stakeholder-Zahlung',
    stakeholder_payment_disabled_at_payment_account:
        'Die Stakeholder-Zahlung ist für das Zahlungskonto deaktiviert. Aktivieren Sie sie zuerst in den Zahlungskonto-Einstellungen, wenn Sie sie auf Vertragsebene verwenden möchten.',
    disable_stakeholder_payment: 'Stakeholder-Zahlung deaktivieren',
    help_disable_stakeholder_payment:
        'Wenn aktiviert, ist die Stakeholder-Zahlung für diesen Vertrag deaktiviert.',
    enable_stakeholder_payment: 'Stakeholder-Zahlung aktivieren',
    help_enable_stakeholder_payment:
        'Stakeholder-Zahlung für dieses Zahlungskonto aktivieren oder deaktivieren.',
    stakeholder_contract_id: 'Stakeholder Vertrags-ID',
    help_stakeholder_contract_id:
        'Die Vertrags-ID für die Stakeholder-Zahlung vom Zahlungsanbieter.',
    stakeholder_fee: 'Stakeholder Gebühr',
    help_stakeholder_fee:
        'Die Stakeholder-Gebühr als Dezimalwert (Prozent durch 100 teilen). Z.B. für 0,25% 0,0025 eingeben.',
    kyb_settings: 'KYB Einstellungen',
    investor_profile_settings: 'Investoren Profil',
    investor_profile_settings_override:
        'Eigene Werte für diese Plattform festlegen',
    investor_profile_settings_reset_to_parent:
        'Auf Werte der Elternplattform zurücksetzen',
    personal_data: 'Persönliche Daten',
    country_of_birth: 'Geburtsland',
    city_of_birth: 'Geburtsort',
    gender: 'Geschlecht',
    pep: 'Politisch exponierte Person',
    field_visible: 'Anzeigen',
    field_required: 'Pflichtfeld',
    field_editable_after_kyc: 'Bearbeitbar nach KYC',
    company_account_creation_mail_receipents:
        'Firmenkonto Erstellung E-Mail Empfänger',
    company_account_document_submission_mail_receipents:
        'Firmenkonto Dokument Einreichung E-Mail Empfänger',
    help_email_receipents:
        'Geben Sie die E-Mail-Adressen der Empfänger durch Zeilenumbruch ein',
    toast_error_money_withdrawal_created:
        'Geldabhebung erstellung fehlgeschlagen!',
    warning: 'Warnung',
    warning_modal_text:
        'Sind Sie sicher, dass Sie fortfahren möchten? Dies wird {actionLabel} werden.',
    continue: 'Fortfahren',
    run_bulk_set_pending_orders: 'Bulk Bestellstatus auf Ausstehend setzen',
    run_bulk_set_paid_orders: 'Bulk Bestellstatus auf Bezahlt setzen',
    kyc_reset_threshold: 'KYC Zurücksetzung Schwellenwert (Stunden)',
    help_kyc_reset_threshold:
        'Die Anzahl der Stunden nach der das KYC Prozess zurückgesetzt wird.(Wenn nicht gesetzt, Default ist 72 Stunden)',
    help_additional_fields:
        'Hier können Sie markieren, welche zusätzlichen Felder für die Kampagne erforderlich sind. Die folgenden Schalter sind für die obligatorische Eingabe der jeweiligen Felder.',
    show_depot_fields_on_profile_section:
        'Depot Felder auf Profil-Abschnitt anzeigen',
    confetti_on_investment_completion:
        'Konfetti nach abgeschlossenem Investment',
    confetti_in_onboarding: 'Konfetti im Onboarding',
    customize: 'Anpassen',
    toast_success_page_saved: 'Seite erfolgreich gespeichert!',
    config: 'Konfiguration',
    preview: 'Vorschau',
    change_image: 'Bild ändern',
    click_to_choose_image: 'Klicken, um ein Bild auszuwählen',
    media_library: 'Medienbibliothek',
    uploading: 'Laden',
    upload_new: 'Neu hochladen',
    no_images_yet: 'Noch keine Bilder',
    edit_alt_text: 'Alt-Text bearbeiten',
    alt_text: 'Alt-Text',
    upload_your_first_image_using_the_button_above:
        'Laden Sie Ihr erstes Bild mit dem obigen Button hoch',
    has_eyebrow: 'Eyebrow anzeigen',
    is_badge: 'Eyebrow als Plakette anzeigen',
    eyebrow_text: 'Eyebrow Text',
    eyebrow_color: 'Eyebrow Farbe',
    eyebrow_icon: 'Eyebrow Icon',
    icon_class_name_example: 'Icon class name (z.B. "fa-solid fa-star")',
    cards: 'Karten',
    add_card: 'Karte hinzufügen',
    card: 'Karte',
    icon: 'Icon',
    icon_background: 'Icon Hintergrund',
    icon_color: 'Icon Farbe',
    alignment: 'Ausrichtung',
    orientation: 'Orientierung',
    has_glow_effect: 'Glüheffekt anzeigen',
    card_layout_orientation: 'Kartenlayout Orientierung',

    // Blog Posts
    blog_post: 'Blogbeitrag',
    move_up: 'Nach oben verschieben',
    move_down: 'Nach unten verschieben',
    thumbnail: 'Vorschaubild',
    help_blog_post_thumbnail:
        'Vorschaubild, das für diesen Beitrag angezeigt wird.',
    slug: 'Slug',
    category: 'Kategorie',
    duration: 'Dauer',
    author: 'Autor',
    author_info: 'Autoreninfo',
    body: 'Inhalt',
    guest: 'Gast',
    youtube_link: 'YouTube-Link',
    spotify_link: 'Spotify-Link',
    apple_music_link: 'Apple-Music-Link',
    podcasts: 'Podcasts',
    blogs: 'Blogs',
    videos: 'Videos',
    guides: 'Ratgeber',
    press_posts: 'Presse',
    help_podcasts_table: 'Verwalte die Podcast-Episoden für diese Plattform.',
    help_blogs_table: 'Verwalte die Blogbeiträge für diese Plattform.',
    help_videos_table: 'Verwalte die Videoinhalte für diese Plattform.',
    help_guides_table: 'Verwalte die Ratgeber für diese Plattform.',
    help_press_posts_table: 'Verwalte die Presseartikel für diese Plattform.',
    help_blog_post_slug:
        'Wird in der URL verwendet. Wird aus dem Titel vorbefüllt, kann aber frei geändert werden und bleibt bei späteren Titeländerungen unverändert. Muss für diese Plattform eindeutig sein.',
    help_blog_post_body: 'Haupttext des Beitrags.',
    published_at: 'Veröffentlichungsdatum',
    help_blog_post_published_at:
        'Wann dieser Beitrag live geht. Leer lassen, um ihn sofort zu veröffentlichen, oder ein zukünftiges Datum und eine Uhrzeit wählen, um ihn zu planen.',
    blog_post_cta: 'Call-to-Action-Button',
    cta_label: 'Button-Text',
    cta_url: 'Button-Link',
    cta_icon: 'Button-Icon',
    help_blog_post_cta_label:
        'Text auf dem Button unter dem Artikel, z. B. Jetzt investieren. Ohne Text und Link wird kein Button angezeigt.',
    help_blog_post_cta_url:
        'Eine vollständige URL (https://…) oder ein Pfad auf der Website, z. B. /investitionen.',
    help_blog_post_cta_icon:
        'Name eines Lucide-Icons von lucide.dev/icons, z. B. arrow-right. Leer lassen für den Pfeil nach rechts.',
    seo: 'SEO',
    og_title: 'OG-Titel',
    og_description: 'OG-Beschreibung',
    og_image: 'OG-Bild',
    focus_keyword: 'Fokus-Keyword',
    help_blog_post_og_title:
        'Überschreibt den Titel für Social-Media-Vorschauen. Wird bei leerem Feld vom Titel übernommen.',
    help_blog_post_og_description:
        'Überschreibt die Beschreibung für Social-Media-Vorschauen. Wird bei leerem Feld von der Vorschau übernommen.',
    modal_title_create_blog_post: 'Blogbeitrag erstellen',
    modal_title_update_blog_post: 'Blogbeitrag aktualisieren',
    modal_title_delete_blog_post: 'Blogbeitrag löschen',
    modal_title_delete_blog_posts: 'Blogbeiträge löschen',
    toast_success_blog_post_created: 'Blogbeitrag erstellt!',
    toast_success_blog_post_updated: 'Blogbeitrag aktualisiert!',
    blog_post_translations: 'Übersetzungen',
    help_blog_post_translations:
        'Verknüpfen Sie diesen Beitrag mit seinen Übersetzungen. Beim Sprachwechsel auf der Website landen Leser dann direkt auf der passenden Übersetzung.',
    blog_post_translation_select: 'Beitrag auswählen',
    blog_post_translation_not_published: 'noch nicht veröffentlicht',
    blog_post_translation_link: 'Verknüpfen',
    blog_post_translation_unlink: 'Verknüpfung lösen',
    toast_success_blog_post_translation_linked: 'Übersetzung verknüpft!',
    toast_success_blog_post_translation_unlinked: 'Verknüpfung gelöst!',
    campaign_translations: 'Sprachversionen',
    help_campaign_translations:
        'Verknüpfen Sie die Kampagnen dieses Assets, die dasselbe Angebot in einer anderen Sprache sind. Beim Sprachwechsel auf der Website landen Besucher dann direkt auf der verknüpften Kampagne, ohne Verknüpfung auf der Investitionsübersicht.',
    campaign_translation_select: 'Kampagne auswählen',
    campaign_translation_link: 'Verknüpfen',
    campaign_translation_unlink: 'Verknüpfung lösen',
    campaign_translation_no_candidates:
        'Keine unverknüpfte Kampagne dieses Assets in dieser Sprache.',
    campaign_x_default: 'Standardversion (x-default)',
    help_campaign_x_default:
        'Wird Besuchern von Suchmaschinen angezeigt, für deren Sprache es keine Version gibt. Ohne Auswahl wird die deutsche Version verwendet.',
    campaign_x_default_none: 'Nicht festgelegt (deutsche Version)',
    toast_success_campaign_translation_linked: 'Sprachversion verknüpft!',
    toast_success_campaign_translation_unlinked: 'Verknüpfung gelöst!',
    toast_success_campaign_x_default_updated: 'Standardversion gespeichert!',
    toast_success_blog_post_deleted: 'Blogbeitrag "{blogPost}" gelöscht!',
    toast_success_blog_posts_deleted: 'Blogbeiträge "{blogPosts}" gelöscht!',

    // Secondary market
    order_books_table: 'Bezugsrechtebuch',
    direction: 'Direktion',
    source: 'Quelle',
    quantity: 'Menge',
    PRE_EMPTIVE: 'Pre-emptive',
    SHARE: 'Share',
    ADMIN_ADJUSTMENT: 'Admin-Korrektur',
    IMPORT: 'Import',
    INVESTMENT: 'Investment',
    SECONDARY_MARKET: 'Secondary Market',
    EXERCISE: 'Ausübung',
    IN: 'Zugang',
    OUT: 'Abgang',
    secondary_market_listings: 'Marktplatz-Angebote',
    secondary_market_buy_requests: 'Marktplatz-Nachfrage',
    help_listings_table:
        'Übersicht aller Verkaufsangebote auf dem Sekundärmarkt',
    pre_emptive: 'Bezugsrecht',
    share: 'Aktie',
    share_campaign_link: 'Kampagnen-Link kopieren',
    status_open: 'Offen',
    status_reserved: 'Reserviert',
    status_sold: 'Verkauft',
    status_cancelled: 'Storniert',
    status_expired: 'Abgelaufen',
    price_per_unit: 'Preis pro Stück',
    note: 'Notiz',
    modal_title_cancel_listing: 'Angebot wirklich stornieren?',
    toast_success_listing_cancelled: 'Angebot erfolgreich storniert',
    create_listing: 'Angebot erstellen',
    create_buy_request: 'Nachfrage erstellen',
    modal_title_cancel_buy_request: 'Nachfrage wirklich stornieren?',
    sm_pre_emptive_rights_required:
        'Secondary Market - Bezugsrechte erforderlich',
    secondary_market_settings: 'Secondary Market - Einstellungen',
    sm_pre_emptive_rights: 'Bezugsrechte erforderlich',
    help_sm_pre_emptive_rights:
        'Eine Investition in diese Kampagne ist nur möglich, wenn der Käufer über die erforderlichen Bezugsrechte verfügt.',
    secondary_market_offers: 'Kaufanfragen',
    create_offer: 'Kaufanfrage erstellen',
    edit_offer: 'Kaufanfrage bearbeiten',
    seller: 'Verkäufer/in',
    buyer: 'Käufer/in',
    available_rights: 'Verfügbare Bezugsrechte',
    sm_transaction_fee: 'Marktplatz-Gebühr (%)',
    offer_status: 'Kaufanfrage status',
    offer_status_pending: 'Ausstehend',
    offer_status_accepted: 'Akzeptiert',
    offer_status_rejected: 'Abgelehnt',
    offer_status_cancelled: 'Storniert',
    offer_status_expired: 'Abgelaufen',
    transaction_status_initiated: 'Initialisiert',
    transaction_status_buyer_signed: 'Kaufer signiert',
    transaction_status_seller_signed: 'Verkaufer signiert',
    transaction_status_pending_payment: 'Zahlung ausstehend',
    transaction_status_completed: 'Abgeschlossen',
    transaction_status_waiting_for_approval: 'Wartet auf Freigabe',
    transaction_status_failed: 'Eskaliert',
    pre_emptive_rights_table: 'Secondary Market - Bezugsrechte',
    help_pre_emptive_rights_table:
        'Hier werden die einzelnen Investoren und die ihnen zugeordneten Bezugsrechte aufgeführt.',
    contract_document: 'Vertragsdokument',
    tx_status_initiated: 'Initialisiert',
    tx_status_buyer_signed: 'Vom Käufer unterschrieben',
    tx_status_seller_signed: 'Vom Verkäufer unterschrieben',
    tx_status_pending_payment: 'Zahlung ausstehend',
    tx_status_completed: 'Abgeschlossen',
    tx_status_escalated: 'Eskaliert',
    tx_status_cancelled: 'Abgebrochen',
    tx_status_waiting_for_approval: 'Wartet auf Freigabe',
    transaction_status: 'Transaktionsstatus',
    seller_signed_contract: 'Vom Verkäufer unterzeichneter Vertrag',
    buyer_signed_contract: 'Vom Käufer unterzeichneter Vertrag',
    payment_receipt: 'Zahlungsbestätigung',
    payment_reference: 'Zahlungsreferenz',
    transaction_will_be_created_on_save:
        'Beim Speichern wird automatisch eine Transaktion erstellt.',
    offer_details: 'Kaufanfrage-Details',
    transaction: 'Transaktion',
    toast_success_offer_saved: 'Kaufanfrage wurde erfolgreich gespreichert!',
    regenerate: 'Regenerieren',
    modal_title_regenerate_offer:
        'Soll diese Kaufanfrage wirklich neu generiert werden?',
    toast_success_offer_regenerated: 'Kaufanfrage erfolgreich neu generiert',
    toast_error_cannot_regenerate_offer:
        'Kaufanfrage kann nicht neu generiert werden',
    send_email: 'E-Mail senden',
    modal_title_send_offer_email: 'E-Mail manuell auslösen',
    help_send_offer_email:
        'Sendet die ausgewählte E-Mail für dieses Angebot erneut, z. B. nachdem ein Datensatz manuell nachgepflegt wurde.',
    email_template_type: 'E-Mail-Vorlage',
    recipient_role: 'Empfänger',
    role_buyer: 'Käufer/in',
    role_seller: 'Verkäufer/in',
    send_email_option_offer_received_buy_request:
        'Angebot erhalten (auf Kaufnachfrage)',
    sm_subscription_ratio: 'Bezugsverhältnis (Anzahl Bezugsrechte pro Aktie)',
    help_sm_subscription_ratio:
        'Anzahl der erforderlichen Bezugsrechte pro Aktie. Der Wert bestimmt den Umrechnungsfaktor (z. B. bei Wert 3 werden für 3 Aktien insgesamt 9 Bezugsrechte benötigt; bei Wert 0,5 reicht 1 Bezugsrecht für 2 Aktien).',
    sm_tolerance_band: 'Toleranzbandbreite (%)',
    help_sm_tolerance_band:
        'Erlaubte Abweichung vom Richtpreis ohne Warnhinweis',
    sm_signing_deadline: 'Unterzeichnungs-Frist (Tage)',
    help_sm_signing_deadline:
        'Frist in Tagen für die Unterzeichnung des Vertrags durch beide Parteien',
    sm_payment_fulfillment_deadline: 'Zahlungserfüllungs-Frist (Tage)',
    help_sm_payment_fulfillment_deadline:
        'Frist in Tagen für den Käufer zur Überweisung und zum Upload der Zahlungsbestätigung',
    sm_payment_confirmation_deadline: 'Zahlungsbestätigungs-Frist (Tage)',
    help_sm_payment_confirmation_deadline:
        'Frist in Tagen für den Verkäufer zur Bestätigung des Zahlungseingangs',
    sm_exercise_campaign: 'Verknüpfte Ausübungs-Kampagne',
    help_sm_exercise_campaign:
        'ID der Zielkampagne für die Ausübung der Bezugsrechte',
    help_sm_transaction_fee: 'Transaktionsgebühr (0 bedeutet kostenfrei)',
    create_pre_emptive_rights: 'Bezugsrechte hinzufügen',
    edit_pre_emptive_rights: 'Bezugsrechte bearbeiten',
    sm_risk_disclaimers_title: 'Risikohinweise (Checkout Phase 2)',
    sm_risk_disclaimers_help:
        'Reihenfolge per Drag & Drop anpassen. Alle Einträge müssen vom Investor akzeptiert werden.',
    sm_add_risk_disclaimer: 'Hinweis hinzufügen',
    sm_risk_text_placeholder: 'Risikotext eingeben... *',
    sm_risk_url_placeholder: 'https://... (optionaler Link)',
    sm_no_risk_disclaimers: 'Keine Risikohinweise konfiguriert.',
    sm_save_risk_disclaimers: 'Risikohinweise speichern',
    sm_risk_validation_empty_text:
        'Bitte füllen Sie den Text für alle Risikohinweise aus.',
    sm_risk_disclaimers_saved_success:
        'Risikohinweise erfolgreich gespeichert.',
    sm_risk_disclaimers_saved_error:
        'Fehler beim Speichern der Risikohinweise.',
    upload_asset_secondary_market_import: 'SM - Bezughsrechte importieren',
    export_asset_secondary_market_pre_emptive_rights:
        'SM - Bezugsrechte exportieren',
    loading_preview: 'Vorschau wird geladen',
    all_rows_valid: 'Alle Zeilen sind gültig',
    invalid: 'Ungültig',
    sm_required_base_data_fields: 'Plicht Stammdaten-Felder für Investition',
    sm_buyer_signature_position: 'Position der Unterschrift des Käufers',
    sm_seller_signature_position: 'Position der Unterschrift des Verkäufers',
}
